import React from "react";
import "./icon.css";

function CreateDayIcon(props) {
  return (
    // <?xml version="1.0" encoding="UTF-8"?>
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.66 127.66"
    >
      <g id="Creative">
        <path
          className="main"
          d="m127.66,63.83c0,8.1-9.43,14.28-12.35,21.32-3.03,7.31-.84,18.31-6.35,23.81-5.51,5.51-16.51,3.32-23.81,6.35-7.05,2.92-13.22,12.35-21.32,12.35s-14.28-9.43-21.32-12.35c-7.31-3.03-18.31-.84-23.81-6.35-5.51-5.51-3.32-16.51-6.35-23.81-2.92-7.05-12.35-13.22-12.35-21.32s9.43-14.28,12.35-21.32c3.03-7.31.84-18.31,6.35-23.81,5.51-5.51,16.51-3.32,23.81-6.35,7.05-2.92,13.22-12.35,21.32-12.35s14.28,9.43,21.32,12.35c7.31,3.03,18.31.84,23.81,6.35,5.51,5.51,3.32,16.51,6.35,23.81,2.92,7.05,12.35,13.22,12.35,21.32Z"
        />
        <circle className="accent" cx="63.83" cy="63.83" r="27.13" />
        <path
          className="accent"
          d="m63.83,16.05c-2.22,0-4.56,6.23-5.84,10.28-.53,1.69.73,3.4,2.5,3.4h6.7c1.77,0,3.03-1.72,2.5-3.4-1.28-4.05-3.62-10.28-5.84-10.28Z"
        />
        <path
          className="accent"
          d="m30.04,30.04c-1.57,1.57,1.18,7.63,3.13,11.4.81,1.57,2.92,1.89,4.17.64l4.73-4.73c1.25-1.25.93-3.36-.64-4.17-3.77-1.96-9.83-4.71-11.4-3.13Z"
        />
        <path
          className="accent"
          d="m16.05,63.83c0,2.22,6.23,4.56,10.28,5.84,1.69.53,3.4-.73,3.4-2.5v-6.7c0-1.77-1.72-3.03-3.4-2.5-4.05,1.28-10.28,3.62-10.28,5.84Z"
        />
        <path
          className="accent"
          d="m30.04,97.62c1.57,1.57,7.63-1.18,11.4-3.13,1.57-.81,1.89-2.92.64-4.17l-4.73-4.73c-1.25-1.25-3.36-.93-4.17.64-1.96,3.77-4.71,9.83-3.13,11.4Z"
        />
        <path
          className="accent"
          d="m63.83,111.62c2.22,0,4.56-6.23,5.84-10.28.53-1.69-.73-3.4-2.5-3.4h-6.7c-1.77,0-3.03,1.72-2.5,3.4,1.28,4.05,3.62,10.28,5.84,10.28Z"
        />
        <path
          className="accent"
          d="m111.62,63.83c0-2.22-6.23-4.56-10.28-5.84-1.69-.53-3.4.73-3.4,2.5v6.7c0,1.77,1.72,3.03,3.4,2.5,4.05-1.28,10.28-3.62,10.28-5.84Z"
        />
        <path
          className="accent"
          d="m97.62,30.04c-1.57-1.57-7.63,1.18-11.4,3.13-1.57.81-1.89,2.92-.64,4.17l4.73,4.73c1.25,1.25,3.36.93,4.17-.64,1.96-3.77,4.71-9.83,3.13-11.4Z"
        />
        <circle className="main" cx="91.34" cy="90.96" r="19.65" />
        <circle className="accent" cx="91.34" cy="90.96" r="16.38" />
        <circle className="main" cx="91.34" cy="90.96" r="13.65" />
        <g>
          <rect
            className="accent"
            x="89.16"
            y="82.21"
            width="4.37"
            height="17.5"
          />
          <rect
            className="accent"
            x="89.16"
            y="82.21"
            width="4.37"
            height="17.5"
            transform="translate(182.3 -.38) rotate(90)"
          />
        </g>
      </g>
    </svg>
  );
}

function CreateDayIconV2(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.48 127.48"
      style={{ opacity: props.opacity }}
    >
      <g id="Layer_2-2">
        <g id="Creative">
          <path
            className="main"
            d="m102.01,47.89c-2.4-5.78,3.74-17.44-.62-21.8s-16.01,1.78-21.8-.62c-5.58-2.31-9.43-14.97-15.85-14.97s-10.27,12.66-15.85,14.97c-5.78,2.4-17.44-3.74-21.8.62-4.36,4.36,1.78,16.01-.62,21.8-2.31,5.58-14.97,9.43-14.97,15.85s12.66,10.27,14.97,15.85c2.4,5.78-3.74,17.44.62,21.8s16.01-1.78,21.8.62c5.58,2.31,9.43,14.97,15.85,14.97s10.27-12.66,15.85-14.97c5.78-2.4,17.44,3.74,21.8-.62s-1.78-16.01.62-21.8c2.31-5.58,14.97-9.43,14.97-15.85s-12.66-10.27-14.97-15.85Z"
          />
          <path
            className="main"
            d="m102.01,47.89c-2.4-5.78,3.74-17.44-.62-21.8s-16.01,1.78-21.8-.62c-5.58-2.31-9.43-14.97-15.85-14.97s-10.27,12.66-15.85,14.97c-5.78,2.4-17.44-3.74-21.8.62-4.36,4.36,1.78,16.01-.62,21.8-2.31,5.58-14.97,9.43-14.97,15.85s12.66,10.27,14.97,15.85c2.4,5.78-3.74,17.44.62,21.8s16.01-1.78,21.8.62c5.58,2.31,9.43,14.97,15.85,14.97s10.27-12.66,15.85-14.97c5.78-2.4,17.44,3.74,21.8-.62s-1.78-16.01.62-21.8c2.31-5.58,14.97-9.43,14.97-15.85s-12.66-10.27-14.97-15.85Z"
          />
          <path
            className="main"
            d="m63.74,127.48c-9.05,0-14.27-7.42-17.72-12.34-.47-.67-1.07-1.52-1.62-2.26-.44-.59-1.16-.89-1.88-.79-1,.13-2.12.33-3.01.48-5.81.99-14.6,2.48-20.84-3.76-6.24-6.24-4.75-15.02-3.76-20.84.15-.89.34-2.01.48-3.01.1-.73-.2-1.45-.79-1.88-.74-.56-1.59-1.15-2.26-1.62-4.91-3.45-12.34-8.67-12.34-17.72s7.42-14.27,12.34-17.72c.67-.47,1.52-1.07,2.26-1.62.59-.44.89-1.16.79-1.88-.13-1-.33-2.12-.48-3.01-.99-5.81-2.48-14.6,3.76-20.84s15.02-4.75,20.84-3.76c.89.15,2.01.34,3.01.48.73.1,1.45-.2,1.88-.79.56-.74,1.15-1.59,1.62-2.26C49.47,7.42,54.69,0,63.74,0s14.27,7.42,17.72,12.34c.47.67,1.07,1.52,1.62,2.26.44.59,1.16.89,1.88.79,1-.13,2.12-.33,3.01-.48,5.81-.99,14.6-2.48,20.84,3.76s4.74,15.02,3.76,20.84c-.15.89-.34,2.01-.48,3.01-.1.73.2,1.45.79,1.88.74.56,1.59,1.15,2.26,1.62,4.91,3.45,12.34,8.67,12.34,17.72s-7.42,14.27-12.34,17.72c-.67.47-1.52,1.07-2.26,1.62-.59.44-.89,1.16-.79,1.88.13,1,.33,2.12.48,3.01.99,5.81,2.48,14.6-3.76,20.84-6.24,6.24-15.02,4.74-20.84,3.76-.89-.15-2.01-.34-3.01-.48-.73-.1-1.45.2-1.88.79-.56.74-1.15,1.59-1.62,2.26-3.45,4.91-8.67,12.34-17.72,12.34Zm-19.32-36.55c2.49,0,5.01.35,7.5,1.38,5.27,2.19,8.47,6.74,11.29,10.76.17.24.34.49.53.76.19-.26.37-.52.53-.76,2.82-4.02,6.02-8.58,11.3-10.76,5.39-2.24,10.99-1.28,15.93-.45.14.02.29.05.45.08-.03-.15-.05-.3-.08-.45-.84-4.94-1.79-10.53.45-15.93,2.19-5.27,6.74-8.47,10.76-11.3.24-.17.49-.34.76-.53-.26-.19-.52-.37-.76-.53-4.02-2.82-8.58-6.02-10.76-11.3h0c-2.24-5.39-1.28-10.99-.45-15.93.02-.14.05-.29.08-.45-.15.03-.3.05-.45.08-4.94.84-10.54,1.79-15.93-.45-5.27-2.19-8.47-6.74-11.29-10.76-.17-.24-.34-.49-.53-.76-.19.26-.37.52-.53.76-2.82,4.02-6.02,8.58-11.3,10.76-5.39,2.24-10.99,1.28-15.93.45-.14-.02-.29-.05-.45-.08.03.15.05.3.08.45.84,4.94,1.79,10.53-.45,15.93-2.19,5.27-6.74,8.47-10.76,11.3-.24.17-.49.34-.76.53.26.19.52.37.76.53,4.02,2.82,8.58,6.02,10.76,11.3,2.24,5.39,1.28,10.99.45,15.93-.02.14-.05.29-.08.45.15-.03.3-.05.45-.08,2.66-.45,5.52-.94,8.43-.94h0Zm62.82-24.48h.01-.01Z"
          />
          <path
            className="accent"
            d="m63.74,16.63c1.14.81,3.04,3.51,4.21,5.19,2.59,3.69,5.27,7.51,9.34,9.19,1.68.7,3.57,1.03,5.79,1.03,2.55,0,5.14-.44,7.66-.87,2.01-.34,4.1-.7,5.61-.7.26,0,.47.01.64.03.13,1.43-.37,4.37-.69,6.23-.77,4.55-1.57,9.26.17,13.45,1.69,4.06,5.5,6.74,9.19,9.34,1.68,1.18,4.38,3.08,5.19,4.21-.81,1.14-3.51,3.04-5.19,4.21-3.69,2.59-7.51,5.27-9.19,9.34-1.74,4.19-.94,8.9-.17,13.45.32,1.86.82,4.81.69,6.23-.16.01-.37.02-.64.02-1.52,0-3.6-.35-5.61-.7-2.51-.43-5.11-.87-7.66-.87-2.22,0-4.11.34-5.79,1.03-4.06,1.69-6.74,5.5-9.34,9.19-1.18,1.68-3.08,4.38-4.21,5.19-1.14-.81-3.04-3.51-4.21-5.19-2.59-3.69-5.27-7.51-9.34-9.19-1.68-.7-3.57-1.03-5.79-1.03-2.55,0-5.14.44-7.66.87-2.01.34-4.1.7-5.61.7-.26,0-.47-.01-.64-.03-.13-1.43.37-4.37.69-6.23.77-4.55,1.57-9.25-.17-13.45-1.69-4.06-5.5-6.74-9.19-9.34-1.68-1.18-4.38-3.08-5.19-4.21.81-1.14,3.51-3.04,5.19-4.21,3.69-2.59,7.51-5.27,9.19-9.34,1.74-4.19.94-8.9.17-13.45-.32-1.86-.82-4.81-.69-6.23.16-.01.37-.03.64-.03,1.52,0,3.6.35,5.61.7,2.51.43,5.11.87,7.66.87,2.22,0,4.11-.34,5.79-1.03,4.06-1.69,6.74-5.5,9.34-9.19,1.18-1.68,3.08-4.38,4.21-5.19h0Zm0-6.13c-6.42,0-10.27,12.66-15.85,14.97-1.01.42-2.2.58-3.49.58-4.07,0-9.22-1.57-13.27-1.57-2.05,0-3.82.4-5.03,1.61-4.36,4.36,1.78,16.01-.62,21.8-2.31,5.58-14.97,9.43-14.97,15.85s12.66,10.27,14.97,15.85c2.4,5.78-3.74,17.44.62,21.8,1.21,1.21,2.98,1.61,5.03,1.61,4.05,0,9.2-1.57,13.27-1.57,1.3,0,2.48.16,3.49.58,5.58,2.31,9.43,14.97,15.85,14.97s10.27-12.66,15.85-14.97c1.01-.42,2.2-.58,3.49-.58,4.07,0,9.22,1.57,13.27,1.57,2.05,0,3.82-.4,5.03-1.61,4.36-4.36-1.78-16.01.62-21.8,2.31-5.58,14.97-9.43,14.97-15.85s-12.66-10.27-14.97-15.85c-2.4-5.78,3.74-17.44-.62-21.8-1.21-1.21-2.98-1.61-5.03-1.61-4.05,0-9.2,1.57-13.27,1.57-1.3,0-2.48-.16-3.49-.58-5.58-2.31-9.43-14.97-15.85-14.97h0Z"
          />
          <path
            className="accent"
            d="m63.74,45.28c10.18,0,18.46,8.28,18.46,18.46s-8.28,18.46-18.46,18.46-18.46-8.28-18.46-18.46,8.28-18.46,18.46-18.46"
          />
          <path
            className="accent"
            d="m63.74,39.28c-13.51,0-24.46,10.95-24.46,24.46s10.95,24.46,24.46,24.46,24.46-10.95,24.46-24.46-10.95-24.46-24.46-24.46h0Z"
          />
        </g>
      </g>
    </svg>
  );
}

function NameIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 127.41"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m125.24,97.38l-59,29.5c-1.41.7-3.06.7-4.47,0L2.76,97.38c-1.69-.85-2.76-2.58-2.76-4.47V5C0,2.24,2.24,0,5,0h118c2.76,0,5,2.24,5,5v87.91c0,1.89-1.07,3.63-2.76,4.47Z"
        />
        <g>
          <path
            className="accent"
            d="m85.71,107.68l-19.63,9.5c-1.31.63-2.83.63-4.14,0l-19.63-9.49c5.98-2.32,13.52-4.28,21.7-4.28s15.73,1.96,21.7,4.28Z"
          />
          <g>
            <path
              className="accent"
              d="m81.79,11.24v77.08c0,.64-.61,1.1-1.22.91-4.14-1.3-10.03-2.11-16.56-2.11s-12.42.81-16.56,2.11c-.61.19-1.22-.27-1.22-.91V11.24c0-.53.43-.95.95-.95h33.67c.53,0,.95.43.95.95Z"
            />
            <path
              className="accent"
              d="m41.09,11.24v77.02c0,.66-.65,1.11-1.27.89-3.52-1.25-8.44-2.03-13.9-2.03s-10.38.78-13.9,2.03c-.62.22-1.27-.24-1.27-.89V11.24c0-.53.43-.95.95-.95h28.43c.53,0,.95.43.95.95Z"
            />
            <path
              className="accent"
              d="m117.24,11.24v77.02c0,.66-.65,1.11-1.27.89-3.52-1.25-8.46-2.03-13.92-2.03s-10.4.78-13.92,2.03c-.62.22-1.26-.24-1.26-.89V11.24c0-.53.43-.95.95-.95h28.47c.53,0,.95.43.95.95Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

function NameIconV2(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 127.41"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m125.24,97.38l-59,29.5c-1.41.7-3.06.7-4.47,0L2.76,97.38c-1.69-.85-2.76-2.58-2.76-4.47V5C0,2.24,2.24,0,5,0h118c2.76,0,5,2.24,5,5v87.91c0,1.89-1.07,3.63-2.76,4.47Z"
        />
        <path
          className="accent"
          d="m85.71,107.68l-19.63,9.5c-1.31.63-2.83.63-4.14,0l-19.63-9.49c5.98-2.32,13.52-4.28,21.7-4.28s15.73,1.96,21.7,4.28Z"
        />
        <g>
          <path
            className="accent"
            d="m80.84,10.29h-33.67c-.53,0-.95.43-.95.95v77.08c0,.54.44.95.94.95.09,0,.19-.01.28-.04,4.14-1.29,10.03-2.11,16.56-2.11s12.42.81,16.56,2.11c.1.03.19.04.28.04.5,0,.94-.41.94-.95V11.24c0-.53-.43-.95-.95-.95Zm-5.05,71.71c-3.61-.58-7.62-.88-11.78-.88s-8.18.31-11.78.88V16.29h23.57v65.71Z"
          />
          <path
            className="accent"
            d="m40.14,10.29H11.72c-.53,0-.95.43-.95.95v77.01c0,.54.44.95.94.95.11,0,.21-.02.32-.06,3.52-1.25,8.44-2.03,13.9-2.03s10.38.78,13.9,2.03c.11.04.22.06.32.06.5,0,.94-.41.94-.95V11.24c0-.53-.43-.95-.95-.95Zm-5.05,71.54c-2.86-.46-5.97-.71-9.16-.71s-6.3.24-9.16.71V16.29h18.33v65.54Z"
          />
          <path
            className="accent"
            d="m116.29,10.29h-28.47c-.53,0-.95.43-.95.95v77.01c0,.54.44.95.94.95.11,0,.21-.02.32-.06,3.52-1.25,8.46-2.03,13.92-2.03s10.4.78,13.92,2.03c.11.04.22.06.32.06.5,0,.94-.41.94-.95V11.24c0-.53-.43-.95-.95-.95Zm-5.05,71.54c-2.87-.46-5.98-.71-9.19-.71s-6.32.24-9.19.71V16.29h18.38v65.54Z"
          />
        </g>
      </g>
    </svg>
  );
}

function NameIconV3(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 127.57"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m123,0H5C2.24,0,0,2.23,0,5v83.9c0,1.9,1.07,3.63,2.77,4.48l53.05,31.93c4.98,3.01,11.22,3.01,16.22.01l53.2-31.94c1.69-.85,2.76-2.58,2.76-4.48V5c0-2.77-2.24-5-5-5Z"
        />
        <path
          className="accent"
          d="m78.43,97.55l-14.42,8.42-14.43-8.41c4.03-1.37,8.23-2.29,14.4-2.29s10.4.91,14.45,2.28Z"
        />
        <g>
          <path
            className="accent"
            d="m48.48,86.53c-.21.1-.41.17-.63.22.35-.06.7-.19,1.01-.39-.24.1-.37.17-.38.17Zm1.73-69.87v62.75s.04-.01.06-.02V16.66h-.06Z"
          />
          <g>
            <path
              className="accent"
              d="m44.21,16.66v62.73s.04,0,.06.02V16.66h-.06Zm1.79,69.87s-.14-.07-.38-.17c.31.2.65.33,1,.39-.21-.05-.42-.12-.62-.22Z"
            />
            <path
              className="accent"
              d="m114.4,10.66H13.67c-1.65,0-3,1.35-3,3v70.16c0,.11.01.23.02.35.02.11.04.22.07.34.03.14.07.28.12.4.05.14.11.26.18.38.07.12.14.23.22.33.08.12.17.22.27.32.01.01.02.02.03.02.08.09.17.16.26.23.09.07.19.14.29.2.01,0,.03.02.05.03l48.38,28.92c2.12,1.34,4.83,1.35,6.95,0l48.04-28.77c.16-.06.31-.14.46-.23.86-.55,1.39-1.51,1.39-2.53V13.66c0-1.65-1.34-3-3-3Zm-64.19,6h27.59v62.75c-3.48-1.2-8.64-2.59-13.8-2.59s-10.25,1.37-13.73,2.57c-.02,0-.04,0-.06.02V16.66Zm-33.54,0h27.6v62.75s-.04-.01-.06-.02c-3.48-1.2-8.61-2.57-13.74-2.57s-10.32,1.39-13.8,2.59V16.66Zm67.54,80.99l-2.12,1.24-17.92,10.46-.16.09-.17-.1-17.9-10.44-2.3-1.34-22.9-13.14c2.82-.84,6.32-1.6,9.73-1.6,3.74,0,7.6.92,10.54,1.84,2.19.69,3.86,1.38,4.59,1.69,0,0,0,0,.02,0,.24.1.37.17.38.17.2.1.41.17.62.22.11.02.22.04.33.05.19.02.39.02.58,0,.11-.01.21-.03.32-.05.22-.05.42-.12.63-.22.01,0,.14-.07.38-.17.01,0,.02,0,.02,0,1.71-.73,8.6-3.53,15.12-3.53,3.74,0,7.6.92,10.54,1.84,2.57.81,4.43,1.62,4.88,1.82.02.01.05.03.08.04.04.02.09.04.14.06.1.05.2.08.3.11.02.01.04.01.06.02.01,0,.03.01.04.01.09.03.17.04.26.05.05.01.09.02.13.02s.08,0,.12.01c.04,0,.08,0,.12,0,.09.01.17.01.26,0,.04,0,.08,0,.12,0,.04-.01.08-.01.12-.01s.08,0,.13-.02c.1,0,.2-.03.3-.06.02,0,.04,0,.06-.02.1-.03.2-.06.3-.11.04-.02.07-.03.11-.05,0,0,.01-.01.03-.01.55-.25,8.25-3.7,15.5-3.7,3.39,0,6.88.76,9.69,1.59l-23.08,13.24Zm27.19-18.24c-3.48-1.2-8.64-2.59-13.8-2.59s-10.32,1.39-13.8,2.59V16.66h27.6v62.75Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

function NameIconV4(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 127.41"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m125.24,97.38l-59,29.5c-1.41.7-3.06.7-4.47,0L2.76,97.38c-1.69-.85-2.76-2.58-2.76-4.47V5C0,2.24,2.24,0,5,0h118c2.76,0,5,2.24,5,5v87.91c0,1.89-1.07,3.63-2.76,4.47Z"
        />
        <path
          className="accent"
          d="m85.71,107.68l-19.63,9.5c-1.31.63-2.83.63-4.14,0l-19.63-9.49c5.98-2.32,13.52-4.28,21.7-4.28s15.73,1.96,21.7,4.28Z"
        />
        <path
          className="accent"
          d="m47.32,88.19c-.44,0-.89-.1-1.3-.29h0c-.08-.04-8.04-3.8-15.5-3.8s-15.42,3.76-15.5,3.8c-.93.44-2.02.38-2.9-.17-.87-.55-1.4-1.51-1.4-2.54V13.35c0-1.66,1.34-3,3-3h33.6c1.66,0,3,1.34,3,3v71.84c0,1.03-.53,1.99-1.4,2.54-.49.31-1.04.46-1.6.46Zm-16.8-10.1c5.15,0,10.31,1.43,13.8,2.66V16.35h-27.6v64.4c3.49-1.23,8.64-2.66,13.8-2.66Z"
        />
        <path
          className="accent"
          d="m80.85,88.19c-.44,0-.89-.1-1.3-.29h0c-.08-.04-8.04-3.8-15.5-3.8s-15.42,3.76-15.5,3.8c-.93.44-2.02.38-2.9-.17-.87-.55-1.4-1.51-1.4-2.54V13.35c0-1.66,1.34-3,3-3h33.6c1.66,0,3,1.34,3,3v71.84c0,1.03-.53,1.99-1.4,2.54-.49.31-1.04.46-1.6.46Zm-16.8-10.1c5.15,0,10.31,1.43,13.8,2.66V16.35h-27.6v64.4c3.49-1.23,8.64-2.66,13.8-2.66Z"
        />
        <path
          className="accent"
          d="m114.45,88.19c-.44,0-.89-.1-1.3-.3-.15-.07-8.07-3.8-15.5-3.8s-15.42,3.76-15.5,3.8c-.93.44-2.02.38-2.9-.17-.87-.55-1.4-1.51-1.4-2.54V13.35c0-1.66,1.34-3,3-3h33.6c1.66,0,3,1.34,3,3v71.84c0,1.03-.53,1.99-1.4,2.54-.49.31-1.04.46-1.6.46Zm-30.6-71.84v64.4c3.49-1.23,8.64-2.66,13.8-2.66s10.31,1.43,13.8,2.66V16.35h-27.6Z"
        />
      </g>
    </svg>
  );
}

function DobIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.3 127.33"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m127.3,35.46v-7.24c0-11.09-8.41-20.25-19.19-21.44-2.14-4.03-6.37-6.77-11.24-6.77h-8.86c-4.81,0-9.01,2.69-11.17,6.64h-26.38c-2.16-3.95-6.36-6.64-11.17-6.64h-8.86c-4.87,0-9.1,2.75-11.24,6.77C8.41,7.96,0,17.12,0,28.22v21.6h0v55.94C0,117.65,9.68,127.33,21.58,127.33h84.15c11.9,0,21.57-9.68,21.57-21.57V35.46h0Z"
        />
        <g>
          <g>
            <path
              className="accent"
              d="m10.5,45.96v59.79c0,6.11,4.96,11.07,11.07,11.07h84.15c6.11,0,11.07-4.96,11.07-11.07v-59.79H10.5Z"
            />
            <path
              className="accent"
              d="m116.8,28.22c0-6.12-4.96-11.07-11.07-11.07h-6.64v-4.43c0-1.22-.99-2.21-2.22-2.21h-8.86c-1.22,0-2.22.99-2.22,2.21v4.43h-44.29v-4.43c0-1.22-.99-2.21-2.22-2.21h-8.86c-1.22,0-2.22.99-2.22,2.21v4.43h-6.64c-6.12,0-11.07,4.96-11.07,11.07v11.1h106.3v-11.1Z"
            />
          </g>
          <g>
            <rect
              className="main"
              x="22.83"
              y="77.22"
              width="13.25"
              height="11.25"
            />
            <rect
              className="main"
              x="45.62"
              y="77.22"
              width="13.26"
              height="11.25"
            />
            <rect
              className="main"
              x="91.22"
              y="58.42"
              width="13.26"
              height="11.26"
            />
            <rect
              className="main"
              x="22.83"
              y="58.42"
              width="13.25"
              height="11.26"
            />
            <rect
              className="main"
              x="45.62"
              y="58.42"
              width="13.26"
              height="11.26"
            />
            <rect
              className="main"
              x="68.41"
              y="58.42"
              width="13.28"
              height="11.26"
            />
            <rect
              className="main"
              x="68.41"
              y="77.22"
              width="13.28"
              height="11.25"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

function ValuesIcon(props) {
  return (
    <svg
      id="Layer_2"
      className={`jordan`}
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.95 116.26"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m106.43,33.62c2.8-19.94-5.3-27.91-10.47-30.89-5.06-2.92-13.57-4.96-25.41,1.87-2.16,1.24-4.36,2.76-6.58,4.5C48.1-3.29,37.16-.27,31.98,2.72c-6.35,3.67-13.2,12-10.47,30.91-2.54,1.03-4.89,2.14-7,3.36C1.88,44.28,0,53.37,0,58.13c0,5.97,2.85,16.97,21.52,24.51-2.8,19.94,5.3,27.91,10.47,30.89,5.06,2.92,13.57,4.96,25.41-1.87,2.16-1.25,4.36-2.76,6.58-4.5,15.87,12.39,26.82,9.37,31.99,6.38,6.36-3.67,13.21-12,10.48-30.91,2.54-1.03,4.89-2.14,7-3.36,12.63-7.29,14.51-16.38,14.51-21.14,0-5.97-2.85-16.97-21.52-24.51Z"
        />
        <g>
          <path
            className="accent"
            d="m101.83,41.4c-.9-.34-1.83-.67-2.78-.98h-.02c-.22.91-.47,1.83-.73,2.76t-.01.02c-.28.98-.58,1.97-.9,2.95h.01c9.83,3.25,15.63,7.75,15.62,11.98,0,.94-.28,1.88-.82,2.82-2.16,3.73-8.43,7.41-17.66,10.04-1.83.52-3.77.99-5.82,1.43.65,1.99,1.21,3.91,1.67,5.76,2.93,11.65,2.12,20.12-1.9,22.43-3.66,2.12-10.45-.65-18.19-7.54,0,0-.01,0-.01-.01-1.07,1.19-2.15,2.32-3.23,3.41-.3.29-.59.58-.89.88.75.68,1.49,1.32,2.24,1.93,9.18,7.51,17.37,9.82,23.08,6.53,5.72-3.3,7.81-11.56,5.9-23.25-.31-1.89-.72-3.84-1.22-5.84,1.98-.57,3.87-1.18,5.66-1.86,11.08-4.19,17.19-10.13,17.19-16.73s-6.1-12.54-17.19-16.73Z"
          />
          <path
            className="accent"
            d="m75.39,41.92c.54.04,1.07.09,1.6.15.45.04.9.09,1.34.14.11,0,.22,0,.33.03.28.03.56.06.83.1.27.03.54.07.82.11.4.05.81.1,1.21.15.4.05.8.11,1.2.17,1.03.15,2.04.32,3.04.5.69-2.04,1.25-3.97,1.71-5.77h.01c-.72-.14-1.45-.27-2.18-.39-.56-.09-1.11-.18-1.67-.26-1.68-.26-3.39-.48-5.14-.66-.58-.06-1.16-.12-1.75-.17-.63-.06-1.28-.11-1.92-.17-.65-.06-1.3-.1-1.95-.14-2.92-.2-5.89-.29-8.9-.29-1.17,0-2.34.02-3.5.06-.48,0-.96.01-1.44.03h-.01c-1.25.05-2.49.11-3.72.19-1.14.07-2.26.16-3.38.25-.24.02-.48.04-.72.06-.32.03-.64.06-.95.1-3.37.33-6.64.79-9.77,1.38.01,0,.01.01.01.02.45,1.79,1.01,3.71,1.69,5.74,0,0,.01.02.01.03,5.74-1.03,11.98-1.63,18.47-1.8h.07c.13,0,.25,0,.37,0,.01,0,.03,0,.04,0h.06c.92-.02,1.84-.03,2.77-.03,3.27.01,6.43.11,9.45.33.66.04,1.32.09,1.97.15Z"
          />
          <path
            className="accent"
            d="m68.11,91.02l.02-.02c.05-.05.1-.11.14-.16.36-.4.72-.81,1.08-1.22.25-.27.49-.56.73-.84.86-1,1.71-2.02,2.55-3.08.33-.42.66-.84.99-1.27.71-.9,1.4-1.83,2.08-2.77.34-.46.67-.92.99-1.38.77-1.07,1.52-2.15,2.24-3.26.35-.53.7-1.07,1.06-1.61.01,0,.02-.02.02-.04.35-.56.7-1.12,1.05-1.68h.01c.41-.65.82-1.31,1.22-1.97.45-.74.89-1.49,1.33-2.25.83-1.44,1.63-2.88,2.39-4.32h0c.16-.3.31-.6.46-.89.36-.68.71-1.36,1.05-2.04s.67-1.36,1-2.04c.34-.69.66-1.37.98-2.06.62-1.35,1.21-2.7,1.76-4.03.26-.63.52-1.26.77-1.89.06-.13.11-.26.16-.39.22-.58.44-1.16.66-1.73.26-.66.5-1.32.73-1.98.34-.95.66-1.89.96-2.83.62-1.95,1.17-3.86,1.64-5.73.24-.99.47-1.97.66-2.93h.01c.2-.99.38-1.96.54-2.91,1.91-11.7-.18-19.95-5.89-23.25-5.71-3.3-13.91-.98-23.08,6.52-1.48,1.21-2.97,2.54-4.45,3.97-1.48-1.43-2.96-2.76-4.44-3.97-9.17-7.5-17.37-9.82-23.08-6.52-5.71,3.3-7.81,11.55-5.9,23.25.16.95.33,1.91.54,2.89v.02c.2.96.42,1.93.67,2.91t.01.02c.11.46.23.93.36,1.4.25.96.53,1.92.83,2.9.14.47.28.94.44,1.41.3.94.62,1.88.95,2.83.19.54.39,1.08.6,1.63.37,1,.76,1.99,1.16,3,.2.5.41,1,.62,1.51.43,1.03.88,2.07,1.35,3.1.12.27.24.53.36.8.1.22.2.43.31.65.23.51.47,1.02.72,1.53.49,1.04,1.01,2.08,1.54,3.11.67,1.3,1.36,2.6,2.09,3.9.4.72.81,1.44,1.22,2.16.59,1.02,1.18,2.02,1.79,3.01.25.41.5.82.76,1.22h.01c.26.43.52.84.78,1.25.44.71.89,1.4,1.35,2.09.6.89,1.19,1.76,1.79,2.61.64.92,1.29,1.82,1.95,2.71.33.44.66.88.99,1.32.33.43.66.86.99,1.29,1.02,1.31,2.06,2.58,3.11,3.8,1.33-1.29,2.71-2.74,4.13-4.35t.03-.02c-1.88-2.22-3.73-4.6-5.53-7.11-.6-.83-1.19-1.68-1.78-2.56-.3-.44-.59-.88-.89-1.33-.88-1.33-1.75-2.7-2.6-4.1-.28-.47-.57-.93-.85-1.41-.28-.47-.55-.94-.83-1.42-.41-.71-.81-1.41-1.2-2.11-.39-.71-.77-1.41-1.14-2.1,0-.03-.03-.06-.05-.09-.35-.67-.69-1.33-1.03-1.99-.35-.69-.69-1.38-1.02-2.06-.24-.49-.47-.98-.7-1.46-.77-1.63-1.49-3.23-2.14-4.8-.16-.36-.31-.73-.45-1.09-.39-.94-.76-1.87-1.1-2.79-.16-.44-.32-.88-.47-1.31h-.02c-.35-.97-.68-1.92-.98-2.85-.65-1.98-1.21-3.89-1.66-5.72-.01,0-.01-.02-.01-.03-.25-.99-.47-1.96-.66-2.9,0-.01,0-.02,0-.02-2.1-10.14-1.11-17.39,2.56-19.5.81-.47,1.77-.7,2.85-.7,4.31,0,10.63,3.59,17.52,10.27,1.37,1.32,2.75,2.77,4.15,4.33,1.4-1.56,2.78-3.01,4.15-4.33,8.63-8.36,16.37-11.89,20.38-9.57,3.66,2.11,4.65,9.37,2.56,19.5v.02c-.2.94-.42,1.91-.67,2.91-.46,1.85-1.02,3.78-1.67,5.77-.01,0-.02,0-.03,0-.31.94-.63,1.89-.98,2.85-1.85,5.12-4.24,10.45-7.08,15.78-.22.42-.45.84-.67,1.26-.23.43-.47.87-.72,1.3-.27.47-.54.95-.82,1.43-.12.2-.24.4-.35.6-.03.07-.08.14-.12.21-.64,1.11-1.3,2.2-1.99,3.27-.16.27-.33.54-.51.81-.17.27-.34.54-.52.81-.17.28-.36.57-.55.85-.31.49-.64.98-.97,1.47-.73,1.1-1.48,2.17-2.24,3.21-.37.52-.74,1.03-1.13,1.54-.49.67-1,1.34-1.51,1.99-.43.55-.87,1.1-1.3,1.64-.44.53-.87,1.05-1.3,1.56h.01c-.67.79-1.32,1.55-1.98,2.28-1.39,1.56-2.78,3-4.14,4.31h-.01c-.74.73-1.47,1.41-2.19,2.05-7.73,6.88-14.52,9.65-18.18,7.53-.81-.47-1.49-1.19-2.03-2.12-2.15-3.73-2.2-11,.14-20.31.45-1.85,1.02-3.77,1.67-5.76-2.05-.43-4-.9-5.82-1.43-11.56-3.29-18.49-8.23-18.48-12.86-.01-4.23,5.79-8.72,15.62-11.97h0c-.5-1.54-.94-3.04-1.33-4.51-.06-.21-.11-.41-.16-.62-.05-.2-.1-.4-.15-.61h-.01c-.95.31-1.89.64-2.79.98-11.08,4.2-17.18,10.13-17.19,16.73,0,6.59,6.11,12.54,17.19,16.73,1.79.67,3.69,1.3,5.66,1.87-.49,1.99-.91,3.94-1.21,5.83-1.91,11.69.18,19.95,5.89,23.24,5.71,3.3,13.91.99,23.08-6.51.75-.61,1.49-1.25,2.24-1.92h.01c.73-.65,1.46-1.33,2.19-2.04h.01c.35-.33.69-.67,1.04-1.03.35-.34.69-.7,1.05-1.06.38-.39.76-.79,1.13-1.2.31-.33.62-.66.92-1Z"
          />
        </g>
      </g>
    </svg>
  );
}

function VisionIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 159.99 127.37"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m159.61,61.9c.51,1.12.51,2.45,0,3.56-17.05,37.3-46.33,61.91-79.61,61.91S17.41,102.76.38,65.47c-.51-1.12-.51-2.45,0-3.56C17.41,24.61,46.72,0,80,0s62.57,24.61,79.61,61.9Z"
        />
        <path
          className="accent"
          d="m146.75,62.19c.43.94.43,2.05,0,2.99-14.29,31.27-38.85,51.91-66.75,51.91S27.52,96.45,13.24,65.18c-.43-.94-.43-2.05,0-2.99C27.52,30.92,52.09,10.29,80,10.29s52.46,20.64,66.75,51.91Z"
        />
        <circle className="main" cx="79.99" cy="63.69" r="42.48" />
        <path
          className="accent"
          d="m79.99,93.96c-16.69,0-30.28-13.58-30.28-30.28s13.58-30.28,30.28-30.28,30.28,13.58,30.28,30.28-13.58,30.28-30.28,30.28Zm0-52.31c-12.15,0-22.03,9.88-22.03,22.03s9.88,22.03,22.03,22.03,22.03-9.88,22.03-22.03-9.88-22.03-22.03-22.03Z"
        />
        <circle className="accent" cx="91.38" cy="52.3" r="8.32" />
      </g>
    </svg>
  );
}

function IkigaiIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.8 127.8"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m11.39,11.4c.21-.04.42-.08.63-.11-.38.1-.67.4-.74.79.03-.23.07-.45.11-.68Z"
        />
        <path
          className="main"
          d="m63.9,74.57c1.67,0,3.32-.08,4.95-.22-1.63.15-3.28.23-4.95.23s-3.32-.08-4.95-.23c1.63.14,3.28.22,4.95.22Z"
        />
        <path
          className="main"
          d="m54.12,54.12c-.59,3.17-.9,6.43-.9,9.78s.31,6.61.9,9.78h-.01c-2.16-.4-4.26-.93-6.32-1.58-.38-2.7-.57-5.45-.57-8.2s.19-5.51.57-8.2c-.36.11-.72.23-1.08.35-.36.12-.72.25-1.08.38-.35.13-.71.26-1.06.4-.35.13-.7.27-1.05.42-.52.22-1.04.44-1.55.67-.52.23-1.03.47-1.54.72-.33.16-.67.33-1,.5-1.76.91-3.47,1.91-5.11,3.01-.4.27-.8.54-1.2.82-.43.31-.85.62-1.27.93-1.63-1.23-3.2-2.55-4.68-3.96.36-.29.72-.57,1.08-.84,6.17-4.63,13.25-8.04,20.69-9.97l.03-.15.16-.03c1.93-7.44,5.34-14.53,9.97-20.71.27-.36.55-.72.83-1.08,1.41,1.49,2.74,3.05,3.97,4.69-1.14,1.52-2.2,3.1-3.18,4.74-.17.29-.34.58-.5.87-.19.32-.37.65-.55.98-.17.33-.35.66-.52.99-.09.18-.19.36-.28.54-.16.32-.31.63-.46.95-.22.46-.44.92-.64,1.39-.18.4-.35.8-.52,1.21-.03.07-.06.13-.08.2-.19.45-.36.9-.53,1.35-.02.05-.04.1-.05.14-.18.46-.34.92-.5,1.39-.13.39-.26.79-.39,1.19,2.7-.38,5.45-.57,8.2-.57s5.51.19,8.2.57c.65,2.06,1.18,4.17,1.58,6.33-3.17-.59-6.43-.9-9.78-.9s-6.61.31-9.78.9Z"
        />
        <path
          className="main"
          d="m12.03,116.51c-.21-.03-.42-.07-.63-.11-.04-.23-.09-.47-.12-.7.07.4.36.72.75.81Z"
        />
        <path
          className="main"
          d="m73.68,73.68h0c-.19,1.04-.41,2.06-.66,3.07-.07.3-.14.59-.23.89-.01.03-.02.07-.03.1-.08.32-.17.65-.27.97-.12.43-.25.87-.39,1.3-.45.06-.91.12-1.37.17-2.26.27-4.54.4-6.83.4-2.75,0-5.49-.19-8.18-.57h-.02c.13.4.26.8.39,1.19.15.44.3.88.47,1.31.01.03.02.05.03.08.01.04.03.09.05.14.17.45.34.9.53,1.35.02.07.05.13.08.2.17.41.34.81.52,1.21.2.46.41.92.64,1.38.18.4.38.8.58,1.19.51,1,1.05,1.99,1.62,2.95.02.04.04.07.07.11.15.27.32.55.49.82.01.02.03.04.04.06.84,1.36,1.74,2.67,2.69,3.94h0c-1.23,1.64-2.55,3.21-3.95,4.69-.29-.36-.57-.72-.84-1.08-4.64-6.17-8.04-13.25-9.97-20.69l-.16-.03-.03-.16c-7.44-1.93-14.53-5.34-20.7-9.98-.36-.27-.72-.55-1.08-.84,1.48-1.4,3.05-2.72,4.68-3.95,4.76,3.57,10.14,6.37,15.94,8.2-.38-2.7-.57-5.45-.57-8.2s.19-5.51.57-8.2c.52-.16,1.03-.32,1.55-.46.53-.15,1.05-.29,1.58-.42.29-.08.59-.15.89-.21.76-.19,1.53-.35,2.31-.49-.59,3.17-.9,6.43-.9,9.78s.31,6.61.9,9.78c1.59.29,3.19.52,4.83.67,1.63.14,3.28.22,4.95.22s3.32-.08,4.95-.22c1.64-.15,3.24-.38,4.83-.67Z"
        />
        <path
          className="main"
          d="m74.73,106.73c.82.62,1.66,1.21,2.52,1.77-.86-.57-1.7-1.15-2.52-1.77Z"
        />
        <path
          className="main"
          d="m100.63,67.85c-.36.29-.72.57-1.08.84-6.17,4.64-13.25,8.04-20.69,9.97l-.03.16-.17.03c-1.92,7.44-5.33,14.53-9.96,20.7-.27.36-.55.72-.84,1.08-1.4-1.48-2.72-3.04-3.96-4.68h0c.56-.76,1.1-1.52,1.62-2.29.25-.37.49-.74.73-1.11.01-.03.03-.05.05-.08.24-.39.48-.78.72-1.17.15-.24.29-.48.43-.72.02-.04.05-.08.06-.12.33-.56.65-1.13.94-1.71.16-.31.32-.62.48-.93.16-.31.31-.63.46-.94.22-.45.43-.9.63-1.36,0,0,.01-.02.01-.03.14-.31.27-.62.4-.94.04-.08.07-.17.1-.25.07-.16.14-.32.2-.49.14-.32.27-.65.39-.98.36-.93.68-1.87.98-2.82-.45.06-.91.12-1.37.17-2.26.27-4.54.4-6.83.4-2.75,0-5.49-.19-8.18-.57h-.02s-.01-.03-.01-.05c-.16-.5-.31-1-.45-1.5-.15-.53-.29-1.05-.42-1.58-.08-.29-.15-.59-.21-.89-.19-.76-.35-1.53-.49-2.31,1.59.29,3.19.52,4.83.67,1.63.14,3.28.22,4.95.22s3.32-.08,4.95-.22c1.64-.15,3.24-.38,4.83-.67.59-3.17.9-6.44.9-9.78s-.31-6.61-.9-9.78h.01c1.03.19,2.05.41,3.06.66.3.07.59.14.89.23.03,0,.07.02.1.03.32.08.65.17.97.27.44.12.87.25,1.3.39.38,2.7.57,5.45.57,8.2s-.19,5.51-.57,8.2c.4-.13.8-.26,1.19-.39.47-.16.93-.32,1.39-.5.04,0,.09-.03.14-.05.45-.17.9-.34,1.35-.53.07-.02.13-.05.2-.08.41-.17.81-.34,1.21-.52.47-.2.93-.42,1.39-.64.32-.15.63-.3.95-.46.18-.09.36-.19.54-.28.33-.17.66-.35.99-.52.33-.18.66-.36.98-.55.29-.16.58-.33.87-.5,1.64-.98,3.22-2.04,4.74-3.18,1.63,1.23,3.2,2.55,4.68,3.95Z"
        />
        <path
          className="main"
          d="m116.51,115.78c-.03.21-.06.41-.1.62-.23.04-.47.09-.7.12.38-.07.7-.36.8-.74Z"
        />
        <path
          className="main"
          d="m111.42,63.9c10.51-11.62,16.38-26.64,16.38-42.72,0-3.95-.36-7.89-1.08-11.72l-1.07-5.73c-.15-.81-.79-1.45-1.6-1.6l-5.73-1.06c-3.83-.71-7.77-1.07-11.69-1.07-16.07,0-31.09,5.87-42.72,16.38C52.28,5.87,37.26,0,21.18,0,17.23,0,13.29.37,9.46,1.08l-5.73,1.07c-.81.15-1.45.79-1.6,1.6l-1.06,5.73c-.71,3.83-1.07,7.77-1.07,11.69,0,16.07,5.87,31.09,16.38,42.72C5.87,75.52,0,90.54,0,106.62c0,3.95.36,7.89,1.08,11.72l1.07,5.73c.15.81.79,1.45,1.6,1.6l5.73,1.06c3.83.71,7.77,1.07,11.69,1.07,16.07,0,31.09-5.87,42.72-16.38,11.62,10.51,26.64,16.38,42.72,16.38,3.95,0,7.89-.36,11.72-1.08l5.73-1.07c.81-.15,1.45-.79,1.6-1.6l1.06-5.73c.71-3.83,1.07-7.77,1.07-11.69,0-16.07-5.87-31.09-16.38-42.72Z"
        />
        <path
          className="main"
          d="m100.63,59.94c-1.48,1.41-3.05,2.73-4.68,3.96-1.52-1.14-3.1-2.2-4.74-3.18-.29-.17-.58-.34-.87-.5-.32-.19-.65-.37-.98-.55-.33-.17-.66-.35-.99-.52-.13-.06-.25-.13-.38-.2-.05-.03-.11-.05-.16-.08-.32-.16-.63-.31-.95-.46-.46-.22-.92-.44-1.39-.64-.4-.18-.8-.35-1.21-.52-.07-.03-.13-.06-.2-.08-.45-.19-.9-.36-1.35-.53-.05-.02-.1-.04-.14-.05-.03-.01-.05-.02-.08-.03-.43-.17-.87-.32-1.31-.47-.39-.13-.79-.26-1.19-.39.38,2.7.57,5.45.57,8.2s-.19,5.51-.57,8.2c-.02,0-.03,0-.05,0-.5.16-1,.31-1.5.45-.53.15-1.05.29-1.58.42-.29.08-.59.15-.89.21-.76.19-1.53.35-2.31.49.59-3.17.9-6.44.9-9.78s-.31-6.61-.9-9.78c-3.17-.59-6.43-.9-9.78-.9s-6.61.31-9.78.9h0c.19-1.04.41-2.06.66-3.07.08-.33.16-.66.26-.99.08-.32.17-.65.27-.97.12-.44.25-.87.39-1.3,2.7-.38,5.45-.57,8.2-.57s5.51.19,8.2.57c-1.83-5.8-4.63-11.18-8.2-15.94,1.23-1.63,2.54-3.19,3.95-4.67.3.36.57.71.84,1.07,4.64,6.16,8.04,13.24,9.97,20.69l.16.03.03.16c7.44,1.93,14.53,5.34,20.7,9.97.36.27.72.55,1.08.84Z"
        />
        <path
          className="main"
          d="m116.4,11.39c.04.23.09.47.12.7-.07-.42-.4-.75-.82-.82.23.03.47.08.7.12Z"
        />
        <path
          className="accent"
          d="m11.39,11.4c.21-.04.42-.08.63-.11-.38.1-.67.4-.74.79.03-.23.07-.45.11-.68Z"
        />
        <path
          className="accent"
          d="m63.9,74.57c1.67,0,3.32-.08,4.95-.22-1.63.15-3.28.23-4.95.23s-3.32-.08-4.95-.23c1.63.14,3.28.22,4.95.22Z"
        />
        <path
          className="accent"
          d="m54.12,54.12c-.59,3.17-.9,6.43-.9,9.78s.31,6.61.9,9.78h-.01c-2.16-.4-4.26-.93-6.32-1.58-.38-2.7-.57-5.45-.57-8.2s.19-5.51.57-8.2c-.36.11-.72.23-1.08.35-.36.12-.72.25-1.08.38-.35.13-.71.26-1.06.4-.35.13-.7.27-1.05.42-.52.22-1.04.44-1.55.67-.52.23-1.03.47-1.54.72-.33.16-.67.33-1,.5-1.76.91-3.47,1.91-5.11,3.01-.4.27-.8.54-1.2.82-.43.31-.85.62-1.27.93-1.63-1.23-3.2-2.55-4.68-3.96.36-.29.72-.57,1.08-.84,6.17-4.63,13.25-8.04,20.69-9.97l.03-.15.16-.03c1.93-7.44,5.34-14.53,9.97-20.71.27-.36.55-.72.83-1.08,1.41,1.49,2.74,3.05,3.97,4.69-1.14,1.52-2.2,3.1-3.18,4.74-.17.29-.34.58-.5.87-.19.32-.37.65-.55.98-.17.33-.35.66-.52.99-.09.18-.19.36-.28.54-.16.32-.31.63-.46.95-.22.46-.44.92-.64,1.39-.18.4-.35.8-.52,1.21-.03.07-.06.13-.08.2-.19.45-.36.9-.53,1.35-.02.05-.04.1-.05.14-.18.46-.34.92-.5,1.39-.13.39-.26.79-.39,1.19,2.7-.38,5.45-.57,8.2-.57s5.51.19,8.2.57c.65,2.06,1.18,4.17,1.58,6.33-3.17-.59-6.43-.9-9.78-.9s-6.61.31-9.78.9Z"
        />
        <path
          className="accent"
          d="m12.03,116.51c-.21-.03-.42-.07-.63-.11-.04-.23-.09-.47-.12-.7.07.4.36.72.75.81Z"
        />
        <path
          className="accent"
          d="m73.68,73.68h0c-.19,1.04-.41,2.06-.66,3.07-.07.3-.14.59-.23.89-.01.03-.02.07-.03.1-.08.32-.17.65-.27.97-.12.43-.25.87-.39,1.3-.45.06-.91.12-1.37.17-2.26.27-4.54.4-6.83.4-2.75,0-5.49-.19-8.18-.57h-.02c.13.4.26.8.39,1.19.15.44.3.88.47,1.31.01.03.02.05.03.08.01.04.03.09.05.14.17.45.34.9.53,1.35.02.07.05.13.08.2.17.41.34.81.52,1.21.2.46.41.92.64,1.38.18.4.38.8.58,1.19.51,1,1.05,1.99,1.62,2.95.02.04.04.07.07.11.15.27.32.55.49.82.01.02.03.04.04.06.84,1.36,1.74,2.67,2.69,3.94h0c-1.23,1.64-2.55,3.21-3.95,4.69-.29-.36-.57-.72-.84-1.08-4.64-6.17-8.04-13.25-9.97-20.69l-.16-.03-.03-.16c-7.44-1.93-14.53-5.34-20.7-9.98-.36-.27-.72-.55-1.08-.84,1.48-1.4,3.05-2.72,4.68-3.95,4.76,3.57,10.14,6.37,15.94,8.2-.38-2.7-.57-5.45-.57-8.2s.19-5.51.57-8.2c.52-.16,1.03-.32,1.55-.46.53-.15,1.05-.29,1.58-.42.29-.08.59-.15.89-.21.76-.19,1.53-.35,2.31-.49-.59,3.17-.9,6.43-.9,9.78s.31,6.61.9,9.78c1.59.29,3.19.52,4.83.67,1.63.14,3.28.22,4.95.22s3.32-.08,4.95-.22c1.64-.15,3.24-.38,4.83-.67Z"
        />
        <path
          className="accent"
          d="m74.73,106.73c.82.62,1.66,1.21,2.52,1.77-.86-.57-1.7-1.15-2.52-1.77Z"
        />
        <path
          className="accent"
          d="m100.63,67.85c-.36.29-.72.57-1.08.84-6.17,4.64-13.25,8.04-20.69,9.97l-.03.16-.17.03c-1.92,7.44-5.33,14.53-9.96,20.7-.27.36-.55.72-.84,1.08-1.4-1.48-2.72-3.04-3.96-4.68h0c.56-.76,1.1-1.52,1.62-2.29.25-.37.49-.74.73-1.11.01-.03.03-.05.05-.08.24-.39.48-.78.72-1.17.15-.24.29-.48.43-.72.02-.04.05-.08.06-.12.33-.56.65-1.13.94-1.71.16-.31.32-.62.48-.93.16-.31.31-.63.46-.94.22-.45.43-.9.63-1.36,0,0,.01-.02.01-.03.14-.31.27-.62.4-.94.04-.08.07-.17.1-.25.07-.16.14-.32.2-.49.14-.32.27-.65.39-.98.36-.93.68-1.87.98-2.82-.45.06-.91.12-1.37.17-2.26.27-4.54.4-6.83.4-2.75,0-5.49-.19-8.18-.57h-.02s-.01-.03-.01-.05c-.16-.5-.31-1-.45-1.5-.15-.53-.29-1.05-.42-1.58-.08-.29-.15-.59-.21-.89-.19-.76-.35-1.53-.49-2.31,1.59.29,3.19.52,4.83.67,1.63.14,3.28.22,4.95.22s3.32-.08,4.95-.22c1.64-.15,3.24-.38,4.83-.67.59-3.17.9-6.44.9-9.78s-.31-6.61-.9-9.78h.01c1.03.19,2.05.41,3.06.66.3.07.59.14.89.23.03,0,.07.02.1.03.32.08.65.17.97.27.44.12.87.25,1.3.39.38,2.7.57,5.45.57,8.2s-.19,5.51-.57,8.2c.4-.13.8-.26,1.19-.39.47-.16.93-.32,1.39-.5.04,0,.09-.03.14-.05.45-.17.9-.34,1.35-.53.07-.02.13-.05.2-.08.41-.17.81-.34,1.21-.52.47-.2.93-.42,1.39-.64.32-.15.63-.3.95-.46.18-.09.36-.19.54-.28.33-.17.66-.35.99-.52.33-.18.66-.36.98-.55.29-.16.58-.33.87-.5,1.64-.98,3.22-2.04,4.74-3.18,1.63,1.23,3.2,2.55,4.68,3.95Z"
        />
        <path
          className="accent"
          d="m116.51,115.78c-.03.21-.06.41-.1.62-.23.04-.47.09-.7.12.38-.07.7-.36.8-.74Z"
        />
        <path
          className="accent"
          d="m100.63,59.94c-1.48,1.41-3.05,2.73-4.68,3.96-1.52-1.14-3.1-2.2-4.74-3.18-.29-.17-.58-.34-.87-.5-.32-.19-.65-.37-.98-.55-.33-.17-.66-.35-.99-.52-.13-.06-.25-.13-.38-.2-.05-.03-.11-.05-.16-.08-.32-.16-.63-.31-.95-.46-.46-.22-.92-.44-1.39-.64-.4-.18-.8-.35-1.21-.52-.07-.03-.13-.06-.2-.08-.45-.19-.9-.36-1.35-.53-.05-.02-.1-.04-.14-.05-.03-.01-.05-.02-.08-.03-.43-.17-.87-.32-1.31-.47-.39-.13-.79-.26-1.19-.39.38,2.7.57,5.45.57,8.2s-.19,5.51-.57,8.2c-.02,0-.03,0-.05,0-.5.16-1,.31-1.5.45-.53.15-1.05.29-1.58.42-.29.08-.59.15-.89.21-.76.19-1.53.35-2.31.49.59-3.17.9-6.44.9-9.78s-.31-6.61-.9-9.78c-3.17-.59-6.43-.9-9.78-.9s-6.61.31-9.78.9h0c.19-1.04.41-2.06.66-3.07.08-.33.16-.66.26-.99.08-.32.17-.65.27-.97.12-.44.25-.87.39-1.3,2.7-.38,5.45-.57,8.2-.57s5.51.19,8.2.57c-1.83-5.8-4.63-11.18-8.2-15.94,1.23-1.63,2.54-3.19,3.95-4.67.3.36.57.71.84,1.07,4.64,6.16,8.04,13.24,9.97,20.69l.16.03.03.16c7.44,1.93,14.53,5.34,20.7,9.97.36.27.72.55,1.08.84Z"
        />
        <path
          className="accent"
          d="m116.4,11.39c.04.23.09.47.12.7-.07-.42-.4-.75-.82-.82.23.03.47.08.7.12Z"
        />
        <path
          className="main"
          d="m80.01,55.7c-.12-.9-.26-1.8-.43-2.69-.25-1.31-.54-2.62-.88-3.91,0-.05-.02-.11-.04-.16-1.93-7.45-5.33-14.53-9.97-20.69-.27-.36-.54-.71-.84-1.07h0c-1.24-1.6-2.56-3.12-3.96-4.56C52.76,11.02,37.55,4.5,21.18,4.5c-3.4,0-6.8.29-10.11.86-2.92.51-5.21,2.81-5.71,5.73-.57,3.31-.86,6.71-.86,10.09,0,16.36,6.52,31.57,18.12,42.72,1.44,1.38,2.96,2.7,4.55,3.95.36.29.72.57,1.08.84,6.17,4.64,13.26,8.05,20.7,9.98.05.01.1.03.15.03,1.26.34,2.54.62,3.82.86l.11.02c.88.16,1.77.31,2.67.43h.02c2.69.38,5.43.57,8.18.57,2.29,0,4.57-.13,6.83-.4.46-.05.92-.11,1.37-.17.61-.08,1.21-.18,1.81-.28.29-.05.59-.1.88-.16.11,0,.22-.04.33-.06l3.54-.66.17-.03.03-.16.7-3.78s.01-.07.02-.1c.17-.89.31-1.78.43-2.68.38-2.69.57-5.45.57-8.2s-.19-5.5-.57-8.2Zm-11.16,18.65c-1.63.15-3.28.23-4.95.23s-3.32-.08-4.95-.23c-1.64-.15-3.24-.38-4.83-.67h-.01c-2.16-.4-4.26-.93-6.32-1.58-5.8-1.83-11.18-4.63-15.94-8.2-1.63-1.23-3.2-2.55-4.68-3.96-10.26-9.73-16.67-23.49-16.67-38.76,0-1.25.04-2.5.13-3.73.03-.41.06-.82.1-1.22.03-.39.07-.78.11-1.16.01-.04.01-.09.02-.13.05-.38.09-.77.15-1.14.05-.39.11-.78.17-1.17.03-.18.06-.35.09-.53t.01-.02c.07-.39.36-.69.74-.79.02-.01.05-.02.07-.02.15-.03.3-.05.45-.07.03-.01.05-.01.08-.02.39-.06.78-.12,1.17-.17.8-.11,1.61-.21,2.43-.28.41-.04.82-.07,1.23-.1,1.23-.09,2.48-.13,3.73-.13,15.26,0,29.03,6.4,38.75,16.66,1.41,1.49,2.74,3.05,3.97,4.69,3.57,4.76,6.37,10.14,8.2,15.94.65,2.06,1.18,4.17,1.58,6.33.59,3.17.9,6.44.9,9.78s-.31,6.61-.9,9.78c-1.59.29-3.19.52-4.83.67Z"
        />
        <path
          className="accent"
          d="m21.18,16.5c11.49,0,22.27,4.01,30.84,11.39-3.32,5.05-5.96,10.6-7.77,16.35-5.75,1.82-11.3,4.46-16.35,7.78-7.38-8.58-11.4-19.36-11.4-30.84,0-1.15.04-2.26.11-3.29.03-.36.05-.71.09-1.06v-.07s.01-.05.01-.05c0,0,.01,0,.02,0h.04s.04,0,.04,0c.34-.03.69-.06,1.03-.08h.05c1.04-.08,2.14-.12,3.29-.12m0-6c-1.25,0-2.5.04-3.73.13-.41.03-.82.06-1.23.1-.82.07-1.63.17-2.43.28-.39.05-.78.11-1.17.17-.03,0-.05,0-.08.02-.17.03-.35.06-.52.09-.38.1-.67.4-.74.79t-.01.02c-.03.18-.06.35-.09.53-.06.39-.12.78-.17,1.17-.06.37-.1.76-.15,1.14-.01.04-.01.09-.02.13-.04.38-.08.77-.11,1.16-.04.4-.07.81-.1,1.22-.09,1.23-.13,2.48-.13,3.73,0,15.27,6.41,29.03,16.67,38.76.36-.29.72-.57,1.08-.84,6.17-4.63,13.25-8.04,20.69-9.97l.19-.18c1.93-7.44,5.34-14.53,9.97-20.71.27-.36.55-.72.83-1.08-9.72-10.26-23.49-16.66-38.75-16.66h0Z"
        />
        <path
          className="main"
          d="m80.01,55.7c-.12-.9-.26-1.8-.43-2.69l-.73-3.88-.03-.16-.16-.03-3.78-.7s-.07-.01-.1-.02c-.89-.17-1.78-.31-2.68-.43-2.69-.38-5.44-.57-8.2-.57s-5.5.19-8.2.57c-.9.12-1.8.26-2.69.43l-.98.19c-.98.2-1.96.42-2.93.68-.05,0-.11.02-.16.04-7.44,1.93-14.52,5.34-20.69,9.97-.36.27-.72.55-1.08.84-1.59,1.25-3.11,2.57-4.55,3.96-11.6,11.14-18.12,26.35-18.12,42.72,0,3.4.29,6.8.86,10.11.51,2.92,2.81,5.21,5.73,5.71,3.31.57,6.71.86,10.09.86,16.36,0,31.57-6.52,42.72-18.12,1.39-1.44,2.71-2.96,3.96-4.55.29-.36.57-.72.84-1.08,4.63-6.17,8.04-13.26,9.96-20.7.02-.05.04-.1.04-.15.34-1.26.62-2.54.86-3.82.01-.03.01-.07.02-.1.17-.89.31-1.78.43-2.68.38-2.69.57-5.45.57-8.2s-.19-5.5-.57-8.2Zm-8.89,27.13c-.12.33-.25.66-.39.98-.06.17-.13.33-.2.49-.03.08-.06.17-.1.25-.12.32-.26.63-.4.94,0,0-.01.02-.01.03-.2.46-.41.91-.63,1.36-.15.31-.3.63-.46.94-.16.31-.32.62-.48.93-.29.58-.61,1.15-.94,1.71-.01.04-.04.08-.06.12-.14.24-.28.48-.43.72-.24.39-.48.78-.72,1.17-.02.03-.04.05-.05.08-.24.37-.48.74-.73,1.11-.52.77-1.06,1.53-1.62,2.28h0c-1.23,1.64-2.55,3.21-3.95,4.69-.38.4-.76.79-1.15,1.18-.32.31-.63.62-.96.92-.3.29-.61.57-.92.85-.1.09-.21.19-.32.28-.03.02-.05.05-.08.07-.02.02-.05.04-.07.06-.29.26-.58.52-.88.76-.3.26-.61.52-.92.76-.13.11-.26.22-.4.32-.13.1-.26.2-.39.31-.02.02-.05.04-.07.05-.13.1-.26.2-.39.3-.13.1-.25.2-.39.29-.37.28-.75.56-1.13.82-.39.28-.78.54-1.17.8-.33.22-.66.43-.99.64-.3.2-.61.39-.92.57-.11.07-.23.14-.34.21-.32.19-.64.37-.96.55-.01,0-.01,0-.02,0-.23.13-.46.26-.69.39-.21.12-.42.23-.64.34-.06.04-.13.07-.19.1-.02.01-.03.02-.05.03-.01,0-.02,0-.03.02-.27.14-.54.27-.81.41-.4.2-.79.4-1.19.58-.4.19-.81.38-1.21.55-.83.36-1.67.71-2.53,1.03-.3.12-.6.23-.9.33-.61.23-1.23.44-1.86.64-.3.09-.61.19-.91.28-.36.11-.73.21-1.1.31-.45.13-.9.24-1.36.36-.29.07-.58.14-.87.2-.38.09-.75.17-1.13.25-.41.09-.83.17-1.24.24-.41.08-.82.15-1.24.21-.04.01-.07.01-.11.02-.2.03-.41.05-.62.08-.06.01-.11.02-.17.03-.28.04-.56.08-.84.11-.05,0-.11,0-.16.02-.37.05-.74.08-1.12.12-.28.03-.55.06-.83.08-.41.04-.83.07-1.25.09-.37.02-.74.04-1.11.05-.24.02-.48.03-.71.03-.48.01-.95.02-1.43.02-.55,0-1.11-.01-1.66-.03-.7-.02-1.39-.05-2.07-.1-.41-.03-.81-.06-1.22-.1-.82-.07-1.63-.17-2.43-.28-.39-.05-.78-.11-1.17-.17-.03-.01-.05-.01-.08-.02-.05,0-.09,0-.14-.02-.12-.02-.23-.04-.35-.06-.01,0-.01,0-.02,0h-.01c-.39-.09-.68-.41-.75-.81l-.18-1.11c-.09-.6-.17-1.2-.24-1.8-.02-.15-.03-.29-.05-.44-.01-.09-.02-.18-.03-.27-.03-.32-.06-.64-.09-.97,0-.04-.01-.09-.01-.13-.02-.21-.03-.42-.05-.63-.04-.54-.07-1.09-.09-1.64v-.12c-.01-.16-.01-.32-.02-.49-.01-.16-.01-.33-.01-.49-.01-.33-.01-.66-.01-.99,0-.48.01-.95.02-1.43,0-.23.01-.47.03-.71.01-.37.03-.74.05-1.11.02-.42.05-.84.09-1.25.02-.28.05-.55.08-.83.04-.38.07-.75.12-1.12,0-.05,0-.11.02-.16.03-.28.07-.56.11-.84.01-.06.02-.11.03-.17.03-.21.05-.42.08-.62.01-.04.01-.07.02-.11.06-.42.13-.83.21-1.24.07-.41.15-.83.24-1.24.08-.38.16-.75.25-1.13.06-.29.13-.58.2-.87.12-.46.23-.91.36-1.36.1-.37.2-.74.31-1.1.02-.06.03-.11.05-.17.08-.25.16-.5.24-.74.19-.63.4-1.25.63-1.86.1-.3.21-.6.33-.9.32-.86.67-1.7,1.03-2.53.17-.4.36-.81.55-1.21.18-.4.38-.79.58-1.19.14-.27.27-.54.41-.81.01,0,.01-.02.02-.03.01-.02.02-.03.03-.05.03-.06.06-.13.1-.19.11-.22.22-.43.34-.64.13-.23.26-.46.39-.69,0,0,.01,0,.01-.02.18-.32.36-.64.55-.96.07-.11.14-.23.21-.34.18-.31.37-.62.57-.92.21-.33.42-.66.64-.99.26-.39.52-.78.8-1.17.26-.38.54-.76.82-1.13.09-.14.19-.26.29-.39.1-.13.2-.26.3-.39.01-.02.03-.05.05-.07.11-.13.21-.26.31-.39.1-.14.21-.27.32-.4.24-.31.5-.62.76-.92.24-.3.5-.59.76-.88.02-.02.04-.05.06-.07.02-.03.05-.05.07-.08.09-.11.19-.22.28-.32.28-.31.56-.62.85-.92.3-.33.61-.64.92-.96.39-.39.78-.77,1.18-1.15,1.48-1.4,3.05-2.72,4.68-3.95.42-.31.84-.62,1.27-.93.4-.28.8-.55,1.2-.82,1.64-1.1,3.35-2.1,5.11-3.01.33-.17.67-.34,1-.5.51-.25,1.02-.49,1.54-.72.51-.23,1.03-.45,1.55-.67.35-.15.7-.29,1.05-.42.35-.14.71-.27,1.06-.4.36-.13.72-.26,1.08-.38.36-.12.72-.24,1.08-.35.52-.16,1.03-.32,1.55-.46.53-.15,1.05-.29,1.58-.42.29-.08.59-.15.89-.21.76-.19,1.53-.35,2.31-.49,3.17-.59,6.44-.9,9.78-.9s6.61.31,9.78.9c.59,3.17.9,6.44.9,9.78s-.31,6.61-.9,9.78h0c-.19,1.04-.41,2.06-.66,3.07-.07.3-.14.59-.23.89-.01.03-.02.07-.03.1-.08.32-.17.65-.27.97-.12.43-.25.87-.39,1.3-.3.95-.62,1.89-.98,2.82Z"
        />
        <path
          className="accent"
          d="m47.79,55.7c-.36.11-.72.23-1.08.35-.36.12-.72.25-1.08.38-.35.13-.71.26-1.06.4-.35.13-.7.27-1.05.42-.52.22-1.04.44-1.55.67-.52.23-1.03.47-1.54.72-.33.16-.67.33-1,.5-1.76.91-3.47,1.91-5.11,3.01-.4.27-.8.54-1.2.82-.43.31-.85.62-1.27.93,4.76,3.57,10.14,6.37,15.94,8.2-.38-2.7-.57-5.45-.57-8.2s.19-5.51.57-8.2h0Z"
        />
        <path
          className="main"
          d="m105.18,63.89c-1.44-1.39-2.96-2.71-4.55-3.95-.36-.29-.72-.57-1.08-.84-6.17-4.63-13.26-8.04-20.7-9.97-.05,0-.1-.03-.15-.03-1.26-.34-2.54-.62-3.82-.86-.03-.01-.07-.01-.1-.02-.89-.17-1.78-.31-2.68-.43-2.69-.38-5.44-.57-8.2-.57s-5.5.19-8.2.57c-.9.12-1.8.26-2.69.43l-.98.19-2.9.54-.16.03-.03.15-.7,3.79s-.01.07-.02.1c-.17.89-.31,1.78-.43,2.68-.38,2.69-.57,5.44-.57,8.2s.19,5.5.57,8.2c.12.9.26,1.79.43,2.68.25,1.32.54,2.62.88,3.92.01.05.02.11.04.16,1.93,7.44,5.33,14.52,9.97,20.69.27.36.55.72.84,1.08,1.25,1.59,2.57,3.11,3.95,4.55,11.15,11.6,26.35,18.12,42.72,18.12,3.4,0,6.8-.29,10.11-.87,2.92-.5,5.21-2.8,5.72-5.72.56-3.31.85-6.71.85-10.09,0-16.37-6.52-31.58-18.12-42.73Zm12.09,44.39c-.02.69-.05,1.38-.1,2.06-.03.41-.06.82-.1,1.23-.03.36-.07.73-.11,1.09-.01.09-.02.18-.03.27-.04.36-.09.72-.14,1.07-.05.39-.11.78-.17,1.16-.03.18-.06.35-.09.53v.02s-.01.03-.01.05t-.01.02c-.1.38-.42.67-.8.74l-1.11.18c-.6.09-1.2.17-1.8.24-.14.02-.29.03-.43.05-.1,0-.19.02-.29.03-.37.04-.75.07-1.12.1-.2.02-.4.03-.61.05-.55.04-1.1.07-1.66.09h-.09c-.33,0-.65.03-.99.03-.33.01-.66.01-.99.01-.48,0-.95-.01-1.43-.02-.23,0-.47,0-.71-.03-.37,0-.74-.03-1.11-.05-.58-.03-1.15-.08-1.72-.13-.49-.04-.99-.1-1.48-.16-.32-.03-.65-.07-.97-.13-.07,0-.13-.02-.2-.03-.33-.04-.66-.09-.99-.15-.39-.05-.78-.12-1.16-.19-.91-.17-1.81-.36-2.7-.57-.58-.14-1.15-.29-1.72-.45-.44-.11-.86-.24-1.29-.37-.48-.15-.97-.3-1.45-.46-.58-.19-1.15-.4-1.72-.61-.36-.13-.71-.26-1.06-.41-.35-.14-.71-.28-1.05-.43-.74-.31-1.46-.63-2.17-.97-.45-.21-.89-.43-1.33-.66-.34-.17-.68-.35-1.01-.53-.19-.1-.38-.21-.56-.31-.37-.2-.74-.41-1.11-.63-.44-.25-.88-.52-1.31-.79-.38-.23-.75-.47-1.12-.72-.86-.56-1.7-1.15-2.52-1.77-.29-.21-.57-.42-.85-.64-2.15-1.67-4.16-3.49-6.02-5.46-1.4-1.48-2.72-3.04-3.96-4.68h0c-.95-1.28-1.85-2.59-2.69-3.95-.01-.02-.03-.04-.04-.06-.17-.27-.34-.55-.49-.82-.03-.04-.05-.07-.07-.11-.57-.96-1.11-1.95-1.62-2.95-.2-.39-.4-.79-.58-1.19-.23-.46-.44-.92-.64-1.38-.18-.4-.35-.8-.52-1.21-.03-.07-.06-.13-.08-.2-.19-.45-.36-.9-.53-1.35-.02-.05-.04-.1-.05-.14-.01-.03-.02-.05-.03-.08-.17-.43-.32-.87-.47-1.31-.13-.39-.26-.79-.39-1.19-.01-.02-.01-.03-.01-.05-.16-.5-.31-1-.45-1.5-.15-.53-.29-1.05-.42-1.58-.08-.29-.15-.59-.21-.89-.19-.76-.35-1.53-.49-2.31-.59-3.17-.9-6.44-.9-9.78s.31-6.61.9-9.78c3.17-.59,6.44-.9,9.78-.9s6.61.31,9.78.9h.01c1.03.19,2.05.41,3.06.66.3.07.59.14.89.23.03,0,.07.02.1.03.32.08.65.17.97.27.44.12.87.25,1.3.39.4.13.8.26,1.19.39.44.15.88.3,1.31.47.03,0,.05.02.08.03.04,0,.09.03.14.05.45.17.9.34,1.35.53.07.02.13.05.2.08.41.17.81.34,1.21.52.47.2.93.42,1.39.64.32.15.63.3.95.46.05.03.11.05.16.08.13.07.25.14.38.2.33.17.66.35.99.52.33.18.66.36.98.55.29.16.58.33.87.5,1.64.98,3.22,2.04,4.74,3.18,1.63,1.23,3.2,2.55,4.68,3.95.4.38.79.76,1.18,1.15.31.32.62.63.92.96.29.3.57.61.85.92.09.1.19.21.28.32.02.03.05.05.07.08.28.31.56.63.82.95.26.3.52.61.76.92.11.13.22.26.32.4.1.13.2.26.31.39.02.02.04.05.05.07.2.26.4.51.59.78.28.37.56.75.82,1.13.28.39.54.78.8,1.17.22.33.43.66.64.99.2.3.39.61.57.92.07.11.14.23.21.34.19.32.37.64.55.96,0,0,.01,0,.01.02.29.5.57,1,.83,1.52.01.02.02.03.03.05.01,0,.01.02.02.03.14.27.27.54.41.81.2.4.39.79.58,1.19.18.4.37.81.55,1.21.36.83.71,1.67,1.03,2.53.12.3.23.6.33.9.23.61.44,1.23.64,1.86.09.3.19.61.28.91.11.36.21.73.31,1.1.13.45.25.9.36,1.36.07.29.14.58.2.87.09.38.17.75.25,1.13.09.41.17.83.24,1.24.07.41.14.82.21,1.24.04.24.07.48.1.73.01.06.02.11.03.17.04.28.08.56.11.84,0,.05,0,.11.02.16.05.37.09.75.12,1.12.03.28.06.55.08.83.04.41.07.83.09,1.25.02.37.04.74.05,1.11.01.11.02.23.02.35s0,.24.01.36c.01.48.02.95.02,1.43,0,.55-.01,1.11-.03,1.66Z"
        />
        <path
          className="accent"
          d="m72.1,80.01c-.45.06-.91.12-1.37.17-2.26.27-4.54.4-6.83.4-2.75,0-5.49-.19-8.18-.57h-.02c.13.4.26.8.39,1.19.15.44.3.88.47,1.31.01.03.02.05.03.08.01.04.03.09.05.14.17.45.34.9.53,1.35.02.07.05.13.08.2.17.41.34.81.52,1.21.2.46.41.92.64,1.38.18.4.38.8.58,1.19.51,1,1.05,1.99,1.62,2.95.02.04.04.07.07.11.15.27.32.55.49.82.01.02.03.04.04.06.84,1.36,1.74,2.67,2.69,3.94.56-.75,1.1-1.51,1.62-2.28.25-.37.49-.74.73-1.11.01-.03.03-.05.05-.08.24-.39.48-.78.72-1.17.15-.24.29-.48.43-.72.02-.04.05-.08.06-.12.33-.56.65-1.13.94-1.71.16-.31.32-.62.48-.93.16-.31.31-.63.46-.94.22-.45.43-.9.63-1.36,0,0,.01-.02.01-.03.14-.31.27-.62.4-.94.04-.08.07-.17.1-.25.07-.16.14-.32.2-.49.14-.32.27-.65.39-.98.36-.93.68-1.87.98-2.82h0Z"
        />
        <path
          className="main"
          d="m122.44,11.07c-.51-2.92-2.81-5.22-5.73-5.72-3.31-.56-6.71-.85-10.09-.85-16.37,0-31.58,6.52-42.73,18.12-1.39,1.44-2.71,2.95-3.96,4.54-.28.36-.56.72-.83,1.08-4.63,6.18-8.04,13.27-9.97,20.71-.01.05-.03.09-.03.14-.34,1.27-.62,2.54-.86,3.83-.01.03-.01.07-.02.1-.17.89-.31,1.78-.43,2.68-.38,2.69-.57,5.44-.57,8.2s.19,5.5.57,8.2c.12.9.26,1.79.43,2.68l.73,3.89.03.16.16.03,3.78.7.11.02c.88.16,1.77.31,2.67.43h.02c2.7.37,5.44.56,8.18.56,2.28,0,4.57-.13,6.83-.39.46-.05.92-.11,1.37-.17.61-.08,1.21-.18,1.81-.28.29-.05.57-.1.86-.15t.02-.01c.11,0,.22-.04.33-.06,1.2-.23,2.4-.5,3.58-.81.05-.01.11-.02.16-.04,7.44-1.93,14.52-5.33,20.69-9.97.36-.27.72-.55,1.08-.84,1.59-1.25,3.11-2.57,4.55-3.96,11.6-11.14,18.12-26.35,18.12-42.71,0-3.4-.29-6.81-.86-10.11Zm-5.16,11.54c0,.23-.01.47-.03.71-.01.37-.03.74-.05,1.11-.02.42-.05.84-.09,1.25-.02.28-.05.55-.08.83-.04.43-.08.86-.14,1.28-.04.34-.08.67-.14,1.01-.25,1.79-.59,3.54-1.01,5.26-.11.43-.23.86-.35,1.29-.1.37-.2.74-.31,1.11-.09.3-.18.61-.28.91-.12.38-.24.75-.37,1.12-.12.34-.23.67-.36,1.01-.39,1.07-.81,2.13-1.27,3.16-.36.81-.74,1.61-1.13,2.4-.14.28-.28.56-.43.84-.28.54-.57,1.07-.87,1.59-.18.32-.36.64-.55.96-.07.11-.14.23-.21.34-.18.31-.37.61-.57.92-.21.33-.42.66-.64.99-.16.24-.32.48-.49.72-.11.17-.23.34-.35.5-.25.36-.51.72-.78,1.08-.21.28-.42.57-.64.85-.6.77-1.21,1.52-1.85,2.25-.29.34-.58.67-.88,1-.89.98-1.82,1.93-2.78,2.84-1.48,1.41-3.05,2.73-4.68,3.96-1.52,1.14-3.1,2.2-4.74,3.18-.29.17-.58.34-.87.5-.32.19-.65.37-.98.55-.33.17-.66.35-.99.52-.18.09-.36.19-.54.28-.32.16-.63.31-.95.46-.46.22-.92.44-1.39.64-.4.18-.8.35-1.21.52-.07.03-.13.06-.2.08-.45.19-.9.36-1.35.53-.05.02-.1.04-.14.05-.46.18-.92.34-1.39.5-.39.13-.79.26-1.19.39-.02,0-.03,0-.05,0-.5.16-1,.31-1.5.45-.53.15-1.05.29-1.58.42-.29.08-.59.15-.89.21-.76.19-1.53.35-2.31.49-1.59.29-3.19.52-4.83.67-1.63.14-3.28.22-4.95.22s-3.32-.08-4.95-.22c-1.64-.15-3.24-.38-4.83-.67-.59-3.17-.9-6.44-.9-9.78s.31-6.61.9-9.78h0c.19-1.04.41-2.06.66-3.07.08-.33.16-.66.26-.99.08-.32.17-.65.27-.97.12-.44.25-.87.39-1.3.13-.4.26-.8.39-1.19.16-.47.32-.93.5-1.39.01-.04.03-.09.05-.14.17-.45.34-.9.53-1.35.02-.07.05-.13.08-.2.17-.41.34-.81.52-1.21.2-.47.42-.93.64-1.39.15-.32.3-.63.46-.95.09-.18.19-.36.28-.54.17-.33.35-.66.52-.99.18-.33.36-.66.55-.98.16-.29.33-.58.5-.87.98-1.64,2.04-3.22,3.18-4.74,1.23-1.63,2.54-3.19,3.95-4.67h0c.34-.36.68-.71,1.03-1.06s.72-.71,1.08-1.05c.74-.7,1.5-1.38,2.28-2.03.39-.33.77-.64,1.17-.96.3-.24.6-.47.91-.71.52-.39,1.05-.78,1.58-1.15.71-.51,1.44-.99,2.18-1.46.19-.12.37-.23.55-.34.31-.2.63-.39.95-.57.48-.29.96-.56,1.44-.82.37-.21.75-.41,1.13-.6.22-.12.44-.23.66-.34.74-.37,1.48-.72,2.24-1.05.04-.02.07-.04.11-.05.46-.21.93-.4,1.4-.59.57-.24,1.15-.46,1.74-.67.35-.13.7-.26,1.06-.38.09-.03.18-.06.27-.08.33-.12.66-.23.99-.32,1.69-.54,3.41-.99,5.17-1.35.41-.08.82-.16,1.24-.24.65-.12,1.3-.23,1.97-.31.34-.06.67-.1,1.01-.14.42-.06.85-.1,1.28-.14.28-.03.55-.06.83-.08.41-.04.83-.07,1.25-.09.37-.02.74-.04,1.11-.05.24-.02.48-.03.71-.03.48,0,.95-.02,1.43-.02.57,0,1.14.01,1.71.03.09,0,.17,0,.25.01.49.01.97.04,1.45.07.11,0,.21.01.32.02.53.03,1.06.08,1.58.13.03,0,.06,0,.08,0,.47.04.94.1,1.4.16.1,0,.19.02.29.03.3.04.59.09.89.13.37.06.74.12,1.11.18.42.07.75.4.82.82.06.37.12.74.18,1.11.04.3.09.59.13.89.01.1.03.19.03.29.07.46.12.93.16,1.4.01.03.01.05.01.08.06.53.1,1.06.14,1.59.01.1.01.2.02.3.03.49.06.99.07,1.49.01.07.01.14.01.22.02.57.03,1.14.03,1.72,0,.48-.01.95-.02,1.43Z"
        />
        <path
          className="accent"
          d="m74.58,63.9c0,3.34-.31,6.61-.9,9.78-1.59.29-3.19.52-4.83.67-1.63.14-3.28.22-4.95.22s-3.32-.08-4.95-.22c-1.64-.15-3.24-.38-4.83-.67-.59-3.17-.9-6.44-.9-9.78s.31-6.61.9-9.78c3.17-.59,6.44-.9,9.78-.9s6.61.31,9.78.9c.59,3.17.9,6.44.9,9.78Z"
        />
        <path
          className="accent"
          d="m63.9,31.85c-1.14,1.52-2.2,3.1-3.18,4.74-.17.29-.34.58-.5.87-.19.32-.37.65-.55.98-.17.33-.35.66-.52.99-.09.18-.19.36-.28.54-.16.32-.31.63-.46.95-.22.46-.44.92-.64,1.39-.18.4-.35.8-.52,1.21-.03.07-.06.13-.08.2-.19.45-.36.9-.53,1.35-.02.05-.04.1-.05.14-.18.46-.34.92-.5,1.39-.13.39-.26.79-.39,1.19,2.7-.38,5.45-.57,8.2-.57s5.51.19,8.2.57c-1.83-5.8-4.63-11.18-8.2-15.94h0Z"
        />
        <path
          className="accent"
          d="m80.01,55.7c.38,2.7.57,5.45.57,8.2s-.19,5.51-.57,8.2c.4-.13.8-.26,1.19-.39.47-.16.93-.32,1.39-.5.04,0,.09-.03.14-.05.45-.17.9-.34,1.35-.53.07-.02.13-.05.2-.08.41-.17.81-.34,1.21-.52.47-.2.93-.42,1.39-.64.32-.15.63-.3.95-.46.18-.09.36-.19.54-.28.33-.17.66-.35.99-.52.33-.18.66-.36.98-.55.29-.16.58-.33.87-.5,1.64-.98,3.22-2.04,4.74-3.18-1.52-1.14-3.1-2.2-4.74-3.18-.29-.17-.58-.34-.87-.5-.32-.19-.65-.37-.98-.55-.33-.17-.66-.35-.99-.52-.13-.06-.25-.13-.38-.2-.05-.03-.11-.05-.16-.08-.32-.16-.63-.31-.95-.46-.46-.22-.92-.44-1.39-.64-.4-.18-.8-.35-1.21-.52-.07-.03-.13-.06-.2-.08-.45-.19-.9-.36-1.35-.53-.05-.02-.1-.04-.14-.05-.03-.01-.05-.02-.08-.03-.43-.17-.87-.32-1.31-.47-.39-.13-.79-.26-1.19-.39h0Z"
        />
        <path
          className="accent"
          d="m106.62,16.5c.49,0,.97,0,1.46.02h.06s.32.01.32.01c.41,0,.81.04,1.2.06h.19s.01.01.01.01h.05s.09.01.09.01c.12,0,.24.01.36.02h.02s.69.07.69.07l.02.28.02.05c.03.28.05.57.07.85v.02c0,.09.01.17.02.26.02.39.05.78.06,1.17v.37s.02.06.02.06c.01.46.02.92.02,1.39,0,.43,0,.85-.02,1.3v.06s0,.06,0,.06c0,.07,0,.14,0,.21v.17s-.02.17-.02.17c0,.32-.03.63-.05.99-.02.32-.04.64-.07.95v.08s-.01.08-.01.08c-.01.18-.03.36-.05.55v.07s-.01.04-.01.04v.04c-.03.33-.06.66-.11.99v.07s-.02.07-.02.07c-.03.23-.05.44-.09.67l-.02.11-.02.11c-.21,1.53-.51,3.09-.89,4.63-.1.37-.2.74-.3,1.12v.04s-.02.02-.02.02c-.09.32-.17.64-.27.95l-.05.17c-.06.19-.11.38-.18.57v.04s-.03.04-.03.04c-.1.32-.2.63-.31.93l-.11.31c-.06.18-.13.37-.2.55l-.02.04-.02.04c-.37,1.03-.74,1.93-1.12,2.78-.3.68-.64,1.39-1.02,2.16-.11.23-.23.46-.35.68l-.02.04-.02.04c-.24.46-.49.92-.74,1.35l-.02.04-.02.03c-.14.26-.29.51-.44.77-.04.06-.07.12-.11.17l-.04.07-.07.1-.06.11c-.13.23-.28.45-.45.72-.19.29-.37.58-.57.89-.13.19-.25.38-.38.56l-.08.11-.07.11c-.03.05-.07.1-.11.15l-.07.09-.06.09c-.21.3-.43.6-.65.9l-.21.28c-.11.15-.23.31-.36.48-.54.7-1.04,1.3-1.51,1.85-5.04-3.32-10.59-5.96-16.34-7.77-1.82-5.76-4.46-11.31-7.77-16.34.11-.09.22-.19.33-.28.35-.29.69-.57,1.04-.85.23-.19.46-.36.7-.55l.1-.08c.45-.34.92-.68,1.38-1l.03-.02.03-.02c.52-.38,1.13-.78,1.88-1.26.16-.1.32-.2.47-.29l.06-.04.06-.04c.19-.12.4-.25.64-.38l.08-.05.08-.05c.35-.21.73-.43,1.2-.68l.05-.03.05-.03c.25-.14.53-.29.85-.45l.1-.05.09-.05c.15-.08.31-.16.47-.24.57-.28,1.1-.54,1.61-.77h.03s.37-.18.37-.18l.08-.03.04-.02h.02c.36-.18.73-.32,1.1-.47l.05-.02.04-.02.04-.02c.42-.18.89-.36,1.42-.55h.04s.04-.03.04-.03c.25-.09.49-.18.76-.28l.16-.04.37-.13c.21-.08.38-.13.51-.17l.13-.03.12-.04c1.48-.47,3-.87,4.52-1.18.39-.08.78-.15,1.15-.22.48-.09,1.04-.19,1.59-.25l.17-.02.17-.03c.22-.04.44-.06.67-.09h.07s.07-.02.07-.02c.32-.05.66-.07.99-.11h.04s.04,0,.04,0h.11c.17-.03.34-.05.52-.06h.08s.08-.01.08-.01c.31-.03.63-.05.99-.07.31-.02.63-.03.94-.04h.18s.18-.02.18-.02c.07,0,.13,0,.2,0h.12s.09,0,.09,0c.41,0,.81-.02,1.22-.02m0-6c-.48,0-.95.01-1.43.02-.23,0-.47,0-.71.03-.37,0-.74.03-1.11.05-.42.02-.84.05-1.25.09-.28.02-.55.05-.83.08-.43.04-.86.08-1.28.14-.34.04-.67.08-1.01.14-.67.08-1.32.19-1.97.31-.42.08-.83.16-1.24.24-1.76.36-3.48.81-5.17,1.35-.33.09-.66.2-.99.32-.09.02-.18.05-.27.08-.36.12-.71.25-1.06.38-.59.21-1.17.43-1.74.67-.47.19-.94.38-1.4.59-.04,0-.07.03-.11.05-.76.33-1.5.68-2.24,1.05-.22.11-.44.22-.66.34-.38.19-.76.39-1.13.6-.48.26-.96.53-1.44.82-.32.18-.64.37-.95.57-.18.11-.36.22-.55.34-.74.47-1.47.95-2.18,1.46-.53.37-1.06.76-1.58,1.15-.31.24-.61.47-.91.71-.4.32-.78.63-1.17.96-.78.65-1.54,1.33-2.28,2.03-.36.34-.73.7-1.08,1.05s-.69.7-1.03,1.05h0c.3.37.57.72.84,1.08,4.64,6.16,8.04,13.24,9.97,20.69l.19.19c7.44,1.93,14.53,5.34,20.7,9.97.36.27.72.55,1.08.84.96-.91,1.89-1.86,2.78-2.84.3-.33.59-.66.88-1,.64-.73,1.25-1.48,1.85-2.25.22-.28.43-.57.64-.85.27-.36.53-.72.78-1.08.12-.16.24-.33.35-.5.17-.24.33-.48.49-.72.22-.33.43-.66.64-.99.2-.31.39-.61.57-.92.07-.11.14-.23.21-.34.19-.32.37-.64.55-.96.3-.52.59-1.05.87-1.59.15-.28.29-.56.43-.84.39-.79.77-1.59,1.13-2.4.46-1.03.88-2.09,1.27-3.16.13-.34.24-.67.36-1.01.13-.37.25-.74.37-1.12.1-.3.19-.61.28-.91.11-.37.21-.74.31-1.11.12-.43.24-.86.35-1.29.42-1.72.76-3.47,1.01-5.26.06-.34.1-.67.14-1.01.06-.42.1-.85.14-1.28.03-.28.06-.55.08-.83.04-.41.07-.83.09-1.25.02-.37.04-.74.05-1.11.02-.24.03-.48.03-.71.01-.48.02-.95.02-1.43,0-.58-.01-1.15-.03-1.72,0-.08,0-.15-.01-.22-.01-.5-.04-1-.07-1.49-.01-.1-.01-.2-.02-.3-.04-.53-.08-1.06-.14-1.59,0-.03,0-.05-.01-.08-.04-.47-.09-.94-.16-1.4,0-.1-.02-.19-.03-.29-.04-.3-.09-.59-.13-.89-.06-.37-.12-.74-.18-1.11-.07-.42-.4-.75-.82-.82-.37-.06-.74-.12-1.11-.18-.3-.04-.59-.09-.89-.13-.1,0-.19-.02-.29-.03-.46-.06-.93-.12-1.4-.16-.02,0-.05,0-.08,0-.52-.05-1.05-.1-1.58-.13-.11,0-.21-.02-.32-.02-.48-.03-.96-.06-1.45-.07-.08-.01-.16-.01-.25-.01-.57-.02-1.14-.03-1.71-.03h0Z"
        />
        <path
          className="accent"
          d="m27.92,75.79c5.04,3.32,10.59,5.96,16.34,7.77,1.82,5.76,4.46,11.31,7.77,16.34-.11.09-.22.19-.33.28-.35.29-.69.57-1.04.85-.23.19-.46.36-.7.55l-.1.08c-.45.34-.92.68-1.38,1l-.03.02-.03.02c-.52.38-1.13.78-1.88,1.26-.16.1-.32.2-.47.29l-.06.04-.06.04c-.19.12-.4.25-.64.38l-.08.05-.08.05c-.35.21-.73.43-1.2.68l-.05.03-.05.03c-.25.14-.53.29-.85.45l-.1.05-.09.05c-.15.08-.31.16-.47.24-.57.28-1.1.54-1.61.77h-.03s-.37.18-.37.18l-.08.03-.04.02h-.02c-.36.18-.73.32-1.1.47l-.05.02-.04.02-.04.02c-.42.18-.89.36-1.42.55h-.04s-.04.03-.04.03c-.25.09-.49.18-.76.28l-.16.04-.37.13c-.21.08-.38.13-.51.17l-.13.03-.12.04c-1.48.47-3,.87-4.52,1.18-.39.08-.78.15-1.15.22-.48.09-1.04.19-1.59.25l-.17.02-.17.03c-.22.04-.44.06-.67.09h-.07s-.07.02-.07.02c-.32.05-.66.07-.99.11h-.04s-.04,0-.04,0h-.11c-.17.03-.34.05-.52.06h-.08s-.08.01-.08.01c-.31.03-.63.05-.99.07-.31.02-.63.03-.94.04h-.18s-.18.02-.18.02c-.07,0-.13,0-.2,0h-.12s-.09,0-.09,0c-.41,0-.81.02-1.22.02-.49,0-.97,0-1.46-.02h-.06s-.32-.01-.32-.01c-.41,0-.81-.04-1.2-.06h-.19s-.01-.01-.01-.01h-.05s-.09-.01-.09-.01c-.12,0-.24-.01-.36-.02h-.02s-.69-.07-.69-.07l-.02-.28-.02-.05c-.03-.28-.05-.57-.07-.85v-.02c0-.09-.01-.17-.02-.26-.02-.39-.05-.78-.06-1.17v-.37s-.02-.06-.02-.06c-.01-.46-.02-.92-.02-1.39,0-.43,0-.85.02-1.3v-.06s0-.06,0-.06c0-.07,0-.14,0-.21v-.17s.02-.17.02-.17c0-.32.03-.63.05-.99.02-.32.04-.64.07-.95v-.08s.01-.08.01-.08c.01-.18.03-.36.05-.55v-.07s.01-.04.01-.04v-.04c.03-.33.06-.66.11-.99v-.07s.02-.07.02-.07c.03-.23.05-.44.09-.67l.02-.11.02-.11c.21-1.53.51-3.09.89-4.63.1-.37.2-.74.3-1.12v-.04s.02-.02.02-.02c.09-.32.17-.64.27-.95l.05-.17c.06-.19.11-.38.18-.57v-.04s.03-.04.03-.04c.1-.32.2-.63.31-.93l.11-.31c.06-.18.13-.37.2-.55l.02-.04.02-.04c.37-1.03.74-1.93,1.12-2.78.3-.68.64-1.39,1.02-2.16.11-.23.23-.46.35-.68l.02-.04.02-.04c.24-.46.49-.92.74-1.35l.02-.04.02-.03c.14-.26.29-.51.44-.77.04-.06.07-.12.11-.17l.04-.07.07-.1.06-.11c.13-.23.28-.45.45-.72.19-.29.37-.58.57-.89.13-.19.25-.38.38-.56l.08-.11.07-.11c.03-.05.07-.1.11-.15l.07-.09.06-.09c.21-.3.43-.6.65-.9l.21-.28c.11-.15.23-.31.36-.48.54-.7,1.04-1.3,1.51-1.85m-.74-7.93c-.96.91-1.89,1.86-2.78,2.84-.3.33-.59.66-.88,1-.64.73-1.25,1.48-1.85,2.25-.22.28-.43.57-.64.85-.27.36-.53.72-.78,1.08-.12.16-.24.33-.35.5-.17.24-.33.48-.49.72-.22.33-.43.66-.64.99-.2.31-.39.61-.57.92-.07.11-.14.23-.21.34-.19.32-.37.64-.55.96-.3.52-.59,1.05-.87,1.59-.15.28-.29.56-.43.84-.39.79-.77,1.59-1.13,2.4-.46,1.03-.88,2.09-1.27,3.16-.13.34-.24.67-.36,1.01-.13.37-.25.74-.37,1.12-.1.3-.19.61-.28.91-.11.37-.21.74-.31,1.11-.12.43-.24.86-.35,1.29-.42,1.72-.76,3.47-1.01,5.26-.06.34-.1.67-.14,1.01-.06.42-.1.85-.14,1.28-.03.28-.06.55-.08.83-.04.41-.07.83-.09,1.25-.02.37-.04.74-.05,1.11-.02.24-.03.48-.03.71-.01.48-.02.95-.02,1.43,0,.58.01,1.15.03,1.72,0,.08,0,.15.01.22.01.5.04,1,.07,1.49.01.1.01.2.02.3.04.53.08,1.06.14,1.59,0,.03,0,.05.01.08.04.47.09.94.16,1.4,0,.1.02.19.03.29.04.3.09.59.13.89.06.37.12.74.18,1.11.07.42.4.75.82.82.37.06.74.12,1.11.18.3.04.59.09.89.13.1,0,.19.02.29.03.46.06.93.12,1.4.16.02,0,.05,0,.08,0,.52.05,1.05.1,1.58.13.11,0,.21.02.32.02.48.03.96.06,1.45.07.08.01.16.01.25.01.57.02,1.14.03,1.71.03.48,0,.95-.01,1.43-.02.23,0,.47,0,.71-.03.37,0,.74-.03,1.11-.05.42-.02.84-.05,1.25-.09.28-.02.55-.05.83-.08.43-.04.86-.08,1.28-.14.34-.04.67-.08,1.01-.14.67-.08,1.32-.19,1.97-.31.42-.08.83-.16,1.24-.24,1.76-.36,3.48-.81,5.17-1.35.33-.09.66-.2.99-.32.09-.02.18-.05.27-.08.36-.12.71-.25,1.06-.38.59-.21,1.17-.43,1.74-.67.47-.19.94-.38,1.4-.59.04,0,.07-.03.11-.05.76-.33,1.5-.68,2.24-1.05.22-.11.44-.22.66-.34.38-.19.76-.39,1.13-.6.48-.26.96-.53,1.44-.82.32-.18.64-.37.95-.57.18-.11.36-.22.55-.34.74-.47,1.47-.95,2.18-1.46.53-.37,1.06-.76,1.58-1.15.31-.24.61-.47.91-.71.4-.32.78-.63,1.17-.96.78-.65,1.54-1.33,2.28-2.03.36-.34.73-.7,1.08-1.05s.69-.7,1.03-1.05h0c-.3-.37-.57-.72-.84-1.08-4.64-6.16-8.04-13.24-9.97-20.69l-.19-.19c-7.44-1.93-14.53-5.34-20.7-9.97-.36-.27-.72-.55-1.08-.84h0Z"
        />
        <path
          className="accent"
          d="m99.9,75.78c.09.11.19.22.28.33.29.35.57.69.85,1.04.19.24.37.47.56.71l.07.09c.34.46.68.92,1,1.38l.02.03.02.03c.38.52.78,1.13,1.26,1.89.1.16.2.31.29.47l.04.06.04.06c.12.19.25.41.38.64l.05.08.05.08c.21.35.43.73.68,1.2l.03.05.03.05c.14.25.29.53.45.85l.05.1.05.09c.08.16.16.31.24.47.28.57.54,1.1.77,1.61v.03s.18.37.18.37l.03.08.02.04v.02c.18.37.33.74.5,1.16l.02.04.02.04c.18.42.36.89.55,1.42v.04s.03.04.03.04c.09.25.18.49.28.77l.04.16.13.37c.08.21.13.38.17.51l.03.13.04.12c.47,1.48.87,3,1.18,4.52.08.39.15.78.22,1.15.09.48.19,1.04.25,1.59l.02.17.03.17c.04.22.06.44.09.67v.07s.02.07.02.07c.05.32.07.66.11.99v.04s0,.04,0,.04v.1c.03.17.05.34.06.52v.08s.01.08.01.08c.03.31.05.63.07.99.02.31.03.63.04.94v.18s.02.18.02.18c0,.07,0,.13,0,.2v.12s0,.09,0,.09c0,.41.02.81.02,1.22,0,.49,0,.97-.02,1.46v.06s-.01.32-.01.32c0,.41-.03.81-.06,1.2v.19s-.01.02-.01.02v.06s-.01.09-.01.09c0,.12-.02.24-.02.36v.02s-.07.69-.07.69l-.26.02-.05.02c-.29.03-.58.05-.88.07h-.02c-.09,0-.18.01-.27.02-.39.02-.78.05-1.17.06h-.38s-.07.02-.07.02c-.46.01-.91.02-1.38.02-.44,0-.86,0-1.3-.02h-.06s-.06,0-.06,0c-.07,0-.14,0-.21,0h-.17s-.17-.02-.17-.02c-.32,0-.63-.03-.99-.05-.32-.02-.64-.04-.95-.07h-.08s-.08-.01-.08-.01c-.19-.01-.38-.03-.61-.06h-.05s-.04,0-.04,0c-.33-.03-.67-.06-.99-.11h-.07s-.07-.02-.07-.02c-.23-.03-.44-.05-.67-.09l-.11-.02-.11-.02c-1.53-.21-3.09-.51-4.63-.89-.36-.09-.71-.19-1.07-.29l-.11-.03c-.32-.09-.65-.17-.95-.26l-.19-.06c-.18-.05-.37-.11-.55-.17h-.04s-.04-.03-.04-.03c-.32-.1-.63-.2-.94-.31l-.29-.1c-.19-.07-.38-.13-.57-.2l-.04-.02-.04-.02c-1.03-.37-1.93-.74-2.78-1.12-.67-.3-1.39-.64-2.17-1.02-.22-.11-.44-.22-.66-.34l-.04-.02-.04-.02c-.46-.24-.91-.49-1.35-.74l-.03-.02h-.03c-.26-.16-.52-.31-.78-.46-.06-.03-.11-.07-.17-.1l-.07-.04-.1-.06-.1-.06c-.23-.13-.45-.28-.72-.45-.29-.19-.59-.37-.88-.57l-.05-.03c-.18-.12-.35-.23-.53-.36l-.11-.08-.11-.07c-.05-.03-.1-.07-.15-.11l-.09-.06-.09-.06c-.3-.21-.6-.43-.9-.65l-.29-.21c-.15-.11-.31-.23-.48-.36-.69-.54-1.3-1.04-1.85-1.51,3.32-5.04,5.96-10.59,7.77-16.34,5.76-1.82,11.31-4.46,16.34-7.77m.73-7.93h-.01c-.36.3-.71.57-1.07.84-6.16,4.64-13.24,8.04-20.69,9.97l-.19.19c-1.93,7.44-5.34,14.53-9.97,20.7-.27.36-.55.72-.84,1.08.91.96,1.86,1.89,2.84,2.78.33.3.66.59,1,.88.73.64,1.48,1.25,2.25,1.85.28.22.57.43.85.64.36.27.72.53,1.08.78.16.12.33.24.5.35.24.17.48.33.72.49.33.22.66.43.99.64.31.2.61.39.92.57.11.07.23.14.34.21.32.19.64.37.96.55.52.3,1.05.59,1.59.87.28.15.56.29.84.43.79.39,1.59.77,2.4,1.13,1.03.46,2.09.88,3.16,1.27.34.13.67.24,1.01.36.37.13.74.25,1.12.37.3.1.61.19.91.28.37.11.74.21,1.11.31.43.12.86.24,1.29.35,1.72.42,3.47.76,5.26,1.01.34.06.67.1,1.01.14.42.06.85.1,1.28.14.28.03.55.06.83.08.41.04.83.07,1.25.09.37.02.74.04,1.11.05.24.02.48.03.71.03.48.01.95.02,1.43.02.58,0,1.15,0,1.72-.03.08,0,.15,0,.22-.01.5,0,1-.04,1.49-.07.1-.01.2-.01.3-.02.53-.04,1.06-.08,1.59-.14.03,0,.05,0,.08,0,.47-.04.94-.09,1.4-.16.1,0,.19-.02.29-.03.3-.04.59-.09.89-.13.37-.06.74-.12,1.11-.18.42-.07.75-.4.82-.82.06-.37.12-.74.18-1.11.04-.3.09-.59.13-.89,0-.1.02-.19.03-.29.06-.46.12-.93.16-1.4,0-.02,0-.05,0-.08.05-.52.1-1.05.13-1.58,0-.11.02-.21.02-.32.03-.48.06-.96.07-1.45.01-.08.01-.16.01-.25.02-.57.03-1.14.03-1.71,0-.48-.01-.95-.02-1.43,0-.23,0-.47-.03-.71,0-.37-.03-.74-.05-1.11-.02-.42-.05-.84-.09-1.25-.02-.28-.05-.55-.08-.83-.04-.43-.08-.86-.14-1.28-.04-.34-.08-.67-.14-1.01-.08-.67-.19-1.32-.31-1.97-.08-.42-.16-.83-.24-1.24-.36-1.76-.81-3.48-1.35-5.17-.09-.33-.2-.66-.32-.99-.02-.09-.05-.18-.08-.27-.12-.36-.25-.71-.38-1.06-.21-.59-.43-1.17-.67-1.74-.19-.47-.38-.94-.59-1.4,0-.04-.03-.07-.05-.11-.33-.76-.68-1.5-1.05-2.24-.11-.22-.22-.44-.34-.66-.19-.38-.39-.76-.6-1.13-.26-.48-.53-.96-.82-1.44-.18-.32-.37-.64-.57-.95-.11-.18-.22-.36-.34-.55-.47-.74-.95-1.47-1.46-2.18-.37-.53-.76-1.06-1.15-1.58-.24-.31-.47-.61-.71-.91-.32-.4-.63-.78-.96-1.17-.65-.78-1.33-1.54-2.03-2.28-.34-.36-.7-.73-1.05-1.08s-.7-.69-1.05-1.03h0Z"
        />
      </g>
    </svg>
  );
}

function QuoteIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 153.15 128"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m113.98,128c-12.82,0-23.29-4.19-31.12-12.46-1.99-2.1-3.73-4.43-5.21-6.97-1.84,3.58-4.29,6.74-7.32,9.48-7.34,6.6-16.74,9.95-27.95,9.95-12.86,0-23.3-4.22-31.03-12.53C3.82,107.38,0,96.05,0,81.79c0-19.64,4.84-35.8,14.39-48.02C23.47,22.15,36.93,12.03,54.4,3.66L61.6.22c.96-.46,2.1-.1,2.64.81l16.6,28.55c.59,1.01.21,2.3-.83,2.83l-8.13,4.16c-10.04,5.13-14.37,9.26-16.23,11.82-1.31,1.8-2.26,3.51-2.85,5.11,8.38.99,15.14,4.26,20.15,9.75,2.18-11.51,6.52-21.41,12.99-29.56,9.17-11.55,22.4-21.64,39.33-29.98l7.12-3.51c.95-.47,2.09-.13,2.64.77l17.27,28.57c.61,1.02.23,2.34-.83,2.87l-8.38,4.19c-10.2,5.1-14.45,9.16-16.22,11.66-1.3,1.84-2.25,3.59-2.82,5.24,8.66,1.02,15.54,4.37,20.51,10,5.7,6.48,8.59,15.21,8.59,25.95,0,12.07-3.88,21.69-11.53,28.58-7.34,6.6-16.64,9.95-27.63,9.95Z"
        />
        <path
          className="main"
          d="m67.01,27.06c-9.6,4.91-16.27,9.92-20,15.04-3.74,5.12-5.6,10.14-5.6,15.04,0,4.48,1.9,6.72,5.7,6.72,8.02,0,14.04,2.24,18.05,6.72,4.01,4.48,6.02,10.78,6.02,18.88,0,8.96-2.67,15.84-8,20.64-5.34,4.8-12.27,7.2-20.8,7.2-9.82,0-17.55-3.04-23.2-9.12-5.66-6.08-8.48-14.88-8.48-26.4,0-17.28,4.04-31.1,12.13-41.45,8.09-10.35,20.15-19.36,36.2-27.04l8,13.76Zm71.29,0c-9.81,4.91-16.54,9.92-20.16,15.04-3.63,5.12-5.44,10.14-5.44,15.04,0,4.48,1.81,6.72,5.44,6.72,8.32,0,14.45,2.24,18.4,6.72,3.95,4.48,5.92,10.78,5.92,18.88,0,8.96-2.67,15.84-8,20.64-5.34,4.8-12.16,7.2-20.48,7.2-9.82,0-17.6-3.04-23.36-9.12-5.76-6.08-8.64-14.88-8.64-26.4,0-17.28,4.11-31.1,12.32-41.45,8.21-10.35,20.11-19.36,35.69-27.04l8.32,13.76Z"
        />
        <path
          className="accent"
          d="m66.48,26.14c.29.5.1,1.14-.42,1.41-9.09,4.75-15.44,9.6-19.05,14.55-3.74,5.12-5.6,10.14-5.6,15.04,0,4.48,1.9,6.72,5.7,6.72,8.02,0,14.04,2.24,18.05,6.72,4.01,4.48,6.02,10.78,6.02,18.88,0,8.96-2.67,15.84-8,20.64-5.34,4.8-12.27,7.2-20.8,7.2-9.82,0-17.55-3.04-23.2-9.12-5.66-6.08-8.48-14.88-8.48-26.4,0-17.28,4.04-31.1,12.13-41.45,7.94-10.16,19.72-19.04,35.34-26.63.48-.23,1.07-.06,1.34.4l6.99,12.02Zm71.26-.01c.31.51.11,1.16-.42,1.43-9.28,4.75-15.68,9.6-19.18,14.55-3.63,5.12-5.44,10.14-5.44,15.04,0,4.48,1.81,6.72,5.44,6.72,8.32,0,14.45,2.24,18.4,6.72,3.95,4.48,5.92,10.78,5.92,18.88,0,8.96-2.67,15.84-8,20.64-5.34,4.8-12.16,7.2-20.48,7.2-9.82,0-17.6-3.04-23.36-9.12-5.76-6.08-8.64-14.88-8.64-26.4,0-17.28,4.11-31.1,12.32-41.45,8.06-10.16,19.68-19.03,34.84-26.62.48-.24,1.06-.07,1.34.38l7.27,12.02Z"
        />
      </g>
    </svg>
  );
}

function QuoteIconV2(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m115.58,50.49l9.4-19.53c3.47-7.21.82-15.89-6.09-19.93l-1.82-1.06c-4.79-2.8-9.55-5.04-14.15-6.65-5.14-1.8-10.24-2.88-15.18-3.22-10.63-.72-21.36,2.54-31.92,9.68-1.13.77-2.2,1.56-3.22,2.38-.61.49-1.43.59-2.13.26L30.96,3.02c-7.21-3.47-15.89-.82-19.93,6.09l-1.06,1.82C4.06,21.04.73,30.91.1,40.26c-.72,10.63,2.54,21.37,9.68,31.92.76,1.13,1.56,2.18,2.38,3.19.49.61.6,1.44.26,2.15l-9.4,19.53c-3.47,7.21-.82,15.89,6.09,19.93l1.82,1.06c4.79,2.8,9.55,5.04,14.15,6.65,5.14,1.8,10.24,2.88,15.18,3.22,10.63.72,21.37-2.54,31.92-9.68,1.13-.77,2.2-1.56,3.22-2.38.61-.49,1.43-.59,2.13-.26l19.52,9.4c7.21,3.47,15.89.82,19.93-6.09l1.06-1.82c5.91-10.11,9.23-19.98,9.87-29.33.72-10.63-2.54-21.37-9.68-31.92-.76-1.13-1.56-2.18-2.38-3.19-.49-.61-.6-1.44-.26-2.15Z"
        />
        <path
          className="accent"
          d="m85.33,16.62c.57,0,1.15.02,1.72.06,6.78.46,14.15,3.02,22.1,7.66l-3.58,7.43c-4.89-2.69-8.98-4.09-12.26-4.21-.24,0-.48-.01-.72-.01-2.96,0-5.41.66-7.35,1.98-1.92,1.3-2.33,2.77-1.23,4.4,2.33,3.44,3.12,6.67,2.36,9.69-.76,3.02-2.87,5.71-6.35,8.06-2.86,1.94-5.66,2.91-8.39,2.91-.94,0-1.86-.11-2.78-.34-3.61-.89-6.65-3.17-9.13-6.83-2.85-4.21-3.79-8.41-2.83-12.6.96-4.19,3.92-7.96,8.85-11.3,6.79-4.6,13.31-6.9,19.57-6.9m0-6h0c-7.46,0-15.17,2.67-22.94,7.93-6.21,4.21-10.03,9.23-11.34,14.93-1.35,5.85-.1,11.68,3.71,17.3,3.32,4.9,7.58,8.03,12.65,9.29,1.39.34,2.81.52,4.23.52,3.94,0,7.9-1.33,11.75-3.94,4.72-3.2,7.68-7.09,8.8-11.57.93-3.72.46-7.54-1.4-11.38.54-.09,1.14-.14,1.8-.14.17,0,.34,0,.51,0,1.59.05,4.54.7,9.57,3.47.89.49,1.89.74,2.89.74.61,0,1.23-.09,1.83-.29,1.57-.5,2.86-1.63,3.58-3.11l3.58-7.43c1.36-2.82.32-6.2-2.38-7.78-8.72-5.1-17.04-7.95-24.72-8.47-.7-.05-1.42-.07-2.12-.07h0Z"
        />
        <path
          className="accent"
          d="m24.34,18.85l7.43,3.58c-2.69,4.89-4.09,8.98-4.21,12.26-.11,3.28.54,5.97,1.97,8.07.83,1.22,1.72,1.83,2.68,1.83.55,0,1.12-.2,1.72-.6,2.6-1.76,5.07-2.64,7.43-2.64.77,0,1.52.09,2.26.28,3.02.76,5.71,2.87,8.06,6.35,2.6,3.84,3.45,7.57,2.56,11.17-.89,3.61-3.17,6.65-6.83,9.13-3.14,2.13-6.28,3.19-9.41,3.19-1.06,0-2.12-.12-3.18-.37-4.19-.96-7.96-3.92-11.3-8.85-5.02-7.41-7.3-14.5-6.84-21.29.46-6.78,3.02-14.15,7.66-22.1m0-6c-2.07,0-4.07,1.08-5.18,2.97-5.1,8.72-7.95,17.04-8.47,24.72-.55,8.12,2.09,16.55,7.85,25.06,4.21,6.21,9.23,10.03,14.93,11.34,1.49.34,3.02.52,4.53.52,4.34,0,8.64-1.42,12.78-4.23,4.9-3.32,8.03-7.58,9.28-12.65,1.31-5.32.16-10.69-3.42-15.98-3.2-4.72-7.09-7.68-11.57-8.8-1.21-.3-2.46-.46-3.72-.46-2.54,0-5.1.62-7.67,1.86-.12-.68-.16-1.45-.13-2.31.05-1.59.7-4.54,3.47-9.58.79-1.44.96-3.15.46-4.72-.5-1.57-1.63-2.86-3.11-3.58l-7.43-3.58c-.84-.4-1.72-.59-2.6-.59h0Z"
        />
        <path
          className="accent"
          d="m56.36,73.42c.94,0,1.86.11,2.78.34,3.61.89,6.65,3.17,9.13,6.83,2.85,4.21,3.79,8.41,2.83,12.59-.96,4.19-3.92,7.96-8.85,11.3-6.79,4.6-13.31,6.9-19.57,6.9-.57,0-1.15-.02-1.72-.06-6.78-.46-14.15-3.02-22.1-7.66l3.58-7.43c4.89,2.69,8.98,4.09,12.26,4.21.24,0,.48.01.72.01,2.96,0,5.41-.66,7.35-1.98,1.92-1.3,2.33-2.77,1.23-4.4-2.33-3.44-3.12-6.67-2.36-9.69.76-3.02,2.87-5.71,6.35-8.06,2.86-1.94,5.66-2.91,8.39-2.91m0-6c-3.94,0-7.9,1.33-11.75,3.94-4.72,3.2-7.68,7.09-8.8,11.57-.93,3.72-.46,7.54,1.4,11.38-.54.09-1.14.14-1.8.14-.17,0-.34,0-.51,0-1.59-.05-4.54-.7-9.57-3.47-.89-.49-1.89-.74-2.89-.74-.61,0-1.23.09-1.83.29-1.57.5-2.86,1.63-3.58,3.11l-3.58,7.43c-1.36,2.82-.32,6.2,2.38,7.78,8.72,5.1,17.04,7.95,24.72,8.47.7.05,1.42.07,2.12.07,7.45,0,15.17-2.67,22.94-7.93,6.21-4.21,10.03-9.23,11.34-14.93,1.35-5.86.1-11.68-3.71-17.3-3.32-4.9-7.58-8.03-12.65-9.28-1.39-.34-2.81-.52-4.23-.52h0Z"
        />
        <path
          className="accent"
          d="m90,56.54c1.06,0,2.12.12,3.18.37,4.19.96,7.96,3.92,11.3,8.85,5.02,7.41,7.3,14.5,6.84,21.29-.46,6.78-3.02,14.15-7.66,22.1l-7.43-3.58c2.69-4.89,4.09-8.98,4.21-12.26.11-3.28-.54-5.97-1.97-8.07-.83-1.22-1.72-1.83-2.68-1.83-.55,0-1.12.2-1.72.6-2.6,1.76-5.07,2.64-7.43,2.64-.77,0-1.52-.09-2.26-.28-3.02-.76-5.71-2.87-8.06-6.35-2.6-3.84-3.45-7.57-2.56-11.17.89-3.61,3.17-6.65,6.83-9.13,3.14-2.13,6.28-3.19,9.41-3.19m0-6c-4.34,0-8.64,1.42-12.78,4.23-4.9,3.32-8.03,7.58-9.28,12.65-1.31,5.32-.16,10.69,3.42,15.98,3.19,4.72,7.09,7.68,11.57,8.8,1.21.3,2.46.46,3.72.46,2.54,0,5.1-.62,7.67-1.86.12.68.16,1.45.13,2.31-.05,1.59-.7,4.54-3.47,9.58-.79,1.44-.96,3.15-.46,4.72.5,1.57,1.63,2.86,3.11,3.58l7.43,3.58c.84.4,1.72.59,2.6.59,2.07,0,4.07-1.07,5.18-2.97,5.1-8.72,7.95-17.04,8.47-24.72.55-8.12-2.09-16.55-7.85-25.06-4.21-6.21-9.23-10.03-14.93-11.34-1.49-.34-3.02-.52-4.53-.52h0Z"
        />
      </g>
    </svg>
  );
}

function MemoryIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 95.68 127.04"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m5.67,68.85c-1.83-1.19-3.05-2.64-3.86-3.97-2.35-3.83-2.41-8.54-.18-12.91.55-1.08,1.15-2.18,1.75-3.3,1.47-2.71,3.69-6.8,3.69-8.57,0-.3-.02-.67-.03-1.11-.21-5.47-.71-18.28,8.82-28.18C22.77,3.64,33.15,0,46.71,0c18.1,0,30.9,5.86,38.05,17.42,5.42,8.76,6.17,18.4,6.17,27.51s-3.99,17.6-7.51,25.18c-1.92,4.15-4.29,9.24-4.59,12,.55.65,1.69,1.72,2.57,2.53,5.08,4.73,13.59,12.65,14.27,29.65.13,3.26-1.11,6.49-3.39,8.87-2.37,2.46-5.71,3.87-9.18,3.87H19.81c-3.83,0-7.41-1.67-9.8-4.57-2.31-2.8-3.24-6.44-2.55-9.98,1.14-5.87,4.48-10.51,8.58-14.49-1.58-.94-4.42-4.69-5.54-6.38-4.23-6.39-5.65-18.41-4.83-22.76Z"
        />
        <path
          className="main"
          d="m26.29,90.13c10.78,0,17.07-5.49,19.06-7.56.22-.23.67-.07.63.23-1.34,11.71-25.76,19.07-28.21,31.69-.21,1.07.76,2.05,2.05,2.05h63.3c1.18,0,2.11-.83,2.07-1.82-.86-21.53-16.88-21.98-16.88-32.06s12.12-25.01,12.12-37.73-1.02-34.43-33.72-34.43-29.14,24.15-29.14,29.61-3.87,11.32-6.59,16.65c-2.45,4.79,5.2,4.29,7.25,4.04.18-.02.33.11.29.26-.12.53-.37,1.69-.69,2.99-.45,1.85-1.03,3.99-1.49,5.07-.67,1.56.19,2.3.7,2.58.12.07.13.22.01.29-.34.21-.85.66-.92,1.57-.1,1.37,1.42,1.2,1.53,2.92.1,1.72-2.17,13.65,8.62,13.65Z"
        />
        <path
          className="accent"
          d="m26.29,90.13c10.78,0,17.07-5.49,19.06-7.56.22-.23.67-.07.63.23-1.34,11.71-25.76,19.07-28.21,31.69-.21,1.07.76,2.05,2.05,2.05h63.3c1.18,0,2.11-.83,2.07-1.82-.86-21.53-16.88-21.98-16.88-32.06s12.12-25.01,12.12-37.73-1.02-34.43-33.72-34.43-29.14,24.15-29.14,29.61-3.87,11.32-6.59,16.65c-2.45,4.79,5.2,4.29,7.25,4.04.18-.02.33.11.29.26-.12.53-.37,1.69-.69,2.99-.45,1.85-1.03,3.99-1.49,5.07-.67,1.56.19,2.3.7,2.58.12.07.13.22.01.29-.34.21-.85.66-.92,1.57-.1,1.37,1.42,1.2,1.53,2.92.1,1.72-2.17,13.65,8.62,13.65Z"
        />
        <g>
          <ellipse className="main" cx="64.24" cy="38.92" rx="6.97" ry="4.87" />
          <ellipse className="main" cx="63.33" cy="46.4" rx="6.97" ry="4.87" />
          <ellipse className="main" cx="33.11" cy="38.92" rx="6.97" ry="4.87" />
          <ellipse className="main" cx="38.07" cy="25.9" rx="10.28" ry="7.19" />
          <ellipse className="main" cx="34.07" cy="32.16" rx="8.51" ry="8.68" />
          <ellipse
            className="main"
            cx="53.96"
            cy="26.86"
            rx="10.28"
            ry="7.19"
          />
          <ellipse
            className="main"
            cx="42.59"
            cy="36.61"
            rx="10.28"
            ry="7.19"
          />
          <ellipse className="main" cx="63.49" cy="28.46" rx="7.13" ry="4.98" />
          <ellipse className="main" cx="63.17" cy="33.45" rx="7.13" ry="4.98" />
          <ellipse className="main" cx="46.45" cy="22.8" rx="7.13" ry="4.98" />
          <path
            className="main"
            d="m47.62,42.31l6.7,12.84c.19.37.62.6,1.09.6h4.76c.43,0,.72-.38.54-.71l-6.76-12.73"
          />
          <polygon
            className="main"
            points="60.82 33.08 48.35 33.08 48.35 42.67 51.05 47.67 60.82 47.67 60.82 33.08"
          />
        </g>
      </g>
    </svg>
  );
}

function HideOverlayIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 159.99 127.85"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m139.38,101.84L42,4.46c-2.88-2.88-6.7-4.46-10.77-4.46s-7.9,1.58-10.77,4.46-4.46,6.7-4.46,10.77,1.58,7.9,4.46,10.77l97.38,97.38c2.88,2.88,6.7,4.46,10.77,4.46s7.9-1.58,10.77-4.46c5.94-5.94,5.94-15.61,0-21.55Z"
        />
        <path
          className="main"
          d="m159.61,62.22c.51,1.12.51,2.45,0,3.56-17.05,37.3-46.33,61.91-79.61,61.91S17.41,103.08.38,65.78c-.51-1.12-.51-2.45,0-3.56C17.41,24.92,46.72.31,80,.31s62.57,24.61,79.61,61.9Z"
        />
        <path
          className="accent"
          d="m146.75,62.5c.43.94.43,2.05,0,2.99-14.29,31.27-38.85,51.91-66.75,51.91S27.52,96.77,13.24,65.49c-.43-.94-.43-2.05,0-2.99C27.52,31.24,52.09,10.6,80,10.6s52.46,20.64,66.75,51.91Z"
        />
        <path
          className="main"
          d="m131.42,108.73L35.27,12.57c-1.85-1.85-4.85-1.85-6.7,0-1.85,1.85-1.85,4.85,0,6.7l96.15,96.15c1.85,1.85,4.85,1.85,6.7,0h0c1.85-1.85,1.85-4.85,0-6.7Z"
        />
        <path
          className="main"
          d="m128.26,105.98L38.02,15.74c-1.74-1.74-4.55-1.74-6.29,0s-1.74,4.55,0,6.29l90.24,90.24c1.74,1.74,4.55,1.74,6.29,0h0c1.74-1.74,1.74-4.55,0-6.29Z"
        />
        <circle className="main" cx="79.99" cy="64" r="42.48" />
        <path
          className="main"
          d="m135.19,104.96L39.03,8.81c-1.9-1.9-4.43-2.95-7.12-2.95s-5.21,1.05-7.12,2.95c-1.9,1.9-2.95,4.43-2.95,7.12s1.05,5.22,2.95,7.12l96.15,96.15c1.9,1.9,4.43,2.95,7.12,2.95s5.21-1.05,7.12-2.95c1.9-1.9,2.95-4.43,2.95-7.12s-1.05-5.22-2.95-7.12Z"
        />
        <path
          className="main"
          d="m128.26,105.98L38.02,15.74c-1.74-1.74-4.55-1.74-6.29,0s-1.74,4.55,0,6.29l90.24,90.24c1.74,1.74,4.55,1.74,6.29,0h0c1.74-1.74,1.74-4.55,0-6.29Z"
        />
        <path
          className="accent"
          d="m131.42,108.73L35.27,12.57c-1.85-1.85-4.85-1.85-6.7,0s-1.85,4.85,0,6.7l96.15,96.15c1.85,1.85,4.85,1.85,6.7,0s1.85-4.85,0-6.7Z"
        />
      </g>
    </svg>
  );
}

function QuestionIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <circle className="main" cx="64" cy="64" r="64" />
        <circle className="accent" cx="64" cy="64" r="53.33" />
        <circle className="main" cx="64" cy="64" r="44.44" />
        <path
          className="accent"
          d="m56.38,74.24v-16.18c.66.11,1.27.21,1.83.29.55.08,1.08.12,1.58.12,1.49,0,2.9-.21,4.23-.62,1.33-.41,2.47-.98,3.44-1.7.97-.72,1.73-1.59,2.28-2.61.55-1.02.83-2.14.83-3.36,0-1.66-.55-3.1-1.66-4.31-1.11-1.22-2.6-1.83-4.48-1.83-1.72,0-3.08.58-4.11,1.74-1.02,1.16-1.53,2.68-1.53,4.56h-16.51c0-2.82.57-5.41,1.7-7.76,1.13-2.35,2.71-4.4,4.73-6.14,2.02-1.74,4.4-3.1,7.14-4.07,2.74-.97,5.71-1.45,8.92-1.45s6.24.54,8.92,1.62c2.68,1.08,4.99,2.53,6.93,4.36,1.94,1.83,3.43,3.93,4.48,6.31,1.05,2.38,1.58,4.84,1.58,7.38,0,8.3-5.01,14.19-15.02,17.67v5.97h-15.27Zm-1.66,13.03c0-1.33.25-2.59.75-3.78.5-1.19,1.19-2.23,2.07-3.11.88-.88,1.92-1.58,3.11-2.07,1.19-.5,2.45-.75,3.78-.75s2.59.25,3.78.75c1.19.5,2.23,1.19,3.11,2.07.88.89,1.58,1.92,2.07,3.11.5,1.19.75,2.45.75,3.78s-.25,2.59-.75,3.78c-.5,1.19-1.19,2.23-2.07,3.11-.89.89-1.92,1.58-3.11,2.07-1.19.5-2.45.75-3.78.75s-2.59-.25-3.78-.75c-1.19-.5-2.23-1.19-3.11-2.07-.89-.88-1.58-1.92-2.07-3.11-.5-1.19-.75-2.45-.75-3.78Z"
        />
      </g>
    </svg>
  );
}

function TickIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m128,64c0,35.35-28.66,64-64,64S0,99.35,0,64,28.65,0,64,0c9.66,0,18.81,2.14,27.02,5.97,5.6,2.61,10.76,6.01,15.34,10.05h0c13.27,11.73,21.64,28.88,21.64,47.98Z"
        />
        <circle className="accent" cx="64" cy="64" r="53.33" />
        <circle className="main" cx="64" cy="64" r="44.44" />
        <path
          className="main"
          d="m93.99,50.38l-37.44,37.44c-.56.56-1.46.56-2.01,0l-20.53-20.53c-.56-.56-.56-1.46,0-2.01l9.26-9.26c.56-.56,1.46-.56,2.01,0l9.26,9.26c.56.56,1.46.56,2.01,0l26.16-26.17c.56-.56,1.46-.56,2.01,0l9.26,9.25c.56.56.56,1.46,0,2.01Z"
        />
        <path
          className="accent"
          d="m93.99,50.91l-37.44,37.44c-.56.56-1.46.56-2.01,0l-20.53-20.53c-.56-.56-.56-1.46,0-2.01l9.26-9.26c.56-.56,1.46-.56,2.01,0l9.26,9.26c.56.56,1.46.56,2.01,0l26.16-26.17c.56-.56,1.46-.56,2.01,0l9.26,9.25c.56.56.56,1.46,0,2.01Z"
        />
      </g>
    </svg>
  );
}

function SaveIcon({ load, indicate }) {
  return (
    <svg
      id="Layer_2"
      className={`jordan ${load} ${indicate}`}
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128.07"
    >
      <g id="save_icon">
        <path
          className={"main"}
          d="m15.51,128.07c-8.55,0-15.51-7.12-15.51-15.88V15.87C0,7.12,6.95,0,15.49,0h97.02c8.54,0,15.49,7.12,15.49,15.87v96.31c0,4.4-1.7,8.48-4.8,11.49-2.91,2.83-6.71,4.39-10.71,4.39h0c-3.19,0-6.28-1.01-8.91-2.92l-39.58-28.64-39.57,28.64c-2.64,1.91-5.72,2.92-8.92,2.92Z"
        />
        <path
          className="main"
          d="m112.51,10.09H15.49c-3.12,0-5.64,2.59-5.64,5.78v96.32c0,4.69,5.16,7.42,8.9,4.72l42-30.4c1.95-1.41,4.56-1.41,6.51,0l42,30.39c3.74,2.7,8.89-.03,8.89-4.72V15.87c0-3.19-2.53-5.78-5.64-5.78Z"
        />
        <path
          id="save_icon"
          className={"accent"}
          d="m112.51,10.09H15.49c-3.12,0-5.64,2.59-5.64,5.78v96.32c0,4.69,5.16,7.42,8.9,4.72l42-30.4c1.95-1.41,4.56-1.41,6.51,0l42,30.39c3.74,2.7,8.89-.03,8.89-4.72V15.87c0-3.19-2.53-5.78-5.64-5.78Z"
        />
      </g>
    </svg>
  );
}

function YearIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m128,64c0,35.35-28.66,64-64,64S0,99.35,0,64,28.65,0,64,0c9.66,0,18.81,2.14,27.02,5.97,5.6,2.61,10.76,6.01,15.34,10.05h0c13.27,11.73,21.64,28.88,21.64,47.98Z"
        />
        <circle className="accent" cx="64" cy="64.21" r="48.27" />
        <path
          className="main"
          d="m67.37,23.18c1.06,3.55-2.55,7.49-2.87,7.82-2.13,2.27-3.04,1.16-4.55,5.24-1.84,4.99,3.85,7.88,5.33,8.84,4.09,2.67.5,8.74-3.95,6.67-8.08-3.76-11.72,1.21-12.22,2.98-.64,2.25,2.96,5.72,6.52,7.56,6.21,3.22,9.71.17,18.26,2.87,3.59,1.13,7.22,2.28,9.13,5.74,1.99,3.6,1.45,8.5-.78,11.74-2.48,3.58-5.02,2.17-8.35,6-3.15,3.63-1.83,6-5.48,10.69-1.2,1.54-4.15,5.35-6.26,4.7-2.49-.77-.57-6.79-4.69-14.08-2.24-3.97-3.45-3.31-4.69-6.52-2.36-6.09,1.4-9.97-.78-14.08-1.04-1.96-3.99-2.94-9.65-4.96-8.92-3.17-9.99-2.75-12.52-4.17-12.78-7.21-6.28-17.52-2.51-23.63.76-1.23,4.21-9.29,11.98-11.64,1.55-.47,5.59-2.31,8.94-4.56,2.7-1.81,4.04-2.42,6.19-2.7,5.62-.74,11.66,1.19,12.94,5.5Z"
        />
        <path
          className="main"
          d="m107.56,52.89s-3.27-4.83-4.36-7.28-5.31-1.03-7.28,1.39-3.47,8.16-2.27,11.48c1.21,3.32,7.4,11.33,11.33,11.63,3.93.3,4.68-3.02,4.53-6.65-.15-3.63-.45-6.35-1.96-10.58Z"
        />
        <path
          className="accent"
          d="m64.01,10.67c-29.46,0-53.34,23.88-53.34,53.33s23.88,53.33,53.34,53.33,53.33-23.87,53.33-53.33S93.46,10.67,64.01,10.67Zm0,97.78c-24.55,0-44.45-19.9-44.45-44.45s19.9-44.44,44.45-44.44,44.44,19.89,44.44,44.44-19.9,44.45-44.44,44.45Z"
        />
      </g>
    </svg>
  );
}

function WeekIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 127.3 127.33"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m127.3,35.46v-7.24c0-11.09-8.41-20.25-19.19-21.44-2.14-4.03-6.37-6.77-11.24-6.77h-8.86c-4.81,0-9.01,2.69-11.17,6.64h-26.38c-2.16-3.95-6.36-6.64-11.17-6.64h-8.86c-4.87,0-9.1,2.75-11.24,6.77C8.41,7.96,0,17.12,0,28.22v21.6h0v55.94C0,117.65,9.68,127.33,21.58,127.33h84.15c11.9,0,21.57-9.68,21.57-21.57V35.46h0Z"
        />
        <g>
          <g>
            <path
              className="accent"
              d="m10.5,45.96v59.79c0,6.11,4.96,11.07,11.07,11.07h84.15c6.11,0,11.07-4.96,11.07-11.07v-59.79H10.5Z"
            />
            <path
              className="accent"
              d="m116.8,28.22c0-6.12-4.96-11.07-11.07-11.07h-6.64v-4.43c0-1.22-.99-2.21-2.22-2.21h-8.86c-1.22,0-2.22.99-2.22,2.21v4.43h-44.29v-4.43c0-1.22-.99-2.21-2.22-2.21h-8.86c-1.22,0-2.22.99-2.22,2.21v4.43h-6.64c-6.12,0-11.07,4.96-11.07,11.07v11.1h106.3v-11.1Z"
            />
          </g>
          <g>
            <rect
              className="main"
              x="22.83"
              y="77.22"
              width="13.25"
              height="11.25"
            />
            <rect
              className="main"
              x="45.62"
              y="77.22"
              width="13.26"
              height="11.25"
            />
            <rect
              className="main"
              x="91.22"
              y="58.42"
              width="13.26"
              height="11.26"
            />
            <rect
              className="main"
              x="22.83"
              y="58.42"
              width="13.25"
              height="11.26"
            />
            <rect
              className="main"
              x="45.62"
              y="58.42"
              width="13.26"
              height="11.26"
            />
            <rect
              className="main"
              x="68.41"
              y="58.42"
              width="13.28"
              height="11.26"
            />
            <rect
              className="main"
              x="68.41"
              y="77.22"
              width="13.28"
              height="11.25"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

function DiaryIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 152.88 127.99"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <g>
          <path
            className="main"
            d="m147.88,0h-38.95c-14.63,0-25.18,1.83-32.27,5.61-.08.04-.14.08-.22.12-.08-.04-.14-.08-.22-.12C69.13,1.83,58.58,0,43.95,0H5C2.24,0,0,2.24,0,5v111.94c0,2.76,2.24,5,5,5h38.95c13.57,0,19.83,1.57,26.87,4.81.11.06.23.11.34.16,0,0,2.11,1.08,5.28,1.08s5.26-1.08,5.26-1.08c.11-.05.23-.1.34-.16,7.04-3.24,13.32-4.81,26.89-4.81h38.95c2.76,0,5-2.24,5-5V5c0-2.76-2.24-5-5-5Z"
          />
          <path
            className="accent"
            d="m140.22,10.48h-28.89c-31.07,0-31.07,8.27-31.07,8.27v97.94c0,.37.29.66.66.66.14,0,.27-.04.37-.11.02-.02.04-.03.06-.06l.12-.12s.01-.01.01-.02c2.38-2.47,9.36-6.09,29.84-6.09,18.26,0,25.79.01,28.89.03,1.2,0,2.17-.97,2.17-2.17V12.65c0-1.2-.97-2.17-2.17-2.17Z"
          />
          <path
            className="accent"
            d="m41.55,10.48H12.66c-1.2,0-2.17.97-2.17,2.17v96.16c0,1.2.97,2.17,2.17,2.17,3.1-.01,10.62-.03,28.89-.03,20.48,0,27.46,3.62,29.84,6.09,0,.01.01.02.01.02l.12.12s.03.04.06.06c.1.07.23.11.37.11.37,0,.66-.29.66-.66V18.75s0-8.27-31.07-8.27Z"
          />
        </g>
      </g>
    </svg>
  );
}

function InsightsIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 144.33 128"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <g>
          <g>
            <path
              className="main"
              d="m8.88,105.57L44.57,35.39c4.7-9.24,17.61-10.02,23.39-1.4l18.01,26.88,25.31-50.63,24.15,12.07-35.63,71.26c-4.66,9.31-17.63,10.14-23.43,1.48l-18.11-27.03-25.32,49.78-24.07-12.24Z"
            />
            <polygon
              className="main"
              points="28.34 103.69 22.99 100.97 56.31 35.47 87.28 81.71 115.97 24.33 121.34 27.01 88.04 93.61 57.02 47.31 28.34 103.69"
            />
          </g>
          <circle className="main" cx="25.67" cy="102.33" r="25.67" />
          <circle className="main" cx="25.67" cy="102.33" r="15.5" />
          <circle className="main" cx="56.67" cy="41.39" r="25.67" />
          <circle className="main" cx="56.67" cy="41.39" r="15.5" />
          <circle className="main" cx="87.66" cy="87.66" r="25.67" />
          <circle className="main" cx="87.66" cy="87.66" r="15.5" />
          <circle className="main" cx="118.66" cy="25.67" r="25.67" />
          <circle className="main" cx="118.66" cy="25.67" r="15.5" />
          <polygon
            className="accent"
            points="28.34 103.69 22.99 100.97 56.31 35.47 87.28 81.71 115.97 24.33 121.34 27.01 88.04 93.61 57.02 47.31 28.34 103.69"
          />
          <circle className="accent" cx="25.67" cy="102.33" r="15.5" />
          <circle className="accent" cx="56.67" cy="41.39" r="15.5" />
          <circle className="accent" cx="87.66" cy="87.66" r="15.5" />
          <circle className="accent" cx="118.66" cy="25.67" r="15.5" />
        </g>
      </g>
    </svg>
  );
}

function ProfileIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 126.73 128.31"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <g>
          <path
            className="main"
            d="m16.79,128.31c-9.26,0-16.79-7.53-16.79-16.79,0-26.61,21.65-48.26,48.26-48.26h30.21c26.61,0,48.26,21.65,48.26,48.26,0,9.26-7.53,16.79-16.79,16.79H16.79Z"
          />
          <path
            className="main"
            d="m78.47,73.75h-30.21c-20.86,0-37.76,16.91-37.76,37.76h0c0,3.48,2.82,6.29,6.29,6.29h93.15c3.48,0,6.29-2.82,6.29-6.29h0c0-20.86-16.91-37.76-37.76-37.76Z"
          />
          <circle className="main" cx="63.37" cy="37.72" r="37.72" />
          <circle className="main" cx="63.37" cy="37.72" r="27.22" />
        </g>
        <g>
          <path
            className="accent"
            d="m78.47,73.75h-30.21c-20.86,0-37.76,16.91-37.76,37.76h0c0,3.48,2.82,6.29,6.29,6.29h93.15c3.48,0,6.29-2.82,6.29-6.29h0c0-20.86-16.91-37.76-37.76-37.76Z"
          />
          <circle className="accent" cx="63.37" cy="37.72" r="27.22" />
        </g>
      </g>
    </svg>
  );
}

function LoginIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 95.89 127.48"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <g>
          <g>
            <path
              className="main"
              d="m20.21,127.48c-.73,0-1.41-.03-2.06-.1-9.53-.91-17.1-8.16-18.05-17.29-.07-.63-.1-1.28-.1-1.98V16.05C0,7.2,7.51,0,16.74,0h62.41c9.23,0,16.74,7.2,16.74,16.05v99.83c0,6.4-5.43,11.61-12.11,11.61H20.21Z"
            />
            <path
              className="main"
              d="m79.15,10.5H16.74c-3.2,0-5.79,2.48-5.79,5.55v92.06c0,.31.01.61.05.91.42,4.19,3.89,7.52,8.26,7.92.31.03.63.04.95.04h63.56c.64,0,1.16-.5,1.16-1.11V16.05c0-3.06-2.59-5.55-5.79-5.55Z"
            />
            <path
              className="accent"
              d="m79.15,10.5H16.74c-3.2,0-5.79,2.48-5.79,5.55v92.06c0,.31.01.61.05.91.42,4.19,3.89,7.52,8.26,7.92.31.03.63.04.95.04h63.56c.64,0,1.16-.5,1.16-1.11V16.05c0-3.06-2.59-5.55-5.79-5.55Zm1.16,103.16H20.47c-3.12,0-5.87-2.26-6.04-5.24-.16-2.86,1.95-5.29,4.77-5.76h61.1c.64,0,1.16.5,1.16,1.11v8.78c0,.61-.52,1.11-1.16,1.11Z"
            />
            <path
              className="main"
              d="m71.26,59.09l-25.12,24.07c-.35.34-.83.53-1.34.53h-6.56c-.68,0-1.14-.67-.86-1.27l7.88-13.69c.15-.31-.1-.65-.46-.63L0,71.08v-26.43l44.8,2.87c.35.03.61-.32.46-.63l-7.88-13.69c-.28-.6.18-1.27.86-1.27h6.56c.5,0,.98.19,1.34.53l25.12,24.07c.74.71.74,1.85,0,2.56Z"
            />
          </g>
          <path
            className="accent"
            d="m20.36,109.66h61.1s0-3,0-3H20.36c-.86,0-1.57.67-1.57,1.5s.7,1.5,1.57,1.5Z"
          />
        </g>
      </g>
    </svg>
  );
}

function LogoutIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 96 127.48"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <g>
          <g>
            <path
              className="main"
              d="m75.76,127.48c.73,0,1.41-.03,2.07-.1,9.54-.91,17.12-8.16,18.07-17.29.07-.63.1-1.28.1-1.98V16.05C96,7.2,88.48,0,79.24,0H16.76C7.52,0,0,7.2,0,16.05v99.83c0,6.4,5.44,11.61,12.13,11.61h63.64Z"
            />
            <path
              className="main"
              d="m16.76,10.5h62.48c3.2,0,5.79,2.48,5.79,5.55v77.53s0,3.53,0,3.53v11c0,.31-.01.61-.05.91-.42,4.19-3.89,7.52-8.27,7.92-.31.03-.63.04-.95.04H14.44s-2.32,0-2.32,0c-.64,0-1.16-.5-1.16-1.11v-13.22s0-3.42,0-3.42V16.05c0-3.06,2.59-5.55,5.79-5.55Z"
            />
            <path
              className="accent"
              d="m10.97,16.05v83.19s0,3.42,0,3.42v13.22c0,.61.52,1.11,1.16,1.11h2.32s61.32,0,61.32,0c.32,0,.64-.01.95-.04,4.38-.4,7.86-3.73,8.27-7.92.03-.3.05-.6.05-.91v-11s0-3.53,0-3.53V16.05c0-3.06-2.59-5.55-5.79-5.55H16.76c-3.2,0-5.79,2.48-5.79,5.55Zm3.48,96.5v-8.78c0-.61.52-1.11,1.16-1.11h61.17c2.82.47,4.94,2.9,4.78,5.76-.17,2.99-2.92,5.24-6.04,5.24H15.6c-.64,0-1.16-.5-1.16-1.11Z"
            />
            <path
              className="main"
              d="m24.66,59.09l25.14,24.07c.36.34.84.53,1.34.53h6.57c.68,0,1.14-.67.86-1.27l-7.89-13.69c-.15-.31.1-.65.46-.63l44.86,2.98v-26.43s-44.86,2.87-44.86,2.87c-.36.03-.61-.32-.46-.63l7.89-13.69c.28-.6-.18-1.27-.86-1.27h-6.57c-.5,0-.98.19-1.34.53l-25.14,24.07c-.74.71-.74,1.85,0,2.56Z"
            />
          </g>
          <path
            className="accent"
            d="m75.62,109.66H14.44v-3h61.17c.87,0,1.57.67,1.57,1.5s-.7,1.5-1.57,1.5Z"
          />
        </g>
      </g>
    </svg>
  );
}

function RegisterIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 97.84 128.1"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <g>
          <g>
            <path
              className="main"
              d="m19.36,122.1c-.7,0-1.35-.03-1.98-.09-9.13-.87-16.38-7.82-17.29-16.56-.07-.6-.1-1.22-.1-1.9V15.37C0,6.89,7.19,0,16.04,0h59.77c8.84,0,16.04,6.89,16.04,15.37v95.62c0,6.13-5.2,11.12-11.6,11.12H19.36Z"
            />
            <path
              className="main"
              d="m75.81,10.06H16.04c-3.06,0-5.54,2.38-5.54,5.31v88.18c0,.3.01.58.04.87.4,4.02,3.72,7.2,7.91,7.59.3.03.6.04.91.04h60.88c.61,0,1.11-.48,1.11-1.06V15.37c0-2.93-2.48-5.31-5.54-5.31Z"
            />
            <path
              className="accent"
              d="m75.81,10.06H16.04c-3.06,0-5.54,2.38-5.54,5.31v88.18c0,.3.01.58.04.87.4,4.02,3.72,7.2,7.91,7.59.3.03.6.04.91.04h60.88c.61,0,1.11-.48,1.11-1.06V15.37c0-2.93-2.48-5.31-5.54-5.31Zm1.11,98.8H19.61c-2.99,0-5.62-2.16-5.78-5.02-.15-2.74,1.87-5.07,4.57-5.52h58.52c.61,0,1.11.48,1.11,1.06v8.41c0,.59-.5,1.06-1.11,1.06Z"
            />
          </g>
          <path
            className="accent"
            d="m19.5,105.03h58.53s0-2.87,0-2.87H19.5c-.83,0-1.5.64-1.5,1.44s.67,1.44,1.5,1.44Z"
          />
        </g>
        <g>
          <circle className="main" cx="78.19" cy="108.45" r="19.65" />
          <circle className="accent" cx="78.19" cy="108.45" r="16.38" />
          <circle className="main" cx="78.19" cy="108.45" r="13.65" />
          <g>
            <rect
              className="accent"
              x="76.01"
              y="99.7"
              width="4.37"
              height="17.5"
            />
            <rect
              className="accent"
              x="76.01"
              y="99.7"
              width="4.37"
              height="17.5"
              transform="translate(186.64 30.26) rotate(90)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

function VitIcon(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 126.95 126.95"
      style={{ opacity: props.opacity }}
    >
      <g id="Creative">
        <path
          className="main"
          d="m63.47,0C28.47,0,0,28.47,0,63.47c0,11.97,3.33,23.18,9.12,32.75v25.73c0,2.76,2.24,5,5,5h98.71c2.76,0,5-2.24,5-5v-25.74c5.79-9.56,9.12-20.77,9.12-32.74C126.95,28.47,98.47,0,63.47,0Z"
        />
        <path
          className="accent"
          d="m99.46,25H27.48c9.43-8.83,22.09-14.24,35.99-14.24s26.56,5.41,35.99,14.24Z"
        />
        <path
          className="accent"
          d="m116.18,63.47c0,.83-.02,1.66-.06,2.49-.02.4-.04.81-.07,1.21s-.06.8-.1,1.2c-.04.42-.08.84-.13,1.26-.03.29-.07.58-.11.87-.07.52-.14,1.03-.23,1.54-.06.4-.13.79-.21,1.19-.1.53-.21,1.06-.32,1.58-.01.06-.02.12-.04.18-.12.53-.25,1.06-.38,1.59-.16.62-.33,1.23-.51,1.84-.14.48-.29.96-.45,1.43-.17.54-.36,1.07-.55,1.6-.58,1.6-1.23,3.15-1.95,4.66v-45.28c3.27,6.86,5.11,14.54,5.11,22.64Z"
        />
        <path
          className="accent"
          d="m15.88,40.83v45.28c-.21-.44-.42-.9-.62-1.34-.12-.26-.24-.53-.35-.8-.1-.23-.19-.45-.28-.68-.03-.07-.06-.13-.08-.2-.21-.5-.4-1.01-.59-1.52-.04-.12-.09-.25-.13-.38-.16-.44-.31-.88-.46-1.33-.18-.53-.34-1.07-.5-1.62-.16-.53-.31-1.07-.45-1.61-.03-.12-.06-.23-.08-.34-.11-.45-.22-.91-.32-1.36-.13-.56-.24-1.13-.35-1.69h0c-.05-.26-.1-.51-.14-.76-.08-.49-.16-.99-.23-1.48-.07-.45-.13-.9-.18-1.36-.05-.38-.09-.76-.12-1.15-.08-.84-.14-1.68-.18-2.53-.04-.83-.06-1.66-.06-2.49,0-8.1,1.84-15.78,5.12-22.64Z"
        />
        <path
          className="accent"
          d="m107.07,99.7v15.49c0,.55-.45,1-1,1h-21.68c.13-.05.25-.1.38-.16.43-.17.85-.35,1.27-.53.51-.22,1.01-.45,1.51-.69.58-.26,1.15-.54,1.72-.83.53-.28,1.05-.56,1.56-.84.45-.25.89-.5,1.34-.76.62-.37,1.24-.75,1.84-1.14.39-.24.77-.49,1.14-.75.58-.39,1.16-.79,1.72-1.21.28-.21.56-.42.84-.63,1.41-1.06,2.77-2.2,4.07-3.4.27-.24.53-.49.8-.74.32-.31.65-.63.97-.95.4-.4.79-.81,1.18-1.22.36-.38.72-.77,1.06-1.16.44-.48.87-.98,1.28-1.48Z"
        />
        <path
          className="accent"
          d="m42.55,116.19h-21.67c-.55,0-1-.45-1-1v-15.48c.37.45.75.89,1.15,1.33.2.22.39.44.59.66.19.22.39.43.6.65.2.21.4.42.61.63.2.21.41.43.62.63.38.38.77.76,1.16,1.13.13.13.27.25.4.37.33.31.67.61,1.01.91.32.28.64.56.97.83.39.35.79.67,1.2.99.23.19.46.37.7.55.4.31.81.61,1.22.92.03.03.06.05.09.06.31.23.62.45.94.67.45.32.9.62,1.36.92.24.17.49.33.74.47.48.31.96.61,1.44.89.47.28.95.55,1.43.82.51.28,1.03.56,1.56.84.57.29,1.14.57,1.72.83.5.24,1,.47,1.51.69.42.18.84.36,1.27.53.13.06.25.11.38.16Z"
        />
        <path
          className="accent"
          d="m53.2,79.67c0,.14-.04.29-.1.42l-14.24,29.99c-.37-.19-.73-.39-1.09-.59-.24-.13-.47-.27-.7-.41-.3-.16-.59-.34-.88-.52-.29-.17-.58-.35-.87-.54-.53-.33-1.05-.68-1.57-1.03-.09-.06-.18-.13-.27-.2-.25-.16-.49-.33-.73-.51-1.64-1.18-3.21-2.45-4.7-3.8-.62-.57-1.23-1.15-1.83-1.75-.56-.55-1.11-1.12-1.64-1.71-1.7-1.86-3.28-3.85-4.7-5.95v-38.41l31.27-1.39c.57-.02,1.05.43,1.05,1l.72,18.32.28,7.08Z"
        />
        <path
          className="accent"
          d="m78.09,114.13c-.07.02-.14.04-.2.06-.51.14-1.03.28-1.55.41-.54.14-1.07.26-1.62.38-.54.12-1.09.23-1.64.33-.14.03-.28.05-.43.08-.39.07-.77.13-1.16.19-.51.08-1.02.15-1.53.21-.53.07-1.05.12-1.58.17-.36.04-.72.07-1.09.09-.77.06-1.54.1-2.32.11-.5.02-1,.03-1.5.03s-.99-.01-1.48-.02c-.28-.01-.55-.02-.83-.04-.48-.01-.95-.04-1.43-.07-.32-.02-.63-.05-.95-.08-.28-.02-.56-.05-.83-.08-.57-.06-1.13-.12-1.69-.2-.71-.1-1.41-.21-2.11-.33-.55-.1-1.1-.21-1.64-.33-.64-.13-1.27-.28-1.9-.44-.52-.13-1.04-.27-1.55-.41-.07-.02-.14-.04-.2-.06l13.7-30.4c.36-.78,1.47-.78,1.82,0l13.71,30.4Z"
        />
        <path
          className="accent"
          d="m107.07,54.66v38.41c-.17.25-.34.49-.51.73-.14.2-.28.4-.42.59-.31.43-.63.86-.96,1.28-.33.43-.67.85-1.01,1.26-.33.41-.68.82-1.02,1.21-.31.35-.62.7-.94,1.04-.46.5-.92.98-1.4,1.46-.47.48-.96.94-1.45,1.4-.24.23-.49.46-.74.68-.4.36-.8.71-1.21,1.05-.79.67-1.59,1.31-2.42,1.93-.44.33-.88.65-1.33.96-.94.66-1.9,1.29-2.88,1.89-.41.25-.83.5-1.26.74-.42.25-.85.48-1.29.71-.05.03-.09.06-.14.08l-14.24-29.99c-.07-.13-.1-.28-.1-.42l.28-7.08.72-18.32c0-.57.47-1.02,1.04-1l31.28,1.39Z"
        />
        <path
          className="accent"
          d="m106.07,29H20.88c-.55,0-1,.45-1,1v16.24l38.76,1.29c1.41.87,3.06,1.37,4.83,1.37s3.42-.5,4.83-1.37l38.77-1.29v-16.24c0-.55-.45-1-1-1Zm-42.6,17.9c-3.99,0-7.23-3.24-7.23-7.23s3.24-7.23,7.23-7.23,7.24,3.23,7.24,7.23-3.24,7.23-7.24,7.23Z"
        />
      </g>
    </svg>
  );
}

function DefsFunc(props) {
  return (
    <defs>
      <linearGradient
        id={`gradient-${props.number}`}
        x1={props.x1}
        y1={props.y1}
        x2={props.x2}
        y2={props.y2}
      >
        <stop
          offset={props.stopOpacityTwo}
          style={{ stopColor: "var(--nwd-icon-gradient, rgba(0,74,34,1))", stopOpacity: "0%" }}
        />
        <stop
          offset={props.stopOpacityTwo}
          style={{ stopColor: "var(--nwd-icon-gradient, rgba(0,74,34,1))", stopOpacity: "100%" }}
        />
        <stop
          offset={props.stopOpacityOne}
          style={{ stopColor: "var(--nwd-icon-gradient, rgba(0,74,34,1))", stopOpacity: "100%" }}
        />
      </linearGradient>
    </defs>
  );
}

function OneIcon(props) {
  let stopOpacityOneOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityOneTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 126.83 126.83"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityOneOne}
          stopOpacityTwo={stopOpacityOneTwo}
          number="one"
          x1="100%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <rect
            style={{ zIndex: "500" }}
            className="main shaded"
            x="9.29"
            y="9.29"
            width="108.25"
            height="108.25"
            rx="31.71"
            ry="31.71"
            transform="translate(-26.27 63.41) rotate(-45)"
          />
          <rect
            className="gradient-fill-one"
            x="9.29"
            y="9.29"
            width="108.25"
            height="108.25"
            rx="31.71"
            ry="31.71"
            transform="translate(-26.27 63.41) rotate(-45)"
          />
          {!text && (
            <path
              className="accent"
              d="m58.22,46.69h-8.72v-13.16h24.26v59.77h-15.54v-46.61Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function OneIconMob(props) {
  let stopOpacityOneOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityOneTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 126.83 126.83"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityOneOne}
          stopOpacityTwo={stopOpacityOneTwo}
          number="one-mob"
          x1="100%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <rect
            className="main shaded"
            x="9.29"
            y="9.29"
            width="108.25"
            height="108.25"
            rx="31.71"
            ry="31.71"
            transform="translate(-26.27 63.41) rotate(-45)"
          />
          <rect
            className="gradient-fill-one-mob"
            x="9.29"
            y="9.29"
            width="108.25"
            height="108.25"
            rx="31.71"
            ry="31.71"
            transform="translate(-26.27 63.41) rotate(-45)"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m58.22,46.69h-8.72v-13.16h24.26v59.77h-15.54v-46.61Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function TwoIcon(props) {
  let stopOpacityTwoOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityTwoTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 127.41 127.41"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityTwoOne}
          stopOpacityTwo={stopOpacityTwoTwo}
          number="two"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="main shaded"
            d="m118.08,54.38c.37-.37.74-.76,1.09-1.15.14-.15.26-.31.4-.46.21-.24.42-.48.62-.73.17-.2.33-.41.49-.62.16-.2.32-.4.47-.61.17-.23.33-.46.5-.7.13-.19.27-.38.4-.58.16-.24.31-.48.46-.72.13-.2.26-.4.38-.6.14-.23.27-.46.4-.7.13-.22.26-.45.38-.68.11-.21.22-.42.32-.63.13-.26.26-.52.39-.79.08-.18.16-.36.24-.54.14-.31.27-.61.4-.92.06-.14.11-.28.17-.42.14-.35.28-.71.4-1.07.04-.1.07-.2.1-.3.14-.4.27-.8.39-1.21.02-.06.03-.12.05-.18.13-.44.25-.89.36-1.34,0-.02.01-.05.02-.07.59-2.42.9-4.94.9-7.54h0c0-4.22-.83-8.24-2.32-11.93-.01-.03-.02-.05-.03-.08-.18-.44-.37-.87-.56-1.29-.02-.05-.05-.11-.07-.16-.19-.4-.39-.8-.59-1.2-.04-.07-.07-.14-.11-.21-.2-.39-.42-.77-.64-1.14-.04-.08-.09-.15-.13-.23-.23-.39-.47-.77-.71-1.14-.04-.06-.08-.12-.12-.18-.27-.41-.56-.82-.85-1.22-.01-.02-.03-.04-.04-.06-1.92-2.61-4.23-4.92-6.84-6.84-.02-.01-.04-.03-.06-.04-.4-.29-.8-.57-1.22-.85-.06-.04-.12-.08-.18-.12-.37-.24-.75-.48-1.14-.71-.08-.05-.15-.09-.23-.13-.38-.22-.76-.43-1.14-.64-.07-.04-.14-.07-.21-.11-.4-.21-.8-.4-1.2-.59-.05-.02-.11-.05-.16-.07-.43-.2-.86-.38-1.29-.56-.02-.01-.05-.02-.07-.03-3.69-1.49-7.71-2.32-11.93-2.32H31.85C14.26,0,0,14.26,0,31.85h0c0,13.23,8.07,24.58,19.56,29.39.53.22.67.9.27,1.3l-10.49,10.49h0c-.37.38-.74.76-1.09,1.15-.14.15-.27.31-.4.46-.21.24-.42.48-.62.72-.17.21-.33.42-.49.63-.16.2-.31.4-.46.6-.17.23-.33.47-.5.7-.13.19-.27.38-.4.57-.16.24-.31.48-.46.72-.13.2-.26.4-.38.6-.14.23-.27.46-.4.7-.13.22-.26.45-.38.68-.11.21-.22.42-.33.63-.13.26-.26.52-.39.79-.08.18-.16.36-.24.54-.14.3-.27.61-.4.92-.06.14-.11.28-.17.43-.14.35-.27.7-.4,1.06-.04.1-.07.2-.1.3-.14.4-.27.8-.39,1.2-.02.06-.03.12-.05.18-.13.44-.25.89-.36,1.33,0,.02-.01.05-.02.07-.59,2.42-.9,4.94-.9,7.53h0c0,4.22.83,8.24,2.32,11.93.01.03.02.05.03.08.18.44.36.87.56,1.29.02.05.05.11.07.16.19.4.39.8.59,1.2.04.07.07.14.11.22.2.39.42.77.64,1.14.04.08.09.15.13.23.23.39.47.76.71,1.14.04.06.08.12.12.18.27.41.56.82.85,1.22.01.02.03.04.04.06,1.92,2.61,4.23,4.92,6.84,6.84.02.01.04.03.06.04.4.29.81.58,1.22.85.06.04.12.08.18.12.38.25.76.48,1.14.71.08.04.15.09.23.13.38.22.76.43,1.14.64.07.04.14.07.21.11.4.21.79.4,1.2.59.05.02.11.05.16.07.43.2.86.38,1.29.56.03.01.05.02.08.03,3.68,1.49,7.71,2.32,11.93,2.32h63.71c17.59,0,31.85-14.26,31.85-31.85h0c0-13.23-8.07-24.58-19.56-29.39-.53-.22-.67-.9-.27-1.3l10.49-10.49h0Z"
          />
          <path
            className="gradient-fill-two"
            d="m118.08,54.38c.37-.37.74-.76,1.09-1.15.14-.15.26-.31.4-.46.21-.24.42-.48.62-.73.17-.2.33-.41.49-.62.16-.2.32-.4.47-.61.17-.23.33-.46.5-.7.13-.19.27-.38.4-.58.16-.24.31-.48.46-.72.13-.2.26-.4.38-.6.14-.23.27-.46.4-.7.13-.22.26-.45.38-.68.11-.21.22-.42.32-.63.13-.26.26-.52.39-.79.08-.18.16-.36.24-.54.14-.31.27-.61.4-.92.06-.14.11-.28.17-.42.14-.35.28-.71.4-1.07.04-.1.07-.2.1-.3.14-.4.27-.8.39-1.21.02-.06.03-.12.05-.18.13-.44.25-.89.36-1.34,0-.02.01-.05.02-.07.59-2.42.9-4.94.9-7.54h0c0-4.22-.83-8.24-2.32-11.93-.01-.03-.02-.05-.03-.08-.18-.44-.37-.87-.56-1.29-.02-.05-.05-.11-.07-.16-.19-.4-.39-.8-.59-1.2-.04-.07-.07-.14-.11-.21-.2-.39-.42-.77-.64-1.14-.04-.08-.09-.15-.13-.23-.23-.39-.47-.77-.71-1.14-.04-.06-.08-.12-.12-.18-.27-.41-.56-.82-.85-1.22-.01-.02-.03-.04-.04-.06-1.92-2.61-4.23-4.92-6.84-6.84-.02-.01-.04-.03-.06-.04-.4-.29-.8-.57-1.22-.85-.06-.04-.12-.08-.18-.12-.37-.24-.75-.48-1.14-.71-.08-.05-.15-.09-.23-.13-.38-.22-.76-.43-1.14-.64-.07-.04-.14-.07-.21-.11-.4-.21-.8-.4-1.2-.59-.05-.02-.11-.05-.16-.07-.43-.2-.86-.38-1.29-.56-.02-.01-.05-.02-.07-.03-3.69-1.49-7.71-2.32-11.93-2.32H31.85C14.26,0,0,14.26,0,31.85h0c0,13.23,8.07,24.58,19.56,29.39.53.22.67.9.27,1.3l-10.49,10.49h0c-.37.38-.74.76-1.09,1.15-.14.15-.27.31-.4.46-.21.24-.42.48-.62.72-.17.21-.33.42-.49.63-.16.2-.31.4-.46.6-.17.23-.33.47-.5.7-.13.19-.27.38-.4.57-.16.24-.31.48-.46.72-.13.2-.26.4-.38.6-.14.23-.27.46-.4.7-.13.22-.26.45-.38.68-.11.21-.22.42-.33.63-.13.26-.26.52-.39.79-.08.18-.16.36-.24.54-.14.3-.27.61-.4.92-.06.14-.11.28-.17.43-.14.35-.27.7-.4,1.06-.04.1-.07.2-.1.3-.14.4-.27.8-.39,1.2-.02.06-.03.12-.05.18-.13.44-.25.89-.36,1.33,0,.02-.01.05-.02.07-.59,2.42-.9,4.94-.9,7.53h0c0,4.22.83,8.24,2.32,11.93.01.03.02.05.03.08.18.44.36.87.56,1.29.02.05.05.11.07.16.19.4.39.8.59,1.2.04.07.07.14.11.22.2.39.42.77.64,1.14.04.08.09.15.13.23.23.39.47.76.71,1.14.04.06.08.12.12.18.27.41.56.82.85,1.22.01.02.03.04.04.06,1.92,2.61,4.23,4.92,6.84,6.84.02.01.04.03.06.04.4.29.81.58,1.22.85.06.04.12.08.18.12.38.25.76.48,1.14.71.08.04.15.09.23.13.38.22.76.43,1.14.64.07.04.14.07.21.11.4.21.79.4,1.2.59.05.02.11.05.16.07.43.2.86.38,1.29.56.03.01.05.02.08.03,3.68,1.49,7.71,2.32,11.93,2.32h63.71c17.59,0,31.85-14.26,31.85-31.85h0c0-13.23-8.07-24.58-19.56-29.39-.53-.22-.67-.9-.27-1.3l10.49-10.49h0Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m87.88,94.52h-48.34l14.89-15.45c3.93-4.09,7.01-7.55,9.24-10.39,2.23-2.84,3.89-5.24,4.98-7.21,1.09-1.96,1.76-3.56,2.03-4.78.27-1.22.4-2.26.4-3.11,0-.9-.15-1.78-.44-2.63-.29-.85-.73-1.61-1.31-2.27-.58-.66-1.29-1.19-2.11-1.59-.82-.4-1.79-.6-2.91-.6-2.12,0-3.78.69-4.98,2.07-1.19,1.38-1.79,3.11-1.79,5.18,0,.58.08,1.43.24,2.55h-17.04c0-3.5.57-6.69,1.71-9.56,1.14-2.87,2.75-5.34,4.82-7.41s4.53-3.66,7.37-4.78c2.84-1.11,5.96-1.67,9.36-1.67s6.44.53,9.28,1.59c2.84,1.06,5.3,2.55,7.37,4.46,2.07,1.91,3.69,4.18,4.86,6.81,1.17,2.63,1.75,5.48,1.75,8.56,0,3.29-.7,6.33-2.11,9.12-1.41,2.79-3.65,5.64-6.73,8.56l-9.95,9.32h19.43v13.22Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function TwoIconMob(props) {
  let stopOpacityTwoOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityTwoTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 127.41 127.41"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityTwoOne}
          stopOpacityTwo={stopOpacityTwoTwo}
          number="two-mob"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="main shaded"
            d="m118.08,54.38c.37-.37.74-.76,1.09-1.15.14-.15.26-.31.4-.46.21-.24.42-.48.62-.73.17-.2.33-.41.49-.62.16-.2.32-.4.47-.61.17-.23.33-.46.5-.7.13-.19.27-.38.4-.58.16-.24.31-.48.46-.72.13-.2.26-.4.38-.6.14-.23.27-.46.4-.7.13-.22.26-.45.38-.68.11-.21.22-.42.32-.63.13-.26.26-.52.39-.79.08-.18.16-.36.24-.54.14-.31.27-.61.4-.92.06-.14.11-.28.17-.42.14-.35.28-.71.4-1.07.04-.1.07-.2.1-.3.14-.4.27-.8.39-1.21.02-.06.03-.12.05-.18.13-.44.25-.89.36-1.34,0-.02.01-.05.02-.07.59-2.42.9-4.94.9-7.54h0c0-4.22-.83-8.24-2.32-11.93-.01-.03-.02-.05-.03-.08-.18-.44-.37-.87-.56-1.29-.02-.05-.05-.11-.07-.16-.19-.4-.39-.8-.59-1.2-.04-.07-.07-.14-.11-.21-.2-.39-.42-.77-.64-1.14-.04-.08-.09-.15-.13-.23-.23-.39-.47-.77-.71-1.14-.04-.06-.08-.12-.12-.18-.27-.41-.56-.82-.85-1.22-.01-.02-.03-.04-.04-.06-1.92-2.61-4.23-4.92-6.84-6.84-.02-.01-.04-.03-.06-.04-.4-.29-.8-.57-1.22-.85-.06-.04-.12-.08-.18-.12-.37-.24-.75-.48-1.14-.71-.08-.05-.15-.09-.23-.13-.38-.22-.76-.43-1.14-.64-.07-.04-.14-.07-.21-.11-.4-.21-.8-.4-1.2-.59-.05-.02-.11-.05-.16-.07-.43-.2-.86-.38-1.29-.56-.02-.01-.05-.02-.07-.03-3.69-1.49-7.71-2.32-11.93-2.32H31.85C14.26,0,0,14.26,0,31.85h0c0,13.23,8.07,24.58,19.56,29.39.53.22.67.9.27,1.3l-10.49,10.49h0c-.37.38-.74.76-1.09,1.15-.14.15-.27.31-.4.46-.21.24-.42.48-.62.72-.17.21-.33.42-.49.63-.16.2-.31.4-.46.6-.17.23-.33.47-.5.7-.13.19-.27.38-.4.57-.16.24-.31.48-.46.72-.13.2-.26.4-.38.6-.14.23-.27.46-.4.7-.13.22-.26.45-.38.68-.11.21-.22.42-.33.63-.13.26-.26.52-.39.79-.08.18-.16.36-.24.54-.14.3-.27.61-.4.92-.06.14-.11.28-.17.43-.14.35-.27.7-.4,1.06-.04.1-.07.2-.1.3-.14.4-.27.8-.39,1.2-.02.06-.03.12-.05.18-.13.44-.25.89-.36,1.33,0,.02-.01.05-.02.07-.59,2.42-.9,4.94-.9,7.53h0c0,4.22.83,8.24,2.32,11.93.01.03.02.05.03.08.18.44.36.87.56,1.29.02.05.05.11.07.16.19.4.39.8.59,1.2.04.07.07.14.11.22.2.39.42.77.64,1.14.04.08.09.15.13.23.23.39.47.76.71,1.14.04.06.08.12.12.18.27.41.56.82.85,1.22.01.02.03.04.04.06,1.92,2.61,4.23,4.92,6.84,6.84.02.01.04.03.06.04.4.29.81.58,1.22.85.06.04.12.08.18.12.38.25.76.48,1.14.71.08.04.15.09.23.13.38.22.76.43,1.14.64.07.04.14.07.21.11.4.21.79.4,1.2.59.05.02.11.05.16.07.43.2.86.38,1.29.56.03.01.05.02.08.03,3.68,1.49,7.71,2.32,11.93,2.32h63.71c17.59,0,31.85-14.26,31.85-31.85h0c0-13.23-8.07-24.58-19.56-29.39-.53-.22-.67-.9-.27-1.3l10.49-10.49h0Z"
          />
          <path
            className="gradient-fill-two-mob"
            d="m118.08,54.38c.37-.37.74-.76,1.09-1.15.14-.15.26-.31.4-.46.21-.24.42-.48.62-.73.17-.2.33-.41.49-.62.16-.2.32-.4.47-.61.17-.23.33-.46.5-.7.13-.19.27-.38.4-.58.16-.24.31-.48.46-.72.13-.2.26-.4.38-.6.14-.23.27-.46.4-.7.13-.22.26-.45.38-.68.11-.21.22-.42.32-.63.13-.26.26-.52.39-.79.08-.18.16-.36.24-.54.14-.31.27-.61.4-.92.06-.14.11-.28.17-.42.14-.35.28-.71.4-1.07.04-.1.07-.2.1-.3.14-.4.27-.8.39-1.21.02-.06.03-.12.05-.18.13-.44.25-.89.36-1.34,0-.02.01-.05.02-.07.59-2.42.9-4.94.9-7.54h0c0-4.22-.83-8.24-2.32-11.93-.01-.03-.02-.05-.03-.08-.18-.44-.37-.87-.56-1.29-.02-.05-.05-.11-.07-.16-.19-.4-.39-.8-.59-1.2-.04-.07-.07-.14-.11-.21-.2-.39-.42-.77-.64-1.14-.04-.08-.09-.15-.13-.23-.23-.39-.47-.77-.71-1.14-.04-.06-.08-.12-.12-.18-.27-.41-.56-.82-.85-1.22-.01-.02-.03-.04-.04-.06-1.92-2.61-4.23-4.92-6.84-6.84-.02-.01-.04-.03-.06-.04-.4-.29-.8-.57-1.22-.85-.06-.04-.12-.08-.18-.12-.37-.24-.75-.48-1.14-.71-.08-.05-.15-.09-.23-.13-.38-.22-.76-.43-1.14-.64-.07-.04-.14-.07-.21-.11-.4-.21-.8-.4-1.2-.59-.05-.02-.11-.05-.16-.07-.43-.2-.86-.38-1.29-.56-.02-.01-.05-.02-.07-.03-3.69-1.49-7.71-2.32-11.93-2.32H31.85C14.26,0,0,14.26,0,31.85h0c0,13.23,8.07,24.58,19.56,29.39.53.22.67.9.27,1.3l-10.49,10.49h0c-.37.38-.74.76-1.09,1.15-.14.15-.27.31-.4.46-.21.24-.42.48-.62.72-.17.21-.33.42-.49.63-.16.2-.31.4-.46.6-.17.23-.33.47-.5.7-.13.19-.27.38-.4.57-.16.24-.31.48-.46.72-.13.2-.26.4-.38.6-.14.23-.27.46-.4.7-.13.22-.26.45-.38.68-.11.21-.22.42-.33.63-.13.26-.26.52-.39.79-.08.18-.16.36-.24.54-.14.3-.27.61-.4.92-.06.14-.11.28-.17.43-.14.35-.27.7-.4,1.06-.04.1-.07.2-.1.3-.14.4-.27.8-.39,1.2-.02.06-.03.12-.05.18-.13.44-.25.89-.36,1.33,0,.02-.01.05-.02.07-.59,2.42-.9,4.94-.9,7.53h0c0,4.22.83,8.24,2.32,11.93.01.03.02.05.03.08.18.44.36.87.56,1.29.02.05.05.11.07.16.19.4.39.8.59,1.2.04.07.07.14.11.22.2.39.42.77.64,1.14.04.08.09.15.13.23.23.39.47.76.71,1.14.04.06.08.12.12.18.27.41.56.82.85,1.22.01.02.03.04.04.06,1.92,2.61,4.23,4.92,6.84,6.84.02.01.04.03.06.04.4.29.81.58,1.22.85.06.04.12.08.18.12.38.25.76.48,1.14.71.08.04.15.09.23.13.38.22.76.43,1.14.64.07.04.14.07.21.11.4.21.79.4,1.2.59.05.02.11.05.16.07.43.2.86.38,1.29.56.03.01.05.02.08.03,3.68,1.49,7.71,2.32,11.93,2.32h63.71c17.59,0,31.85-14.26,31.85-31.85h0c0-13.23-8.07-24.58-19.56-29.39-.53-.22-.67-.9-.27-1.3l10.49-10.49h0Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m87.88,94.52h-48.34l14.89-15.45c3.93-4.09,7.01-7.55,9.24-10.39,2.23-2.84,3.89-5.24,4.98-7.21,1.09-1.96,1.76-3.56,2.03-4.78.27-1.22.4-2.26.4-3.11,0-.9-.15-1.78-.44-2.63-.29-.85-.73-1.61-1.31-2.27-.58-.66-1.29-1.19-2.11-1.59-.82-.4-1.79-.6-2.91-.6-2.12,0-3.78.69-4.98,2.07-1.19,1.38-1.79,3.11-1.79,5.18,0,.58.08,1.43.24,2.55h-17.04c0-3.5.57-6.69,1.71-9.56,1.14-2.87,2.75-5.34,4.82-7.41s4.53-3.66,7.37-4.78c2.84-1.11,5.96-1.67,9.36-1.67s6.44.53,9.28,1.59c2.84,1.06,5.3,2.55,7.37,4.46,2.07,1.91,3.69,4.18,4.86,6.81,1.17,2.63,1.75,5.48,1.75,8.56,0,3.29-.7,6.33-2.11,9.12-1.41,2.79-3.65,5.64-6.73,8.56l-9.95,9.32h19.43v13.22Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function ThreeIcon(props) {
  let stopOpacityThreeOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityThreeTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 127.35 127.35"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityThreeOne}
          stopOpacityTwo={stopOpacityThreeTwo}
          number="three"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="main shaded"
            d="m127.35,3.98c0-2.2-1.78-3.98-3.98-3.98H31.84c-4.22,0-8.24.83-11.92,2.32-.03.01-.05.02-.08.03-.44.18-.87.36-1.29.56-.05.02-.11.05-.16.07-.41.19-.8.39-1.2.59-.07.04-.14.07-.21.11-.39.2-.77.42-1.14.64-.08.04-.15.09-.23.13-.39.23-.77.47-1.14.71-.06.04-.12.08-.18.12-.41.27-.82.56-1.22.85-.02.01-.04.03-.06.04-2.61,1.92-4.92,4.23-6.84,6.84-.01.02-.03.04-.04.06-.29.4-.58.81-.85,1.22-.04.06-.08.12-.12.18-.25.38-.48.76-.71,1.14-.04.07-.09.15-.13.22-.22.38-.43.76-.64,1.14-.04.07-.07.14-.11.21-.21.4-.4.8-.59,1.2-.02.05-.05.1-.07.16-.2.43-.38.86-.56,1.29-.01.03-.02.05-.03.08-1.49,3.68-2.32,7.7-2.32,11.92h0c0,2.6.32,5.12.9,7.53,0,.02.01.05.02.07.11.45.23.9.36,1.34.02.06.03.12.05.18.12.41.25.81.39,1.21.03.1.07.2.1.3.13.36.26.71.4,1.07.06.14.11.28.17.42.13.31.26.62.4.92.08.18.16.36.24.53.13.27.26.53.39.79.11.21.21.42.32.63.12.23.25.45.38.68.13.23.26.46.4.69.12.2.25.4.38.61.15.24.3.48.46.72.13.2.27.39.4.58.16.23.32.47.49.7.15.21.31.4.47.61.16.21.32.42.49.62.2.25.42.49.63.73.13.15.26.3.39.45.35.39.72.77,1.09,1.15,0,0,0,0,0,0l7.96,7.96c.5.5.15,1.36-.56,1.36H3.98C1.78,63.67,0,65.46,0,67.65v55.71c0,2.2,1.78,3.98,3.98,3.98h91.53c4.22,0,8.24-.83,11.92-2.32.03-.01.05-.02.08-.03.43-.18.86-.36,1.29-.56.05-.02.11-.05.16-.07.4-.19.8-.39,1.2-.59.07-.04.15-.07.22-.11.38-.2.76-.42,1.14-.64.08-.04.15-.09.23-.13.38-.23.76-.47,1.14-.71.06-.04.12-.08.19-.12.41-.27.82-.56,1.22-.85.02-.01.04-.03.06-.04,2.61-1.92,4.92-4.23,6.84-6.84.01-.02.03-.04.04-.06.29-.4.57-.8.85-1.22.04-.06.08-.12.12-.19.24-.37.48-.75.71-1.14.05-.08.09-.15.13-.23.22-.38.43-.75.64-1.14.04-.07.07-.14.11-.21.21-.4.4-.79.59-1.2.02-.05.05-.11.07-.16.2-.43.38-.85.56-1.29.01-.03.02-.05.03-.08,1.49-3.68,2.32-7.7,2.32-11.92h0c0-2.59-.32-5.11-.9-7.53,0-.02-.01-.05-.02-.07-.11-.45-.23-.89-.36-1.33-.02-.06-.03-.12-.05-.18-.12-.41-.25-.81-.39-1.21-.03-.1-.07-.2-.1-.3-.13-.36-.26-.71-.4-1.07-.06-.14-.11-.28-.17-.42-.13-.31-.26-.62-.4-.92-.08-.18-.16-.36-.24-.54-.13-.27-.26-.53-.39-.79-.11-.21-.21-.42-.32-.63-.12-.23-.25-.45-.38-.68-.13-.23-.26-.46-.4-.69-.12-.2-.25-.4-.38-.61-.15-.24-.3-.48-.46-.72-.13-.19-.27-.38-.4-.58-.16-.23-.33-.47-.5-.7-.15-.2-.31-.4-.47-.6-.16-.21-.32-.42-.49-.62-.2-.25-.41-.49-.62-.73-.13-.15-.26-.31-.4-.46-.35-.39-.72-.77-1.09-1.15,0,0,0,0,0,0l-7.96-7.96c-.5-.5-.15-1.36.56-1.36h12.75c2.2,0,3.98-1.78,3.98-3.98V3.98Z"
          />
          <path
            className="gradient-fill-three"
            d="m127.35,3.98c0-2.2-1.78-3.98-3.98-3.98H31.84c-4.22,0-8.24.83-11.92,2.32-.03.01-.05.02-.08.03-.44.18-.87.36-1.29.56-.05.02-.11.05-.16.07-.41.19-.8.39-1.2.59-.07.04-.14.07-.21.11-.39.2-.77.42-1.14.64-.08.04-.15.09-.23.13-.39.23-.77.47-1.14.71-.06.04-.12.08-.18.12-.41.27-.82.56-1.22.85-.02.01-.04.03-.06.04-2.61,1.92-4.92,4.23-6.84,6.84-.01.02-.03.04-.04.06-.29.4-.58.81-.85,1.22-.04.06-.08.12-.12.18-.25.38-.48.76-.71,1.14-.04.07-.09.15-.13.22-.22.38-.43.76-.64,1.14-.04.07-.07.14-.11.21-.21.4-.4.8-.59,1.2-.02.05-.05.1-.07.16-.2.43-.38.86-.56,1.29-.01.03-.02.05-.03.08-1.49,3.68-2.32,7.7-2.32,11.92h0c0,2.6.32,5.12.9,7.53,0,.02.01.05.02.07.11.45.23.9.36,1.34.02.06.03.12.05.18.12.41.25.81.39,1.21.03.1.07.2.1.3.13.36.26.71.4,1.07.06.14.11.28.17.42.13.31.26.62.4.92.08.18.16.36.24.53.13.27.26.53.39.79.11.21.21.42.32.63.12.23.25.45.38.68.13.23.26.46.4.69.12.2.25.4.38.61.15.24.3.48.46.72.13.2.27.39.4.58.16.23.32.47.49.7.15.21.31.4.47.61.16.21.32.42.49.62.2.25.42.49.63.73.13.15.26.3.39.45.35.39.72.77,1.09,1.15,0,0,0,0,0,0l7.96,7.96c.5.5.15,1.36-.56,1.36H3.98C1.78,63.67,0,65.46,0,67.65v55.71c0,2.2,1.78,3.98,3.98,3.98h91.53c4.22,0,8.24-.83,11.92-2.32.03-.01.05-.02.08-.03.43-.18.86-.36,1.29-.56.05-.02.11-.05.16-.07.4-.19.8-.39,1.2-.59.07-.04.15-.07.22-.11.38-.2.76-.42,1.14-.64.08-.04.15-.09.23-.13.38-.23.76-.47,1.14-.71.06-.04.12-.08.19-.12.41-.27.82-.56,1.22-.85.02-.01.04-.03.06-.04,2.61-1.92,4.92-4.23,6.84-6.84.01-.02.03-.04.04-.06.29-.4.57-.8.85-1.22.04-.06.08-.12.12-.19.24-.37.48-.75.71-1.14.05-.08.09-.15.13-.23.22-.38.43-.75.64-1.14.04-.07.07-.14.11-.21.21-.4.4-.79.59-1.2.02-.05.05-.11.07-.16.2-.43.38-.85.56-1.29.01-.03.02-.05.03-.08,1.49-3.68,2.32-7.7,2.32-11.92h0c0-2.59-.32-5.11-.9-7.53,0-.02-.01-.05-.02-.07-.11-.45-.23-.89-.36-1.33-.02-.06-.03-.12-.05-.18-.12-.41-.25-.81-.39-1.21-.03-.1-.07-.2-.1-.3-.13-.36-.26-.71-.4-1.07-.06-.14-.11-.28-.17-.42-.13-.31-.26-.62-.4-.92-.08-.18-.16-.36-.24-.54-.13-.27-.26-.53-.39-.79-.11-.21-.21-.42-.32-.63-.12-.23-.25-.45-.38-.68-.13-.23-.26-.46-.4-.69-.12-.2-.25-.4-.38-.61-.15-.24-.3-.48-.46-.72-.13-.19-.27-.38-.4-.58-.16-.23-.33-.47-.5-.7-.15-.2-.31-.4-.47-.6-.16-.21-.32-.42-.49-.62-.2-.25-.41-.49-.62-.73-.13-.15-.26-.31-.4-.46-.35-.39-.72-.77-1.09-1.15,0,0,0,0,0,0l-7.96-7.96c-.5-.5-.15-1.36.56-1.36h12.75c2.2,0,3.98-1.78,3.98-3.98V3.98Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m61.05,57.07c.42.05.78.08,1.07.08h.76c1.96,0,3.55-.58,4.78-1.75,1.22-1.17,1.83-2.68,1.83-4.54s-.57-3.26-1.71-4.38c-1.14-1.11-2.61-1.67-4.42-1.67-1.91,0-3.45.64-4.62,1.91-1.17,1.27-1.75,2.92-1.75,4.93h-14.41c.37-3.13,1.15-5.92,2.35-8.36,1.19-2.44,2.72-4.5,4.58-6.17,1.86-1.67,4.03-2.94,6.53-3.82,2.49-.88,5.25-1.31,8.28-1.31s5.66.41,8.08,1.23c2.41.82,4.48,1.99,6.21,3.5,1.72,1.51,3.05,3.34,3.98,5.49.93,2.15,1.39,4.55,1.39,7.2,0,2.87-.54,5.21-1.63,7.04-1.09,1.83-2.64,3.41-4.66,4.74,3.08.96,5.48,2.67,7.2,5.13,1.72,2.47,2.59,5.51,2.59,9.11,0,2.97-.58,5.68-1.75,8.12-1.17,2.44-2.8,4.54-4.89,6.29-2.1,1.75-4.59,3.1-7.48,4.06-2.89.96-6.06,1.43-9.51,1.43-4.62,0-8.78-.9-12.5-2.71-3.71-1.8-6.69-4.67-8.91-8.6-1.01-1.75-1.69-3.5-2.03-5.25-.35-1.75-.52-3.53-.52-5.33h15.44c.11,2.81.93,4.95,2.47,6.41,1.54,1.46,3.61,2.19,6.21,2.19,2.76,0,4.78-.74,6.05-2.23,1.27-1.48,1.91-3.32,1.91-5.49,0-2.6-.77-4.56-2.31-5.89-1.54-1.33-3.37-1.99-5.49-1.99-.53,0-1.03.04-1.51.12s-1.01.17-1.59.28v-9.79Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function ThreeIconMob(props) {
  let stopOpacityThreeOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityThreeTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 127.35 127.35"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityThreeOne}
          stopOpacityTwo={stopOpacityThreeTwo}
          number="three-mob"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="main shaded"
            d="m127.35,3.98c0-2.2-1.78-3.98-3.98-3.98H31.84c-4.22,0-8.24.83-11.92,2.32-.03.01-.05.02-.08.03-.44.18-.87.36-1.29.56-.05.02-.11.05-.16.07-.41.19-.8.39-1.2.59-.07.04-.14.07-.21.11-.39.2-.77.42-1.14.64-.08.04-.15.09-.23.13-.39.23-.77.47-1.14.71-.06.04-.12.08-.18.12-.41.27-.82.56-1.22.85-.02.01-.04.03-.06.04-2.61,1.92-4.92,4.23-6.84,6.84-.01.02-.03.04-.04.06-.29.4-.58.81-.85,1.22-.04.06-.08.12-.12.18-.25.38-.48.76-.71,1.14-.04.07-.09.15-.13.22-.22.38-.43.76-.64,1.14-.04.07-.07.14-.11.21-.21.4-.4.8-.59,1.2-.02.05-.05.1-.07.16-.2.43-.38.86-.56,1.29-.01.03-.02.05-.03.08-1.49,3.68-2.32,7.7-2.32,11.92h0c0,2.6.32,5.12.9,7.53,0,.02.01.05.02.07.11.45.23.9.36,1.34.02.06.03.12.05.18.12.41.25.81.39,1.21.03.1.07.2.1.3.13.36.26.71.4,1.07.06.14.11.28.17.42.13.31.26.62.4.92.08.18.16.36.24.53.13.27.26.53.39.79.11.21.21.42.32.63.12.23.25.45.38.68.13.23.26.46.4.69.12.2.25.4.38.61.15.24.3.48.46.72.13.2.27.39.4.58.16.23.32.47.49.7.15.21.31.4.47.61.16.21.32.42.49.62.2.25.42.49.63.73.13.15.26.3.39.45.35.39.72.77,1.09,1.15,0,0,0,0,0,0l7.96,7.96c.5.5.15,1.36-.56,1.36H3.98C1.78,63.67,0,65.46,0,67.65v55.71c0,2.2,1.78,3.98,3.98,3.98h91.53c4.22,0,8.24-.83,11.92-2.32.03-.01.05-.02.08-.03.43-.18.86-.36,1.29-.56.05-.02.11-.05.16-.07.4-.19.8-.39,1.2-.59.07-.04.15-.07.22-.11.38-.2.76-.42,1.14-.64.08-.04.15-.09.23-.13.38-.23.76-.47,1.14-.71.06-.04.12-.08.19-.12.41-.27.82-.56,1.22-.85.02-.01.04-.03.06-.04,2.61-1.92,4.92-4.23,6.84-6.84.01-.02.03-.04.04-.06.29-.4.57-.8.85-1.22.04-.06.08-.12.12-.19.24-.37.48-.75.71-1.14.05-.08.09-.15.13-.23.22-.38.43-.75.64-1.14.04-.07.07-.14.11-.21.21-.4.4-.79.59-1.2.02-.05.05-.11.07-.16.2-.43.38-.85.56-1.29.01-.03.02-.05.03-.08,1.49-3.68,2.32-7.7,2.32-11.92h0c0-2.59-.32-5.11-.9-7.53,0-.02-.01-.05-.02-.07-.11-.45-.23-.89-.36-1.33-.02-.06-.03-.12-.05-.18-.12-.41-.25-.81-.39-1.21-.03-.1-.07-.2-.1-.3-.13-.36-.26-.71-.4-1.07-.06-.14-.11-.28-.17-.42-.13-.31-.26-.62-.4-.92-.08-.18-.16-.36-.24-.54-.13-.27-.26-.53-.39-.79-.11-.21-.21-.42-.32-.63-.12-.23-.25-.45-.38-.68-.13-.23-.26-.46-.4-.69-.12-.2-.25-.4-.38-.61-.15-.24-.3-.48-.46-.72-.13-.19-.27-.38-.4-.58-.16-.23-.33-.47-.5-.7-.15-.2-.31-.4-.47-.6-.16-.21-.32-.42-.49-.62-.2-.25-.41-.49-.62-.73-.13-.15-.26-.31-.4-.46-.35-.39-.72-.77-1.09-1.15,0,0,0,0,0,0l-7.96-7.96c-.5-.5-.15-1.36.56-1.36h12.75c2.2,0,3.98-1.78,3.98-3.98V3.98Z"
          />
          <path
            className="gradient-fill-three-mob"
            d="m127.35,3.98c0-2.2-1.78-3.98-3.98-3.98H31.84c-4.22,0-8.24.83-11.92,2.32-.03.01-.05.02-.08.03-.44.18-.87.36-1.29.56-.05.02-.11.05-.16.07-.41.19-.8.39-1.2.59-.07.04-.14.07-.21.11-.39.2-.77.42-1.14.64-.08.04-.15.09-.23.13-.39.23-.77.47-1.14.71-.06.04-.12.08-.18.12-.41.27-.82.56-1.22.85-.02.01-.04.03-.06.04-2.61,1.92-4.92,4.23-6.84,6.84-.01.02-.03.04-.04.06-.29.4-.58.81-.85,1.22-.04.06-.08.12-.12.18-.25.38-.48.76-.71,1.14-.04.07-.09.15-.13.22-.22.38-.43.76-.64,1.14-.04.07-.07.14-.11.21-.21.4-.4.8-.59,1.2-.02.05-.05.1-.07.16-.2.43-.38.86-.56,1.29-.01.03-.02.05-.03.08-1.49,3.68-2.32,7.7-2.32,11.92h0c0,2.6.32,5.12.9,7.53,0,.02.01.05.02.07.11.45.23.9.36,1.34.02.06.03.12.05.18.12.41.25.81.39,1.21.03.1.07.2.1.3.13.36.26.71.4,1.07.06.14.11.28.17.42.13.31.26.62.4.92.08.18.16.36.24.53.13.27.26.53.39.79.11.21.21.42.32.63.12.23.25.45.38.68.13.23.26.46.4.69.12.2.25.4.38.61.15.24.3.48.46.72.13.2.27.39.4.58.16.23.32.47.49.7.15.21.31.4.47.61.16.21.32.42.49.62.2.25.42.49.63.73.13.15.26.3.39.45.35.39.72.77,1.09,1.15,0,0,0,0,0,0l7.96,7.96c.5.5.15,1.36-.56,1.36H3.98C1.78,63.67,0,65.46,0,67.65v55.71c0,2.2,1.78,3.98,3.98,3.98h91.53c4.22,0,8.24-.83,11.92-2.32.03-.01.05-.02.08-.03.43-.18.86-.36,1.29-.56.05-.02.11-.05.16-.07.4-.19.8-.39,1.2-.59.07-.04.15-.07.22-.11.38-.2.76-.42,1.14-.64.08-.04.15-.09.23-.13.38-.23.76-.47,1.14-.71.06-.04.12-.08.19-.12.41-.27.82-.56,1.22-.85.02-.01.04-.03.06-.04,2.61-1.92,4.92-4.23,6.84-6.84.01-.02.03-.04.04-.06.29-.4.57-.8.85-1.22.04-.06.08-.12.12-.19.24-.37.48-.75.71-1.14.05-.08.09-.15.13-.23.22-.38.43-.75.64-1.14.04-.07.07-.14.11-.21.21-.4.4-.79.59-1.2.02-.05.05-.11.07-.16.2-.43.38-.85.56-1.29.01-.03.02-.05.03-.08,1.49-3.68,2.32-7.7,2.32-11.92h0c0-2.59-.32-5.11-.9-7.53,0-.02-.01-.05-.02-.07-.11-.45-.23-.89-.36-1.33-.02-.06-.03-.12-.05-.18-.12-.41-.25-.81-.39-1.21-.03-.1-.07-.2-.1-.3-.13-.36-.26-.71-.4-1.07-.06-.14-.11-.28-.17-.42-.13-.31-.26-.62-.4-.92-.08-.18-.16-.36-.24-.54-.13-.27-.26-.53-.39-.79-.11-.21-.21-.42-.32-.63-.12-.23-.25-.45-.38-.68-.13-.23-.26-.46-.4-.69-.12-.2-.25-.4-.38-.61-.15-.24-.3-.48-.46-.72-.13-.19-.27-.38-.4-.58-.16-.23-.33-.47-.5-.7-.15-.2-.31-.4-.47-.6-.16-.21-.32-.42-.49-.62-.2-.25-.41-.49-.62-.73-.13-.15-.26-.31-.4-.46-.35-.39-.72-.77-1.09-1.15,0,0,0,0,0,0l-7.96-7.96c-.5-.5-.15-1.36.56-1.36h12.75c2.2,0,3.98-1.78,3.98-3.98V3.98Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m61.05,57.07c.42.05.78.08,1.07.08h.76c1.96,0,3.55-.58,4.78-1.75,1.22-1.17,1.83-2.68,1.83-4.54s-.57-3.26-1.71-4.38c-1.14-1.11-2.61-1.67-4.42-1.67-1.91,0-3.45.64-4.62,1.91-1.17,1.27-1.75,2.92-1.75,4.93h-14.41c.37-3.13,1.15-5.92,2.35-8.36,1.19-2.44,2.72-4.5,4.58-6.17,1.86-1.67,4.03-2.94,6.53-3.82,2.49-.88,5.25-1.31,8.28-1.31s5.66.41,8.08,1.23c2.41.82,4.48,1.99,6.21,3.5,1.72,1.51,3.05,3.34,3.98,5.49.93,2.15,1.39,4.55,1.39,7.2,0,2.87-.54,5.21-1.63,7.04-1.09,1.83-2.64,3.41-4.66,4.74,3.08.96,5.48,2.67,7.2,5.13,1.72,2.47,2.59,5.51,2.59,9.11,0,2.97-.58,5.68-1.75,8.12-1.17,2.44-2.8,4.54-4.89,6.29-2.1,1.75-4.59,3.1-7.48,4.06-2.89.96-6.06,1.43-9.51,1.43-4.62,0-8.78-.9-12.5-2.71-3.71-1.8-6.69-4.67-8.91-8.6-1.01-1.75-1.69-3.5-2.03-5.25-.35-1.75-.52-3.53-.52-5.33h15.44c.11,2.81.93,4.95,2.47,6.41,1.54,1.46,3.61,2.19,6.21,2.19,2.76,0,4.78-.74,6.05-2.23,1.27-1.48,1.91-3.32,1.91-5.49,0-2.6-.77-4.56-2.31-5.89-1.54-1.33-3.37-1.99-5.49-1.99-.53,0-1.03.04-1.51.12s-1.01.17-1.59.28v-9.79Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function FourIcon(props) {
  let stopOpacityFourOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityFourTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128.03 128"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityFourOne}
          stopOpacityTwo={stopOpacityFourTwo}
          number="four"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="main shaded"
            d="m128.03,40.07C128.03,17.89,110.13,0,87.95,0c-7.85,0-15.16,2.25-21.34,6.15-1.62,1.02-3.65,1.02-5.27,0C55.16,2.25,47.85,0,40.01,0,17.86,0,.03,17.85.03,39.99c0,7.84,2.26,15.16,6.16,21.34,1.02,1.62,1.02,3.65,0,5.26C2.27,72.78,0,80.11,0,87.98c0,22.16,17.83,40.01,40,40.02,7.86,0,15.19-2.26,21.38-6.17,1.62-1.02,3.65-1.02,5.27,0,6.18,3.91,13.5,6.17,21.36,6.17,22.15,0,40-17.83,40.02-39.99,0-7.84-2.24-15.16-6.14-21.34-1.02-1.62-1.02-3.64,0-5.26,3.89-6.18,6.14-13.49,6.14-21.33Z"
          />
          <path
            className="gradient-fill-four"
            d="m128.03,40.07C128.03,17.89,110.13,0,87.95,0c-7.85,0-15.16,2.25-21.34,6.15-1.62,1.02-3.65,1.02-5.27,0C55.16,2.25,47.85,0,40.01,0,17.86,0,.03,17.85.03,39.99c0,7.84,2.26,15.16,6.16,21.34,1.02,1.62,1.02,3.65,0,5.26C2.27,72.78,0,80.11,0,87.98c0,22.16,17.83,40.01,40,40.02,7.86,0,15.19-2.26,21.38-6.17,1.62-1.02,3.65-1.02,5.27,0,6.18,3.91,13.5,6.17,21.36,6.17,22.15,0,40-17.83,40.02-39.99,0-7.84-2.24-15.16-6.14-21.34-1.02-1.62-1.02-3.64,0-5.26,3.89-6.18,6.14-13.49,6.14-21.33Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m80.96,69.97h7.55v12.45h-7.55v12.86h-15.1v-12.86h-30.2v-10.45l23.9-39.25h21.41v37.25Zm-15.1,0v-24.64l-14.35,24.64h14.35Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function FourIconMob(props) {
  let stopOpacityFourOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityFourTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128.03 128"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityFourOne}
          stopOpacityTwo={stopOpacityFourTwo}
          number="four-mob"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="main shaded"
            d="m128.03,40.07C128.03,17.89,110.13,0,87.95,0c-7.85,0-15.16,2.25-21.34,6.15-1.62,1.02-3.65,1.02-5.27,0C55.16,2.25,47.85,0,40.01,0,17.86,0,.03,17.85.03,39.99c0,7.84,2.26,15.16,6.16,21.34,1.02,1.62,1.02,3.65,0,5.26C2.27,72.78,0,80.11,0,87.98c0,22.16,17.83,40.01,40,40.02,7.86,0,15.19-2.26,21.38-6.17,1.62-1.02,3.65-1.02,5.27,0,6.18,3.91,13.5,6.17,21.36,6.17,22.15,0,40-17.83,40.02-39.99,0-7.84-2.24-15.16-6.14-21.34-1.02-1.62-1.02-3.64,0-5.26,3.89-6.18,6.14-13.49,6.14-21.33Z"
          />
          <path
            className="gradient-fill-four-mob"
            d="m128.03,40.07C128.03,17.89,110.13,0,87.95,0c-7.85,0-15.16,2.25-21.34,6.15-1.62,1.02-3.65,1.02-5.27,0C55.16,2.25,47.85,0,40.01,0,17.86,0,.03,17.85.03,39.99c0,7.84,2.26,15.16,6.16,21.34,1.02,1.62,1.02,3.65,0,5.26C2.27,72.78,0,80.11,0,87.98c0,22.16,17.83,40.01,40,40.02,7.86,0,15.19-2.26,21.38-6.17,1.62-1.02,3.65-1.02,5.27,0,6.18,3.91,13.5,6.17,21.36,6.17,22.15,0,40-17.83,40.02-39.99,0-7.84-2.24-15.16-6.14-21.34-1.02-1.62-1.02-3.64,0-5.26,3.89-6.18,6.14-13.49,6.14-21.33Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m80.96,69.97h7.55v12.45h-7.55v12.86h-15.1v-12.86h-30.2v-10.45l23.9-39.25h21.41v37.25Zm-15.1,0v-24.64l-14.35,24.64h14.35Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function FiveIcon(props) {
  let stopOpacityFiveOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityFiveTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128.04 128.04"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityFiveOne}
          stopOpacityTwo={stopOpacityFiveTwo}
          number="five"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-five"
            d="m122.79,0H5.25C2.35,0,0,2.35,0,5.25v58.77c0,35.36,28.66,64.02,64.02,64.02s64.02-28.66,64.02-64.02V5.25c0-2.9-2.35-5.25-5.25-5.25Z"
          />
          <path
            className="main shaded"
            d="m122.79,0H5.25C2.35,0,0,2.35,0,5.25v58.77c0,35.36,28.66,64.02,64.02,64.02s64.02-28.66,64.02-64.02V5.25c0-2.9-2.35-5.25-5.25-5.25Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m82.77,45.17h-21.66l-1.08,6.89c1-.11,1.91-.21,2.74-.29s1.69-.12,2.57-.12c3.15,0,6.08.55,8.79,1.66,2.71,1.11,5.03,2.63,6.97,4.56,1.94,1.94,3.46,4.26,4.56,6.97,1.11,2.71,1.66,5.67,1.66,8.88,0,3.37-.62,6.42-1.87,9.13-1.24,2.71-3,5.02-5.27,6.93-2.27,1.91-5.03,3.37-8.3,4.4-3.26,1.02-6.89,1.54-10.87,1.54-3.76,0-7.34-.46-10.75-1.37s-6.6-2.31-9.58-4.19l2.41-15.27c2.77,2.38,5.59,4.19,8.46,5.43,2.88,1.24,5.61,1.87,8.21,1.87,3.32,0,5.95-.9,7.88-2.7,1.94-1.8,2.9-4.02,2.9-6.68,0-3.1-1.3-5.6-3.9-7.51-2.6-1.91-6-2.86-10.21-2.86-1.88,0-3.82.21-5.81.62-1.99.42-3.96,1.07-5.89,1.95l5.23-33.6h32.77v13.77Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function FiveIconMob(props) {
  let stopOpacityFiveOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityFiveTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128.04 128.04"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityFiveOne}
          stopOpacityTwo={stopOpacityFiveTwo}
          number="five-mob"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-five-mob"
            d="m122.79,0H5.25C2.35,0,0,2.35,0,5.25v58.77c0,35.36,28.66,64.02,64.02,64.02s64.02-28.66,64.02-64.02V5.25c0-2.9-2.35-5.25-5.25-5.25Z"
          />
          <path
            className="main shaded"
            d="m122.79,0H5.25C2.35,0,0,2.35,0,5.25v58.77c0,35.36,28.66,64.02,64.02,64.02s64.02-28.66,64.02-64.02V5.25c0-2.9-2.35-5.25-5.25-5.25Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m82.77,45.17h-21.66l-1.08,6.89c1-.11,1.91-.21,2.74-.29s1.69-.12,2.57-.12c3.15,0,6.08.55,8.79,1.66,2.71,1.11,5.03,2.63,6.97,4.56,1.94,1.94,3.46,4.26,4.56,6.97,1.11,2.71,1.66,5.67,1.66,8.88,0,3.37-.62,6.42-1.87,9.13-1.24,2.71-3,5.02-5.27,6.93-2.27,1.91-5.03,3.37-8.3,4.4-3.26,1.02-6.89,1.54-10.87,1.54-3.76,0-7.34-.46-10.75-1.37s-6.6-2.31-9.58-4.19l2.41-15.27c2.77,2.38,5.59,4.19,8.46,5.43,2.88,1.24,5.61,1.87,8.21,1.87,3.32,0,5.95-.9,7.88-2.7,1.94-1.8,2.9-4.02,2.9-6.68,0-3.1-1.3-5.6-3.9-7.51-2.6-1.91-6-2.86-10.21-2.86-1.88,0-3.82.21-5.81.62-1.99.42-3.96,1.07-5.89,1.95l5.23-33.6h32.77v13.77Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function SixIcon(props) {
  let stopOpacitySixOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacitySixTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128 144.46"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacitySixOne}
          stopOpacityTwo={stopOpacitySixTwo}
          number="six"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-six"
            d="m58.92,143.19L5.08,112.12C2.03,110.22.12,106.91,0,103.32v-62.17c.12-3.6,2.03-6.9,5.08-8.8L58.92,1.27c3.17-1.69,6.98-1.69,10.16,0l53.84,31.07c3.06,1.9,4.96,5.21,5.08,8.8v62.17c-.12,3.6-2.03,6.9-5.08,8.8l-53.84,31.07c-3.17,1.69-6.98,1.69-10.16,0Z"
          />
          <path
            className="main shaded"
            d="m58.92,143.19L5.08,112.12C2.03,110.22.12,106.91,0,103.32v-62.17c.12-3.6,2.03-6.9,5.08-8.8L58.92,1.27c3.17-1.69,6.98-1.69,10.16,0l53.84,31.07c3.06,1.9,4.96,5.21,5.08,8.8v62.17c-.12,3.6-2.03,6.9-5.08,8.8l-53.84,31.07c-3.17,1.69-6.98,1.69-10.16,0Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m80.47,40.08l-17.76,20.41h.33c1.55-.94,2.82-1.51,3.82-1.7,1-.19,1.88-.29,2.66-.29,3.04,0,5.84.58,8.38,1.74,2.54,1.16,4.76,2.75,6.64,4.77,1.88,2.02,3.35,4.38,4.4,7.09,1.05,2.71,1.58,5.61,1.58,8.71,0,3.32-.61,6.4-1.83,9.25-1.22,2.85-2.97,5.34-5.27,7.47-2.3,2.13-5.08,3.8-8.34,5.02-3.26,1.22-6.94,1.83-11.04,1.83s-7.85-.61-11.12-1.83c-3.26-1.22-6.04-2.88-8.34-4.98-2.3-2.1-4.05-4.55-5.27-7.34-1.22-2.79-1.83-5.77-1.83-8.92,0-3.54.79-7.37,2.36-11.49,1.58-4.12,4-8.17,7.26-12.16l14.52-17.59h18.83Zm-26.88,41.07c0,1.44.28,2.78.83,4.02.55,1.24,1.3,2.34,2.24,3.28.94.94,2.03,1.69,3.28,2.24,1.24.55,2.59.83,4.02.83s2.78-.28,4.02-.83c1.24-.55,2.34-1.3,3.28-2.24s1.69-2.03,2.24-3.28c.55-1.24.83-2.59.83-4.02s-.28-2.78-.83-4.02c-.55-1.24-1.3-2.34-2.24-3.28-.94-.94-2.03-1.69-3.28-2.24-1.24-.55-2.59-.83-4.02-.83s-2.78.28-4.02.83c-1.24.55-2.34,1.3-3.28,2.24s-1.69,2.03-2.24,3.28c-.55,1.24-.83,2.59-.83,4.02Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function SixIconMob(props) {
  let stopOpacitySixOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacitySixTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128 144.46"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacitySixOne}
          stopOpacityTwo={stopOpacitySixTwo}
          number="six-mob"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-six-mob"
            d="m58.92,143.19L5.08,112.12C2.03,110.22.12,106.91,0,103.32v-62.17c.12-3.6,2.03-6.9,5.08-8.8L58.92,1.27c3.17-1.69,6.98-1.69,10.16,0l53.84,31.07c3.06,1.9,4.96,5.21,5.08,8.8v62.17c-.12,3.6-2.03,6.9-5.08,8.8l-53.84,31.07c-3.17,1.69-6.98,1.69-10.16,0Z"
          />
          <path
            className="main shaded"
            d="m58.92,143.19L5.08,112.12C2.03,110.22.12,106.91,0,103.32v-62.17c.12-3.6,2.03-6.9,5.08-8.8L58.92,1.27c3.17-1.69,6.98-1.69,10.16,0l53.84,31.07c3.06,1.9,4.96,5.21,5.08,8.8v62.17c-.12,3.6-2.03,6.9-5.08,8.8l-53.84,31.07c-3.17,1.69-6.98,1.69-10.16,0Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m80.47,40.08l-17.76,20.41h.33c1.55-.94,2.82-1.51,3.82-1.7,1-.19,1.88-.29,2.66-.29,3.04,0,5.84.58,8.38,1.74,2.54,1.16,4.76,2.75,6.64,4.77,1.88,2.02,3.35,4.38,4.4,7.09,1.05,2.71,1.58,5.61,1.58,8.71,0,3.32-.61,6.4-1.83,9.25-1.22,2.85-2.97,5.34-5.27,7.47-2.3,2.13-5.08,3.8-8.34,5.02-3.26,1.22-6.94,1.83-11.04,1.83s-7.85-.61-11.12-1.83c-3.26-1.22-6.04-2.88-8.34-4.98-2.3-2.1-4.05-4.55-5.27-7.34-1.22-2.79-1.83-5.77-1.83-8.92,0-3.54.79-7.37,2.36-11.49,1.58-4.12,4-8.17,7.26-12.16l14.52-17.59h18.83Zm-26.88,41.07c0,1.44.28,2.78.83,4.02.55,1.24,1.3,2.34,2.24,3.28.94.94,2.03,1.69,3.28,2.24,1.24.55,2.59.83,4.02.83s2.78-.28,4.02-.83c1.24-.55,2.34-1.3,3.28-2.24s1.69-2.03,2.24-3.28c.55-1.24.83-2.59.83-4.02s-.28-2.78-.83-4.02c-.55-1.24-1.3-2.34-2.24-3.28-.94-.94-2.03-1.69-3.28-2.24-1.24-.55-2.59-.83-4.02-.83s-2.78.28-4.02.83c-1.24.55-2.34,1.3-3.28,2.24s-1.69,2.03-2.24,3.28c-.55,1.24-.83,2.59-.83,4.02Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function SevenIcon(props) {
  let stopOpacitySevenOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacitySevenTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128 128"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacitySevenOne}
          stopOpacityTwo={stopOpacitySevenTwo}
          number="seven"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-seven"
            d="m128,40h0C128,17.91,110.09,0,88,0h-47.21C18.36,0-.43,18.36,0,40.79c.15,7.57,2.4,14.62,6.19,20.6,1.01,1.59,1.01,3.63,0,5.22C2.41,72.59.16,79.64,0,87.2c-.44,22.44,18.34,40.8,40.78,40.8h47.21c22.09,0,40-17.91,40-40h0s0,0,0,0v-48Z"
          />
          <path
            className="main shaded"
            d="m128,40h0C128,17.91,110.09,0,88,0h-47.21C18.36,0-.43,18.36,0,40.79c.15,7.57,2.4,14.62,6.19,20.6,1.01,1.59,1.01,3.63,0,5.22C2.41,72.59.16,79.64,0,87.2c-.44,22.44,18.34,40.8,40.78,40.8h47.21c22.09,0,40-17.91,40-40h0s0,0,0,0v-48Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m68.06,46.6h-26.14v-13.77h51.36l-35.84,62.56h-17.92l28.54-48.79Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function SevenIconMob(props) {
  let stopOpacitySevenOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacitySevenTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128 128"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacitySevenOne}
          stopOpacityTwo={stopOpacitySevenTwo}
          number="seven-mob"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-seven-mob"
            d="m128,40h0C128,17.91,110.09,0,88,0h-47.21C18.36,0-.43,18.36,0,40.79c.15,7.57,2.4,14.62,6.19,20.6,1.01,1.59,1.01,3.63,0,5.22C2.41,72.59.16,79.64,0,87.2c-.44,22.44,18.34,40.8,40.78,40.8h47.21c22.09,0,40-17.91,40-40h0s0,0,0,0v-48Z"
          />
          <path
            className="main shaded"
            d="m128,40h0C128,17.91,110.09,0,88,0h-47.21C18.36,0-.43,18.36,0,40.79c.15,7.57,2.4,14.62,6.19,20.6,1.01,1.59,1.01,3.63,0,5.22C2.41,72.59.16,79.64,0,87.2c-.44,22.44,18.34,40.8,40.78,40.8h47.21c22.09,0,40-17.91,40-40h0s0,0,0,0v-48Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m68.06,46.6h-26.14v-13.77h51.36l-35.84,62.56h-17.92l28.54-48.79Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function EightIcon(props) {
  let stopOpacityEightOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityEightTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 134.33 134.33"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityEightOne}
          stopOpacityTwo={stopOpacityEightTwo}
          number="eight"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-eight"
            d="m133.57,70.99l-16.74,40.42c-1.01,2.45-2.96,4.4-5.41,5.41l-40.42,16.74c-2.45,1.01-5.2,1.01-7.65,0l-40.42-16.74c-2.45-1.01-4.4-2.96-5.41-5.41L.76,70.99c-1.01-2.45-1.01-5.2,0-7.65L17.5,22.92c1.01-2.45,2.96-4.4,5.41-5.41L63.34.76c2.45-1.01,5.2-1.01,7.65,0l40.42,16.74c2.45,1.01,4.4,2.96,5.41,5.41l16.74,40.42c1.01,2.45,1.01,5.2,0,7.65Z"
          />
          <path
            className="main shaded"
            d="m133.57,70.99l-16.74,40.42c-1.01,2.45-2.96,4.4-5.41,5.41l-40.42,16.74c-2.45,1.01-5.2,1.01-7.65,0l-40.42-16.74c-2.45-1.01-4.4-2.96-5.41-5.41L.76,70.99c-1.01-2.45-1.01-5.2,0-7.65L17.5,22.92c1.01-2.45,2.96-4.4,5.41-5.41L63.34.76c2.45-1.01,5.2-1.01,7.65,0l40.42,16.74c2.45,1.01,4.4,2.96,5.41,5.41l16.74,40.42c1.01,2.45,1.01,5.2,0,7.65Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m55.63,65.47c-6.53-2.71-9.79-7.3-9.79-13.77,0-2.66.52-5.05,1.58-7.18,1.05-2.13,2.5-3.97,4.36-5.52,1.85-1.55,4.09-2.74,6.72-3.57,2.63-.83,5.52-1.24,8.67-1.24s6.04.41,8.67,1.24c2.63.83,4.87,2.02,6.72,3.57,1.85,1.55,3.3,3.39,4.36,5.52,1.05,2.13,1.58,4.52,1.58,7.18,0,1.66-.17,3.14-.5,4.44-.33,1.3-.9,2.49-1.7,3.57-.8,1.08-1.85,2.09-3.15,3.03-1.3.94-2.92,1.85-4.85,2.74,8.52,3.32,12.78,8.68,12.78,16.1,0,2.66-.6,5.12-1.78,7.38-1.19,2.27-2.85,4.23-4.98,5.89-2.13,1.66-4.65,2.96-7.55,3.9s-6.1,1.41-9.58,1.41-6.51-.46-9.42-1.37-5.43-2.2-7.59-3.86-3.85-3.62-5.06-5.89c-1.22-2.27-1.83-4.76-1.83-7.47,0-7.58,4.12-12.94,12.36-16.1Zm4.07,14.11c0,1.05.19,2.05.58,2.99.39.94.91,1.76,1.58,2.45.66.69,1.45,1.24,2.36,1.66.91.41,1.89.62,2.95.62,1,0,1.95-.21,2.86-.62.91-.41,1.71-.97,2.41-1.66.69-.69,1.23-1.49,1.62-2.41.39-.91.58-1.89.58-2.95,0-2.1-.73-3.89-2.2-5.35-1.47-1.46-3.22-2.2-5.27-2.2s-3.87.73-5.31,2.2c-1.44,1.47-2.16,3.22-2.16,5.27Zm.58-27.71c0,1.94.66,3.58,1.99,4.94,1.33,1.36,2.96,2.03,4.9,2.03,1,0,1.91-.19,2.74-.58.83-.39,1.55-.9,2.16-1.54.61-.64,1.09-1.37,1.45-2.2.36-.83.54-1.69.54-2.57,0-1.88-.66-3.5-1.99-4.85-1.33-1.35-2.96-2.03-4.9-2.03s-3.57.66-4.9,1.99-1.99,2.93-1.99,4.81Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function EightIconMob(props) {
  let stopOpacityEightOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityEightTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 134.33 134.33"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityEightOne}
          stopOpacityTwo={stopOpacityEightTwo}
          number="eight-mob"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-eight-mob"
            d="m133.57,70.99l-16.74,40.42c-1.01,2.45-2.96,4.4-5.41,5.41l-40.42,16.74c-2.45,1.01-5.2,1.01-7.65,0l-40.42-16.74c-2.45-1.01-4.4-2.96-5.41-5.41L.76,70.99c-1.01-2.45-1.01-5.2,0-7.65L17.5,22.92c1.01-2.45,2.96-4.4,5.41-5.41L63.34.76c2.45-1.01,5.2-1.01,7.65,0l40.42,16.74c2.45,1.01,4.4,2.96,5.41,5.41l16.74,40.42c1.01,2.45,1.01,5.2,0,7.65Z"
          />
          <path
            className="main shaded"
            d="m133.57,70.99l-16.74,40.42c-1.01,2.45-2.96,4.4-5.41,5.41l-40.42,16.74c-2.45,1.01-5.2,1.01-7.65,0l-40.42-16.74c-2.45-1.01-4.4-2.96-5.41-5.41L.76,70.99c-1.01-2.45-1.01-5.2,0-7.65L17.5,22.92c1.01-2.45,2.96-4.4,5.41-5.41L63.34.76c2.45-1.01,5.2-1.01,7.65,0l40.42,16.74c2.45,1.01,4.4,2.96,5.41,5.41l16.74,40.42c1.01,2.45,1.01,5.2,0,7.65Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m55.63,65.47c-6.53-2.71-9.79-7.3-9.79-13.77,0-2.66.52-5.05,1.58-7.18,1.05-2.13,2.5-3.97,4.36-5.52,1.85-1.55,4.09-2.74,6.72-3.57,2.63-.83,5.52-1.24,8.67-1.24s6.04.41,8.67,1.24c2.63.83,4.87,2.02,6.72,3.57,1.85,1.55,3.3,3.39,4.36,5.52,1.05,2.13,1.58,4.52,1.58,7.18,0,1.66-.17,3.14-.5,4.44-.33,1.3-.9,2.49-1.7,3.57-.8,1.08-1.85,2.09-3.15,3.03-1.3.94-2.92,1.85-4.85,2.74,8.52,3.32,12.78,8.68,12.78,16.1,0,2.66-.6,5.12-1.78,7.38-1.19,2.27-2.85,4.23-4.98,5.89-2.13,1.66-4.65,2.96-7.55,3.9s-6.1,1.41-9.58,1.41-6.51-.46-9.42-1.37-5.43-2.2-7.59-3.86-3.85-3.62-5.06-5.89c-1.22-2.27-1.83-4.76-1.83-7.47,0-7.58,4.12-12.94,12.36-16.1Zm4.07,14.11c0,1.05.19,2.05.58,2.99.39.94.91,1.76,1.58,2.45.66.69,1.45,1.24,2.36,1.66.91.41,1.89.62,2.95.62,1,0,1.95-.21,2.86-.62.91-.41,1.71-.97,2.41-1.66.69-.69,1.23-1.49,1.62-2.41.39-.91.58-1.89.58-2.95,0-2.1-.73-3.89-2.2-5.35-1.47-1.46-3.22-2.2-5.27-2.2s-3.87.73-5.31,2.2c-1.44,1.47-2.16,3.22-2.16,5.27Zm.58-27.71c0,1.94.66,3.58,1.99,4.94,1.33,1.36,2.96,2.03,4.9,2.03,1,0,1.91-.19,2.74-.58.83-.39,1.55-.9,2.16-1.54.61-.64,1.09-1.37,1.45-2.2.36-.83.54-1.69.54-2.57,0-1.88-.66-3.5-1.99-4.85-1.33-1.35-2.96-2.03-4.9-2.03s-3.57.66-4.9,1.99-1.99,2.93-1.99,4.81Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function NineIcon(props) {
  let stopOpacityNineOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityNineTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 132 127.04"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityNineOne}
          stopOpacityTwo={stopOpacityNineTwo}
          number="nine"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-nine"
            d="m124.98,44.35c-2.1-6.46-1.67-14.26-5.58-19.63-3.95-5.43-11.53-7.42-16.96-11.37-5.37-3.91-9.59-10.53-16.04-12.62-6.23-2.02-13.5.79-20.4.79s-14.17-2.81-20.4-.79c-6.46,2.1-10.67,8.71-16.04,12.62-5.43,3.95-13.01,5.94-16.96,11.37-3.91,5.37-3.49,13.18-5.58,19.63-2.02,6.23-7.02,12.26-7.02,19.17s5,12.94,7.02,19.17c2.1,6.46,1.67,14.26,5.58,19.63,3.95,5.43,11.53,7.42,16.96,11.37,5.37,3.91,9.59,10.53,16.04,12.62,6.23,2.02,13.5-.79,20.4-.79s14.17,2.81,20.4.79c6.46-2.1,10.67-8.71,16.04-12.62,5.43-3.95,13-5.94,16.96-11.37,3.91-5.37,3.49-13.18,5.58-19.63,2.02-6.23,7.02-12.26,7.02-19.17s-5-12.94-7.02-19.17Z"
          />
          <path
            className="main shaded"
            d="m124.98,44.35c-2.1-6.46-1.67-14.26-5.58-19.63-3.95-5.43-11.53-7.42-16.96-11.37-5.37-3.91-9.59-10.53-16.04-12.62-6.23-2.02-13.5.79-20.4.79s-14.17-2.81-20.4-.79c-6.46,2.1-10.67,8.71-16.04,12.62-5.43,3.95-13.01,5.94-16.96,11.37-3.91,5.37-3.49,13.18-5.58,19.63-2.02,6.23-7.02,12.26-7.02,19.17s5,12.94,7.02,19.17c2.1,6.46,1.67,14.26,5.58,19.63,3.95,5.43,11.53,7.42,16.96,11.37,5.37,3.91,9.59,10.53,16.04,12.62,6.23,2.02,13.5-.79,20.4-.79s14.17,2.81,20.4.79c6.46-2.1,10.67-8.71,16.04-12.62,5.43-3.95,13-5.94,16.96-11.37,3.91-5.37,3.49-13.18,5.58-19.63,2.02-6.23,7.02-12.26,7.02-19.17s-5-12.94-7.02-19.17Z"
          />
          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m49.53,95.67l17.76-20.41h-.33c-1.55.94-2.82,1.51-3.82,1.7-1,.19-1.88.29-2.65.29-3.04,0-5.85-.58-8.42-1.74-2.57-1.16-4.79-2.75-6.64-4.77-1.85-2.02-3.31-4.38-4.36-7.09-1.05-2.71-1.58-5.61-1.58-8.71,0-3.32.61-6.4,1.83-9.25,1.22-2.85,2.97-5.34,5.27-7.47,2.29-2.13,5.07-3.8,8.34-5.02,3.26-1.22,6.94-1.83,11.04-1.83s7.85.61,11.12,1.83c3.26,1.22,6.04,2.88,8.34,4.98,2.29,2.1,4.05,4.55,5.27,7.34,1.22,2.79,1.83,5.77,1.83,8.92,0,3.54-.79,7.37-2.36,11.49-1.58,4.12-4,8.17-7.26,12.16l-14.52,17.59h-18.83Zm26.88-41.07c0-1.44-.28-2.78-.83-4.02-.55-1.24-1.3-2.34-2.24-3.28-.94-.94-2.03-1.69-3.28-2.24-1.25-.55-2.59-.83-4.02-.83s-2.78.28-4.02.83c-1.24.55-2.34,1.3-3.28,2.24-.94.94-1.69,2.03-2.24,3.28-.55,1.24-.83,2.59-.83,4.02s.28,2.78.83,4.02c.55,1.24,1.3,2.34,2.24,3.28.94.94,2.03,1.69,3.28,2.24,1.25.55,2.59.83,4.02.83s2.78-.28,4.02-.83c1.24-.55,2.34-1.3,3.28-2.24.94-.94,1.69-2.03,2.24-3.28.55-1.24.83-2.59.83-4.02Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function NineIconMob(props) {
  let stopOpacityNineOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityNineTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 132 127.04"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityNineOne}
          stopOpacityTwo={stopOpacityNineTwo}
          number="nine-mob"
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-nine-mob"
            d="m124.98,44.35c-2.1-6.46-1.67-14.26-5.58-19.63-3.95-5.43-11.53-7.42-16.96-11.37-5.37-3.91-9.59-10.53-16.04-12.62-6.23-2.02-13.5.79-20.4.79s-14.17-2.81-20.4-.79c-6.46,2.1-10.67,8.71-16.04,12.62-5.43,3.95-13.01,5.94-16.96,11.37-3.91,5.37-3.49,13.18-5.58,19.63-2.02,6.23-7.02,12.26-7.02,19.17s5,12.94,7.02,19.17c2.1,6.46,1.67,14.26,5.58,19.63,3.95,5.43,11.53,7.42,16.96,11.37,5.37,3.91,9.59,10.53,16.04,12.62,6.23,2.02,13.5-.79,20.4-.79s14.17,2.81,20.4.79c6.46-2.1,10.67-8.71,16.04-12.62,5.43-3.95,13-5.94,16.96-11.37,3.91-5.37,3.49-13.18,5.58-19.63,2.02-6.23,7.02-12.26,7.02-19.17s-5-12.94-7.02-19.17Z"
          />
          <path
            className="main shaded"
            d="m124.98,44.35c-2.1-6.46-1.67-14.26-5.58-19.63-3.95-5.43-11.53-7.42-16.96-11.37-5.37-3.91-9.59-10.53-16.04-12.62-6.23-2.02-13.5.79-20.4.79s-14.17-2.81-20.4-.79c-6.46,2.1-10.67,8.71-16.04,12.62-5.43,3.95-13.01,5.94-16.96,11.37-3.91,5.37-3.49,13.18-5.58,19.63-2.02,6.23-7.02,12.26-7.02,19.17s5,12.94,7.02,19.17c2.1,6.46,1.67,14.26,5.58,19.63,3.95,5.43,11.53,7.42,16.96,11.37,5.37,3.91,9.59,10.53,16.04,12.62,6.23,2.02,13.5-.79,20.4-.79s14.17,2.81,20.4.79c6.46-2.1,10.67-8.71,16.04-12.62,5.43-3.95,13-5.94,16.96-11.37,3.91-5.37,3.49-13.18,5.58-19.63,2.02-6.23,7.02-12.26,7.02-19.17s-5-12.94-7.02-19.17Z"
          />

          {!text && (
            <path
              style={
                props.opacity <= 0.5 ? { fill: "var(--nwd-icon-detail-low, #004a22)" } : { fill: "var(--nwd-icon-detail-high, #e2dfcf)" }
              }
              className="accent"
              d="m49.53,95.67l17.76-20.41h-.33c-1.55.94-2.82,1.51-3.82,1.7-1,.19-1.88.29-2.65.29-3.04,0-5.85-.58-8.42-1.74-2.57-1.16-4.79-2.75-6.64-4.77-1.85-2.02-3.31-4.38-4.36-7.09-1.05-2.71-1.58-5.61-1.58-8.71,0-3.32.61-6.4,1.83-9.25,1.22-2.85,2.97-5.34,5.27-7.47,2.29-2.13,5.07-3.8,8.34-5.02,3.26-1.22,6.94-1.83,11.04-1.83s7.85.61,11.12,1.83c3.26,1.22,6.04,2.88,8.34,4.98,2.29,2.1,4.05,4.55,5.27,7.34,1.22,2.79,1.83,5.77,1.83,8.92,0,3.54-.79,7.37-2.36,11.49-1.58,4.12-4,8.17-7.26,12.16l-14.52,17.59h-18.83Zm26.88-41.07c0-1.44-.28-2.78-.83-4.02-.55-1.24-1.3-2.34-2.24-3.28-.94-.94-2.03-1.69-3.28-2.24-1.25-.55-2.59-.83-4.02-.83s-2.78.28-4.02.83c-1.24.55-2.34,1.3-3.28,2.24-.94.94-1.69,2.03-2.24,3.28-.55,1.24-.83,2.59-.83,4.02s.28,2.78.83,4.02c.55,1.24,1.3,2.34,2.24,3.28.94.94,2.03,1.69,3.28,2.24,1.25.55,2.59.83,4.02.83s2.78-.28,4.02-.83c1.24-.55,2.34-1.3,3.28-2.24.94-.94,1.69-2.03,2.24-3.28.55-1.24.83-2.59.83-4.02Z"
            />
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function TenIcon(props) {
  let stopOpacityTenOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityTenTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128 128"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityTenOne}
          stopOpacityTwo={stopOpacityTenTwo}
          number="ten"
          x1="0%"
          y1="100%"
          x2="0%"
          y2="0%"
        />
        <g id="Creative">
          <path
            className="main shaded "
            d="m5,0h93C114.56,0,128,13.44,128,30v93c0,2.76-2.24,5-5,5H30C13.44,128,0,114.56,0,98V5C0,2.24,2.24,0,5,0Z"
            transform="translate(128 128) rotate(180)"
          />
          <path
            className="gradient-fill-ten"
            d="m5,0h93C114.56,0,128,13.44,128,30v93c0,2.76-2.24,5-5,5H30C13.44,128,0,114.56,0,98V5C0,2.24,2.24,0,5,0Z"
            transform="translate(128 128) rotate(180)"
          />
          {!text && (
            <g>
              <path
                style={
                  props.opacity <= 0.5
                    ? { fill: "#004a22" }
                    : { fill: "#e2dfcf" }
                }
                className="accent"
                d="m28.44,46.53h-9.13v-13.77h25.39v62.56h-16.26v-48.79Z"
              />
              <path
                style={
                  props.opacity <= 0.5
                    ? { fill: "#004a22" }
                    : { fill: "#e2dfcf" }
                }
                className="accent"
                d="m55.67,63.96c0-4.98.65-9.5,1.95-13.57,1.3-4.07,3.12-7.54,5.48-10.41,2.35-2.88,5.14-5.1,8.38-6.68,3.24-1.58,6.82-2.36,10.75-2.36s7.44.79,10.7,2.36c3.26,1.58,6.06,3.8,8.38,6.68,2.32,2.88,4.13,6.35,5.43,10.41,1.3,4.07,1.95,8.59,1.95,13.57s-.65,9.5-1.95,13.57c-1.3,4.07-3.11,7.55-5.43,10.45-2.32,2.9-5.12,5.14-8.38,6.72-3.26,1.58-6.83,2.36-10.7,2.36s-7.51-.79-10.75-2.36c-3.24-1.58-6.03-3.82-8.38-6.72-2.35-2.9-4.18-6.39-5.48-10.45-1.3-4.07-1.95-8.59-1.95-13.57Zm16.1,0c0,2.77.25,5.28.75,7.55.5,2.27,1.2,4.23,2.12,5.89.91,1.66,2,2.95,3.28,3.86,1.27.91,2.71,1.37,4.31,1.37s2.97-.46,4.27-1.37c1.3-.91,2.39-2.2,3.28-3.86.88-1.66,1.58-3.62,2.07-5.89.5-2.27.75-4.78.75-7.55s-.25-5.21-.75-7.51c-.5-2.29-1.19-4.26-2.07-5.89-.89-1.63-1.98-2.9-3.28-3.82-1.3-.91-2.73-1.37-4.27-1.37s-3.04.46-4.31,1.37c-1.27.91-2.37,2.19-3.28,3.82-.91,1.63-1.62,3.6-2.12,5.89-.5,2.3-.75,4.8-.75,7.51Z"
              />
            </g>
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function TenIconMob(props) {
  let stopOpacityTenOne =
    props.opacity === 0 ? "0%" : props.opacity && props.opacity * 100 + "%";
  let stopOpacityTenTwo =
    props.opacity === 0
      ? "100%"
      : props.opacity && 100 - props.opacity * 100 + "%";

  let text = props.text && props.text.toUpperCase();

  return (
    <>
      <svg
        id="Layer_2"
        className="jordan"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128 128"
        style={{ opacity: props.op }}
      >
        <DefsFunc
          stopOpacityOne={stopOpacityTenOne}
          stopOpacityTwo={stopOpacityTenTwo}
          number="ten-mob"
          x1="0%"
          y1="100%"
          x2="0%"
          y2="0%"
        />
        <g id="Creative">
          <path
            className="gradient-fill-ten-mob"
            d="m5,0h93C114.56,0,128,13.44,128,30v93c0,2.76-2.24,5-5,5H30C13.44,128,0,114.56,0,98V5C0,2.24,2.24,0,5,0Z"
            transform="translate(128 128) rotate(180)"
          />
          <path
            className="main shaded"
            d="m5,0h93C114.56,0,128,13.44,128,30v93c0,2.76-2.24,5-5,5H30C13.44,128,0,114.56,0,98V5C0,2.24,2.24,0,5,0Z"
            transform="translate(128 128) rotate(180)"
          />
          {!text && (
            <g>
              <path
                style={
                  props.opacity <= 0.5
                    ? { fill: "#004a22" }
                    : { fill: "#e2dfcf" }
                }
                className="accent"
                d="m28.44,46.53h-9.13v-13.77h25.39v62.56h-16.26v-48.79Z"
              />
              <path
                style={
                  props.opacity <= 0.5
                    ? { fill: "#004a22" }
                    : { fill: "#e2dfcf" }
                }
                className="accent"
                d="m55.67,63.96c0-4.98.65-9.5,1.95-13.57,1.3-4.07,3.12-7.54,5.48-10.41,2.35-2.88,5.14-5.1,8.38-6.68,3.24-1.58,6.82-2.36,10.75-2.36s7.44.79,10.7,2.36c3.26,1.58,6.06,3.8,8.38,6.68,2.32,2.88,4.13,6.35,5.43,10.41,1.3,4.07,1.95,8.59,1.95,13.57s-.65,9.5-1.95,13.57c-1.3,4.07-3.11,7.55-5.43,10.45-2.32,2.9-5.12,5.14-8.38,6.72-3.26,1.58-6.83,2.36-10.7,2.36s-7.51-.79-10.75-2.36c-3.24-1.58-6.03-3.82-8.38-6.72-2.35-2.9-4.18-6.39-5.48-10.45-1.3-4.07-1.95-8.59-1.95-13.57Zm16.1,0c0,2.77.25,5.28.75,7.55.5,2.27,1.2,4.23,2.12,5.89.91,1.66,2,2.95,3.28,3.86,1.27.91,2.71,1.37,4.31,1.37s2.97-.46,4.27-1.37c1.3-.91,2.39-2.2,3.28-3.86.88-1.66,1.58-3.62,2.07-5.89.5-2.27.75-4.78.75-7.55s-.25-5.21-.75-7.51c-.5-2.29-1.19-4.26-2.07-5.89-.89-1.63-1.98-2.9-3.28-3.82-1.3-.91-2.73-1.37-4.27-1.37s-3.04.46-4.31,1.37c-1.27.91-2.37,2.19-3.28,3.82-.91,1.63-1.62,3.6-2.12,5.89-.5,2.3-.75,4.8-.75,7.51Z"
              />
            </g>
          )}
        </g>
      </svg>
      {text && (
        <strong
          className="icon--text"
          style={
            props.opacity < 0.5 ? { color: "var(--nwd-icon-detail-low, #004a22)" } : { color: "var(--nwd-icon-detail-high, #e2dfcf)" }
          }
        >
          {text}
        </strong>
      )}
    </>
  );
}

function PreviousDay(props) {
  return (
    <svg
      id="Layer_2"
      className="jordan"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128.15 128.15"
    >
      <g id="Creative">
        <g>
          <path
            className={props.landingpage ? "accent" : "main"}
            d="m128.15,64.07c0-5.61-12.12-11.44-23.74-15.74-.67-.25-.98-1.01-.68-1.65,5.18-11.26,9.63-23.95,5.66-27.92-3.97-3.97-16.66.48-27.92,5.66-.65.3-1.41-.02-1.65-.68-4.3-11.62-10.13-23.74-15.74-23.74s-11.44,12.12-15.74,23.74c-.25.67-1.01.98-1.65.68-11.26-5.18-23.95-9.63-27.92-5.66-3.97,3.97.48,16.66,5.66,27.92.3.65-.02,1.41-.68,1.65C12.12,52.63,0,58.46,0,64.07s12.12,11.44,23.74,15.74c.67.25.98,1,.68,1.65-5.18,11.26-9.63,23.95-5.66,27.92,3.97,3.97,16.66-.48,27.92-5.66.65-.3,1.41.02,1.65.68,4.3,11.62,10.13,23.74,15.74,23.74s11.44-12.12,15.74-23.74c.25-.67,1-.98,1.65-.68,11.26,5.18,23.95,9.63,27.92,5.66,3.97-3.97-.48-16.66-5.66-27.92-.3-.65.02-1.41.68-1.65,11.62-4.3,23.74-10.13,23.74-15.74Z"
          />
          <path
            className={props.landingpage ? "main" : "accent"}
            d="m64.07,11.59c-2.44,0-5.01,6.84-6.42,11.29-.59,1.85.8,3.74,2.74,3.74h7.35c1.94,0,3.33-1.89,2.74-3.74-1.41-4.45-3.98-11.29-6.42-11.29Z"
          />
          <path
            className={props.landingpage ? "main" : "accent"}
            d="m26.96,26.96c-1.73,1.73,1.29,8.38,3.44,12.52.89,1.72,3.21,2.08,4.58.7l5.2-5.2c1.37-1.37,1.02-3.69-.7-4.58-4.14-2.15-10.79-5.17-12.52-3.44Z"
          />
          <path
            className={props.landingpage ? "main" : "accent"}
            d="m11.59,64.07c0,2.44,6.84,5.01,11.29,6.42,1.85.59,3.74-.8,3.74-2.74v-7.35c0-1.94-1.89-3.33-3.74-2.74-4.45,1.41-11.29,3.98-11.29,6.42Z"
          />
          <path
            className={props.landingpage ? "main" : "accent"}
            d="m26.96,101.19c1.73,1.73,8.38-1.29,12.52-3.44,1.72-.89,2.08-3.21.7-4.58l-5.2-5.2c-1.37-1.37-3.69-1.02-4.58.7-2.15,4.14-5.17,10.79-3.44,12.52Z"
          />
          <path
            className={props.landingpage ? "main" : "accent"}
            d="m64.07,116.56c2.44,0,5.01-6.84,6.42-11.29.59-1.85-.8-3.74-2.74-3.74h-7.35c-1.94,0-3.33,1.89-2.74,3.74,1.41,4.45,3.98,11.29,6.42,11.29Z"
          />
          <path
            className={props.landingpage ? "main" : "accent"}
            d="m101.19,101.19c1.73-1.73-1.29-8.38-3.44-12.52-.89-1.72-3.21-2.08-4.58-.7l-5.2,5.2c-1.37,1.37-1.02,3.69.7,4.58,4.14,2.15,10.79,5.17,12.52,3.44Z"
          />
          <path
            className={props.landingpage ? "main" : "accent"}
            d="m116.56,64.07c0-2.44-6.84-5.01-11.29-6.42-1.85-.59-3.74.8-3.74,2.74v7.35c0,1.94,1.89,3.33,3.74,2.74,4.45-1.41,11.29-3.98,11.29-6.42Z"
          />
          <path
            className={props.landingpage ? "main" : "accent"}
            d="m101.19,26.96c-1.73-1.73-8.38,1.29-12.52,3.44-1.72.89-2.08,3.21-.7,4.58l5.2,5.2c1.37,1.37,3.69,1.02,4.58-.7,2.15-4.14,5.17-10.79,3.44-12.52Z"
          />
          <path
            className={props.landingpage ? "main" : "accent"}
            d="m64.07,94.27c-16.65,0-30.2-13.55-30.2-30.2s13.55-30.2,30.2-30.2,30.2,13.55,30.2,30.2-13.55,30.2-30.2,30.2Zm0-54.4c-13.34,0-24.2,10.86-24.2,24.2s10.86,24.2,24.2,24.2,24.2-10.86,24.2-24.2-10.86-24.2-24.2-24.2Z"
          />
        </g>
        <polygon
          className={props.landingpage ? "main" : "accent"}
          points="77.03 61.37 58.92 61.37 65.97 54.3 62.16 50.49 48.57 64.07 62.16 77.66 65.97 73.83 58.92 66.78 77.03 66.78 77.03 61.37"
        />
      </g>
    </svg>
  );
}

const IconWrapper = (props, children) => {
  return <div {...props}>{children}</div>;
};

export {
  CreateDayIcon,
  CreateDayIconV2,
  NameIcon,
  NameIconV2,
  NameIconV3,
  NameIconV4,
  DobIcon,
  ValuesIcon,
  MemoryIcon,
  VisionIcon,
  IkigaiIcon,
  QuoteIcon,
  QuoteIconV2,
  HideOverlayIcon,
  QuestionIcon,
  SaveIcon,
  YearIcon,
  WeekIcon,
  DiaryIcon,
  InsightsIcon,
  ProfileIcon,
  LoginIcon,
  LogoutIcon,
  RegisterIcon,
  TickIcon,
  VitIcon,
  OneIcon,
  OneIconMob,
  TwoIcon,
  TwoIconMob,
  ThreeIcon,
  ThreeIconMob,
  FourIcon,
  FourIconMob,
  FiveIcon,
  FiveIconMob,
  SixIcon,
  SixIconMob,
  SevenIcon,
  SevenIconMob,
  EightIcon,
  EightIconMob,
  NineIcon,
  NineIconMob,
  TenIcon,
  TenIconMob,
  PreviousDay,
  IconWrapper,
};
